webpackJsonp([2],{

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/newsbanner.d6d61a0.jpg";

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_About__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_ContactUs__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_ContactUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_ContactUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Products__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Products___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Products__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_ProductDetails__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_ProductDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_ProductDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_News__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_News___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_News__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Search__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_NewsDetails__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_NewsDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_NewsDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_JoinUs__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_JoinUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_JoinUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Elements__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_Elements__);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home___default.a
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_About___default.a
  }, {
    path: '/products',
    name: 'products',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Products___default.a
  }, {
    path: '/productDetails',
    name: 'productDetails',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_ProductDetails___default.a
  }, {
    path: '/news',

    name: 'news',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_News___default.a
  }, {
    path: '/newsDetails',
    name: 'newsDetails',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_NewsDetails___default.a
  }, {
    path: '/contact',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_ContactUs___default.a
  }, {
    path: '/joinUs',
    name: 'joinUs',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_JoinUs___default.a
  }, {
    path: '/elements',
    name: 'elements',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_Elements___default.a
  }, {
    path: '/search',

    name: 'search',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_Search___default.a
  }, {
    path: '/refresh',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(317)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '用于同路由刷新'
    }
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.name != 'home' && to.name != 'products' && to.name != 'productDetails' && to.name != 'fanMoney' && to.name != 'activity' && to.name != 'retrospect' && to.name != 'productionPart' && to.name != 'searchPost' && to.name != 'carSystem' && to.name != 'fmMoneyGoods') {
      window.scrollTo(0, 0);
    }
  }
}));

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */].Store({
  modules: {}
}));

/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  setLocalStore: function setLocalStore(name, content) {
    if (!name) return;
    if (typeof content !== 'string') {
      content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content);
    }
    window.localStorage.setItem(name, content);
  },

  getLocalStore: function getLocalStore(name) {
    if (!name) return;

    if (window.localStorage.getItem(name) != "undefined") {
      return window.localStorage.getItem(name);
    }
  },

  removeLocalStore: function removeLocalStore(name) {
    if (!name) return;
    window.localStorage.removeItem(name);
  },

  emptyLocalStorage: function emptyLocalStorage() {
    window.localStorage.clear();
  },

  setSessionStore: function setSessionStore(name, content) {
    if (!name) return;
    if (typeof content !== 'string') {
      content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content);
    }
    window.sessionStorage.setItem(name, content);
  },

  getSessionStore: function getSessionStore(name) {
    if (!name) return;
    return window.sessionStorage.getItem(name);
  },

  removeSessionStore: function removeSessionStore(name) {
    if (!name) return;
    window.sessionStorage.removeItem(name);
  },

  emptySessionStorage: function emptySessionStorage() {
    window.sessionStorage.clear();
  }
});

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(303),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export DefaultMagicKeysAliasMap */
/* unused harmony export StorageSerializers */
/* unused harmony export TransitionPresets */
/* unused harmony export asyncComputed */
/* unused harmony export breakpointsAntDesign */
/* unused harmony export breakpointsBootstrapV5 */
/* unused harmony export breakpointsMasterCss */
/* unused harmony export breakpointsQuasar */
/* unused harmony export breakpointsSematic */
/* unused harmony export breakpointsTailwind */
/* unused harmony export breakpointsVuetify */
/* unused harmony export cloneFnJSON */
/* unused harmony export computedAsync */
/* unused harmony export computedInject */
/* unused harmony export createFetch */
/* unused harmony export createReusableTemplate */
/* unused harmony export createTemplatePromise */
/* unused harmony export createUnrefFn */
/* unused harmony export customStorageEventName */
/* unused harmony export defaultDocument */
/* unused harmony export defaultLocation */
/* unused harmony export defaultNavigator */
/* unused harmony export defaultWindow */
/* unused harmony export executeTransition */
/* unused harmony export formatTimeAgo */
/* unused harmony export getSSRHandler */
/* unused harmony export mapGamepadToXbox360Controller */
/* unused harmony export onClickOutside */
/* unused harmony export onKeyDown */
/* unused harmony export onKeyPressed */
/* unused harmony export onKeyStroke */
/* unused harmony export onKeyUp */
/* unused harmony export onLongPress */
/* unused harmony export onStartTyping */
/* unused harmony export setSSRHandler */
/* unused harmony export templateRef */
/* unused harmony export unrefElement */
/* unused harmony export useActiveElement */
/* unused harmony export useAnimate */
/* unused harmony export useAsyncQueue */
/* unused harmony export useAsyncState */
/* unused harmony export useBase64 */
/* unused harmony export useBattery */
/* unused harmony export useBluetooth */
/* unused harmony export useBreakpoints */
/* unused harmony export useBroadcastChannel */
/* unused harmony export useBrowserLocation */
/* unused harmony export useCached */
/* unused harmony export useClipboard */
/* unused harmony export useCloned */
/* unused harmony export useColorMode */
/* unused harmony export useConfirmDialog */
/* unused harmony export useCssVar */
/* unused harmony export useCurrentElement */
/* unused harmony export useCycleList */
/* unused harmony export useDark */
/* unused harmony export useDebouncedRefHistory */
/* unused harmony export useDeviceMotion */
/* unused harmony export useDeviceOrientation */
/* unused harmony export useDevicePixelRatio */
/* unused harmony export useDevicesList */
/* unused harmony export useDisplayMedia */
/* unused harmony export useDocumentVisibility */
/* unused harmony export useDraggable */
/* unused harmony export useDropZone */
/* unused harmony export useElementBounding */
/* unused harmony export useElementByPoint */
/* unused harmony export useElementHover */
/* unused harmony export useElementSize */
/* unused harmony export useElementVisibility */
/* unused harmony export useEventBus */
/* unused harmony export useEventListener */
/* unused harmony export useEventSource */
/* unused harmony export useEyeDropper */
/* unused harmony export useFavicon */
/* unused harmony export useFetch */
/* unused harmony export useFileDialog */
/* unused harmony export useFileSystemAccess */
/* unused harmony export useFocus */
/* unused harmony export useFocusWithin */
/* unused harmony export useFps */
/* unused harmony export useFullscreen */
/* unused harmony export useGamepad */
/* unused harmony export useGeolocation */
/* unused harmony export useIdle */
/* unused harmony export useImage */
/* unused harmony export useInfiniteScroll */
/* unused harmony export useIntersectionObserver */
/* unused harmony export useKeyModifier */
/* unused harmony export useLocalStorage */
/* unused harmony export useMagicKeys */
/* unused harmony export useManualRefHistory */
/* unused harmony export useMediaControls */
/* unused harmony export useMediaQuery */
/* unused harmony export useMemoize */
/* unused harmony export useMemory */
/* unused harmony export useMounted */
/* unused harmony export useMouse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useMouseInElement; });
/* unused harmony export useMousePressed */
/* unused harmony export useMutationObserver */
/* unused harmony export useNavigatorLanguage */
/* unused harmony export useNetwork */
/* unused harmony export useNow */
/* unused harmony export useObjectUrl */
/* unused harmony export useOffsetPagination */
/* unused harmony export useOnline */
/* unused harmony export usePageLeave */
/* unused harmony export useParallax */
/* unused harmony export useParentElement */
/* unused harmony export usePerformanceObserver */
/* unused harmony export usePermission */
/* unused harmony export usePointer */
/* unused harmony export usePointerLock */
/* unused harmony export usePointerSwipe */
/* unused harmony export usePreferredColorScheme */
/* unused harmony export usePreferredContrast */
/* unused harmony export usePreferredDark */
/* unused harmony export usePreferredLanguages */
/* unused harmony export usePreferredReducedMotion */
/* unused harmony export usePrevious */
/* unused harmony export useRafFn */
/* unused harmony export useRefHistory */
/* unused harmony export useResizeObserver */
/* unused harmony export useScreenOrientation */
/* unused harmony export useScreenSafeArea */
/* unused harmony export useScriptTag */
/* unused harmony export useScroll */
/* unused harmony export useScrollLock */
/* unused harmony export useSessionStorage */
/* unused harmony export useShare */
/* unused harmony export useSorted */
/* unused harmony export useSpeechRecognition */
/* unused harmony export useSpeechSynthesis */
/* unused harmony export useStepper */
/* unused harmony export useStorage */
/* unused harmony export useStorageAsync */
/* unused harmony export useStyleTag */
/* unused harmony export useSupported */
/* unused harmony export useSwipe */
/* unused harmony export useTemplateRefsList */
/* unused harmony export useTextDirection */
/* unused harmony export useTextSelection */
/* unused harmony export useTextareaAutosize */
/* unused harmony export useThrottledRefHistory */
/* unused harmony export useTimeAgo */
/* unused harmony export useTimeoutPoll */
/* unused harmony export useTimestamp */
/* unused harmony export useTitle */
/* unused harmony export useTransition */
/* unused harmony export useUrlSearchParams */
/* unused harmony export useUserMedia */
/* unused harmony export useVModel */
/* unused harmony export useVModels */
/* unused harmony export useVibrate */
/* unused harmony export useVirtualList */
/* unused harmony export useWakeLock */
/* unused harmony export useWebNotification */
/* unused harmony export useWebSocket */
/* unused harmony export useWebWorker */
/* unused harmony export useWebWorkerFn */
/* unused harmony export useWindowFocus */
/* unused harmony export useWindowScroll */
/* unused harmony export useWindowSize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_get__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_nan__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_map__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_demi__ = __webpack_require__(142);

























var loadImage = function () {
  var _ref67 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee27(options) {
    return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            return _context27.abrupt('return', new __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var img = new Image();
              var src = options.src,
                  srcset = options.srcset,
                  sizes = options.sizes,
                  clazz = options.class,
                  loading = options.loading,
                  crossorigin = options.crossorigin,
                  referrerPolicy = options.referrerPolicy;

              img.src = src;
              if (srcset) img.srcset = srcset;
              if (sizes) img.sizes = sizes;
              if (clazz) img.className = clazz;
              if (loading) img.loading = loading;
              if (crossorigin) img.crossOrigin = crossorigin;
              if (referrerPolicy) img.referrerPolicy = referrerPolicy;
              img.onload = function () {
                return resolve(img);
              };
              img.onerror = reject;
            }));

          case 1:
          case 'end':
            return _context27.stop();
        }
      }
    }, _callee27, this);
  }));

  return function loadImage(_x74) {
    return _ref67.apply(this, arguments);
  };
}();





function computedAsync(evaluationCallback, initialState, optionsOrRef) {
  var _this = this;

  var options = void 0;
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["a" /* isRef */])(optionsOrRef)) {
    options = {
      evaluating: optionsOrRef
    };
  } else {
    options = optionsOrRef || {};
  }
  var _options2 = options,
      _options2$lazy = _options2.lazy,
      lazy = _options2$lazy === undefined ? false : _options2$lazy,
      _options2$evaluating = _options2.evaluating,
      evaluating = _options2$evaluating === undefined ? void 0 : _options2$evaluating,
      _options2$shallow = _options2.shallow,
      shallow = _options2$shallow === undefined ? true : _options2$shallow,
      _options2$onError = _options2.onError,
      onError = _options2$onError === undefined ? __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */] : _options2$onError;

  var started = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(!lazy);
  var current = shallow ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(initialState) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(initialState);
  var counter = 0;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["d" /* watchEffect */])(function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee(onInvalidate) {
      var counterAtBeginning, hasFinished, result;
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (started.value) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              counter++;
              counterAtBeginning = counter;
              hasFinished = false;

              if (evaluating) {
                __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a.resolve().then(function () {
                  evaluating.value = true;
                });
              }
              _context.prev = 6;
              _context.next = 9;
              return evaluationCallback(function (cancelCallback) {
                onInvalidate(function () {
                  if (evaluating) evaluating.value = false;
                  if (!hasFinished) cancelCallback();
                });
              });

            case 9:
              result = _context.sent;

              if (counterAtBeginning === counter) current.value = result;
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](6);

              onError(_context.t0);

            case 16:
              _context.prev = 16;

              if (evaluating && counterAtBeginning === counter) evaluating.value = false;
              hasFinished = true;
              return _context.finish(16);

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[6, 13, 16, 20]]);
    }));

    return function (_x2) {
      return _ref.apply(this, arguments);
    };
  }());
  if (lazy) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
      started.value = true;
      return current.value;
    });
  } else {
    return current;
  }
}

function computedInject(key, options, defaultSource, treatDefaultAsFactory) {
  var source = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["f" /* inject */])(key);
  if (defaultSource) source = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["f" /* inject */])(key, defaultSource);
  if (treatDefaultAsFactory) source = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["f" /* inject */])(key, defaultSource, treatDefaultAsFactory);
  if (typeof options === "function") {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function (ctx) {
      return options(source, ctx);
    });
  } else {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])({
      get: function get(ctx) {
        return options.get(source, ctx);
      },
      set: options.set
    });
  }
}

var __defProp$q = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __defProps$d = __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$d = __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$t = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$t = Object.prototype.hasOwnProperty;
var __propIsEnum$t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$q = function __defNormalProp$q(obj, key, value) {
  return key in obj ? __defProp$q(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$q = function __spreadValues$q(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$t.call(b, prop)) __defNormalProp$q(a, prop, b[prop]);
  }if (__getOwnPropSymbols$t) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$t(b)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var prop = _step.value;

        if (__propIsEnum$t.call(b, prop)) __defNormalProp$q(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }return a;
};
var __spreadProps$d = function __spreadProps$d(a, b) {
  return __defProps$d(a, __getOwnPropDescs$d(b));
};
function createReusableTemplate() {
  if (!__WEBPACK_IMPORTED_MODULE_25_vue_demi__["g" /* isVue3 */] && !__WEBPACK_IMPORTED_MODULE_25_vue_demi__["h" /* version */].startsWith("2.7.")) {
    if (false) throw new Error("[VueUse] createReusableTemplate only works in Vue 2.7 or above.");
    return;
  }
  var render = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])();
  var define = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["i" /* defineComponent */])({
    setup: function setup(_, _ref2) {
      var slots = _ref2.slots;

      return function () {
        render.value = slots.default;
      };
    }
  });
  var reuse = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["i" /* defineComponent */])({
    inheritAttrs: false,
    setup: function setup(_, _ref3) {
      var attrs = _ref3.attrs,
          slots = _ref3.slots;

      return function () {
        var _a;
        if (!render.value && "production" !== "production") throw new Error("[VueUse] Failed to find the definition of reusable template");
        return (_a = render.value) == null ? void 0 : _a.call(render, __spreadProps$d(__spreadValues$q({}, attrs), { $slots: slots }));
      };
    }
  });
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["b" /* makeDestructurable */])({ define: define, reuse: reuse }, [define, reuse]);
}

function createTemplatePromise() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!__WEBPACK_IMPORTED_MODULE_25_vue_demi__["g" /* isVue3 */]) {
    if (false) throw new Error("[VueUse] createTemplatePromise only works in Vue 3 or above.");
    return;
  }
  var index = 0;
  var instances = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])([]);
  function create() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["j" /* shallowReactive */])({
      key: index++,
      args: args,
      promise: void 0,
      resolve: function resolve() {},
      reject: function reject() {},
      isResolving: false,
      options: options
    });
    instances.value.push(props);
    props.promise = new __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a(function (_resolve, _reject) {
      props.resolve = function (v) {
        props.isResolving = true;
        return _resolve(v);
      };
      props.reject = _reject;
    }).finally(function () {
      props.promise = void 0;
      var index2 = instances.value.indexOf(props);
      if (index2 !== -1) instances.value.splice(index2, 1);
    });
    return props.promise;
  }
  function start() {
    if (options.singleton && instances.value.length > 0) return instances.value[0].promise;
    return create.apply(undefined, arguments);
  }
  var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["i" /* defineComponent */])(function (_, _ref4) {
    var slots = _ref4.slots;

    var renderList = function renderList() {
      return instances.value.map(function (props) {
        var _a;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["k" /* h */])(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["l" /* Fragment */], { key: props.key }, (_a = slots.default) == null ? void 0 : _a.call(slots, props));
      });
    };
    if (options.transition) return function () {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["k" /* h */])(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["m" /* TransitionGroup */], options.transition, renderList);
    };
    return renderList;
  });
  component.start = start;
  return component;
}

function createUnrefFn(fn) {
  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return fn.apply(this, args.map(function (i) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(i);
    }));
  };
}

function unrefElement(elRef) {
  var _a;
  var plain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(elRef);
  return (_a = plain == null ? void 0 : plain.$el) != null ? _a : plain;
}

var defaultWindow = __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["d" /* isClient */] ? window : void 0;
var defaultDocument = __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["d" /* isClient */] ? window.document : void 0;
var defaultNavigator = __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["d" /* isClient */] ? window.navigator : void 0;
var defaultLocation = __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["d" /* isClient */] ? window.location : void 0;

function useEventListener() {
  var target = void 0;
  var events = void 0;
  var listeners = void 0;
  var options = void 0;

  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  if (typeof args[0] === "string" || Array.isArray(args[0])) {
    events = args[0];
    listeners = args[1];
    options = args[2];

    target = defaultWindow;
  } else {
    target = args[0];
    events = args[1];
    listeners = args[2];
    options = args[3];
  }
  if (!target) return __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */];
  if (!Array.isArray(events)) events = [events];
  if (!Array.isArray(listeners)) listeners = [listeners];
  var cleanups = [];
  var cleanup = function cleanup() {
    cleanups.forEach(function (fn) {
      return fn();
    });
    cleanups.length = 0;
  };
  var register = function register(el, event, listener, options2) {
    el.addEventListener(event, listener, options2);
    return function () {
      return el.removeEventListener(event, listener, options2);
    };
  };
  var stopWatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(function () {
    return [unrefElement(target), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(options)];
  }, function (_ref5) {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
        el = _ref6[0],
        options2 = _ref6[1];

    cleanup();
    if (!el) return;
    cleanups.push.apply(cleanups, __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray___default()(events.flatMap(function (event) {
      return listeners.map(function (listener) {
        return register(el, event, listener, options2);
      });
    })));
  }, { immediate: true, flush: "post" });
  var stop = function stop() {
    stopWatch();
    cleanup();
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(stop);
  return stop;
}

var _iOSWorkaround = false;
function onClickOutside(target, handler) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$window = options.window,
      window = _options$window === undefined ? defaultWindow : _options$window,
      _options$ignore = options.ignore,
      ignore = _options$ignore === undefined ? [] : _options$ignore,
      _options$capture = options.capture,
      capture = _options$capture === undefined ? true : _options$capture,
      _options$detectIframe = options.detectIframe,
      detectIframe = _options$detectIframe === undefined ? false : _options$detectIframe;

  if (!window) return;
  if (__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["f" /* isIOS */] && !_iOSWorkaround) {
    _iOSWorkaround = true;
    __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from___default()(window.document.body.children).forEach(function (el) {
      return el.addEventListener("click", __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */]);
    });
  }
  var shouldListen = true;
  var shouldIgnore = function shouldIgnore(event) {
    return ignore.some(function (target2) {
      if (typeof target2 === "string") {
        return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from___default()(window.document.querySelectorAll(target2)).some(function (el) {
          return el === event.target || event.composedPath().includes(el);
        });
      } else {
        var el = unrefElement(target2);
        return el && (event.target === el || event.composedPath().includes(el));
      }
    });
  };
  var listener = function listener(event) {
    var el = unrefElement(target);
    if (!el || el === event.target || event.composedPath().includes(el)) return;
    if (event.detail === 0) shouldListen = !shouldIgnore(event);
    if (!shouldListen) {
      shouldListen = true;
      return;
    }
    handler(event);
  };
  var cleanup = [useEventListener(window, "click", listener, { passive: true, capture: capture }), useEventListener(window, "pointerdown", function (e) {
    var el = unrefElement(target);
    if (el) shouldListen = !e.composedPath().includes(el) && !shouldIgnore(e);
  }, { passive: true }), detectIframe && useEventListener(window, "blur", function (event) {
    setTimeout(function () {
      var _a;
      var el = unrefElement(target);
      if (((_a = window.document.activeElement) == null ? void 0 : _a.tagName) === "IFRAME" && !(el == null ? void 0 : el.contains(window.document.activeElement))) handler(event);
    }, 0);
  })].filter(Boolean);
  var stop = function stop() {
    return cleanup.forEach(function (fn) {
      return fn();
    });
  };
  return stop;
}

var __defProp$p = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __defProps$c = __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$c = __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$s = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$s = Object.prototype.hasOwnProperty;
var __propIsEnum$s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$p = function __defNormalProp$p(obj, key, value) {
  return key in obj ? __defProp$p(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$p = function __spreadValues$p(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$s.call(b, prop)) __defNormalProp$p(a, prop, b[prop]);
  }if (__getOwnPropSymbols$s) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$s(b)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var prop = _step2.value;

        if (__propIsEnum$s.call(b, prop)) __defNormalProp$p(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }return a;
};
var __spreadProps$c = function __spreadProps$c(a, b) {
  return __defProps$c(a, __getOwnPropDescs$c(b));
};
function createKeyPredicate(keyFilter) {
  if (typeof keyFilter === "function") return keyFilter;else if (typeof keyFilter === "string") return function (event) {
    return event.key === keyFilter;
  };else if (Array.isArray(keyFilter)) return function (event) {
    return keyFilter.includes(event.key);
  };
  return function () {
    return true;
  };
}
function onKeyStroke() {
  var key = void 0;
  var handler = void 0;
  var options = {};
  if (arguments.length === 3) {
    key = arguments.length <= 0 ? undefined : arguments[0];
    handler = arguments.length <= 1 ? undefined : arguments[1];
    options = arguments.length <= 2 ? undefined : arguments[2];
  } else if (arguments.length === 2) {
    if (__WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(arguments.length <= 1 ? undefined : arguments[1]) === "object") {
      key = true;
      handler = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
    } else {
      key = arguments.length <= 0 ? undefined : arguments[0];
      handler = arguments.length <= 1 ? undefined : arguments[1];
    }
  } else {
    key = true;
    handler = arguments.length <= 0 ? undefined : arguments[0];
  }
  var _options3 = options,
      _options3$target = _options3.target,
      target = _options3$target === undefined ? defaultWindow : _options3$target,
      _options3$eventName = _options3.eventName,
      eventName = _options3$eventName === undefined ? "keydown" : _options3$eventName,
      _options3$passive = _options3.passive,
      passive = _options3$passive === undefined ? false : _options3$passive,
      _options3$dedupe = _options3.dedupe,
      dedupe = _options3$dedupe === undefined ? false : _options3$dedupe;

  var predicate = createKeyPredicate(key);
  var listener = function listener(e) {
    if (e.repeat && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(dedupe)) return;
    if (predicate(e)) handler(e);
  };
  return useEventListener(target, eventName, listener, passive);
}
function onKeyDown(key, handler) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return onKeyStroke(key, handler, __spreadProps$c(__spreadValues$p({}, options), { eventName: "keydown" }));
}
function onKeyPressed(key, handler) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return onKeyStroke(key, handler, __spreadProps$c(__spreadValues$p({}, options), { eventName: "keypress" }));
}
function onKeyUp(key, handler) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return onKeyStroke(key, handler, __spreadProps$c(__spreadValues$p({}, options), { eventName: "keyup" }));
}

var DEFAULT_DELAY = 500;
function onLongPress(target, handler, options) {
  var _a, _b;
  var elementRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return unrefElement(target);
  });
  var timeout = void 0;
  function clear() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = void 0;
    }
  }
  function onDown(ev) {
    var _a2, _b2, _c, _d;
    if (((_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.self) && ev.target !== elementRef.value) return;
    clear();
    if ((_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.prevent) ev.preventDefault();
    if ((_c = options == null ? void 0 : options.modifiers) == null ? void 0 : _c.stop) ev.stopPropagation();
    timeout = setTimeout(function () {
      return handler(ev);
    }, (_d = options == null ? void 0 : options.delay) != null ? _d : DEFAULT_DELAY);
  }
  var listenerOptions = {
    capture: (_a = options == null ? void 0 : options.modifiers) == null ? void 0 : _a.capture,
    once: (_b = options == null ? void 0 : options.modifiers) == null ? void 0 : _b.once
  };
  useEventListener(elementRef, "pointerdown", onDown, listenerOptions);
  useEventListener(elementRef, "pointerup", clear, listenerOptions);
  useEventListener(elementRef, "pointerleave", clear, listenerOptions);
}

function isFocusedElementEditable() {
  var _document = document,
      activeElement = _document.activeElement,
      body = _document.body;

  if (!activeElement) return false;
  if (activeElement === body) return false;
  switch (activeElement.tagName) {
    case "INPUT":
    case "TEXTAREA":
      return true;
  }
  return activeElement.hasAttribute("contenteditable");
}
function isTypedCharValid(_ref7) {
  var keyCode = _ref7.keyCode,
      metaKey = _ref7.metaKey,
      ctrlKey = _ref7.ctrlKey,
      altKey = _ref7.altKey;

  if (metaKey || ctrlKey || altKey) return false;
  if (keyCode >= 48 && keyCode <= 57) return true;
  if (keyCode >= 65 && keyCode <= 90) return true;
  if (keyCode >= 97 && keyCode <= 122) return true;
  return false;
}
function onStartTyping(callback) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$document = options.document,
      document2 = _options$document === undefined ? defaultDocument : _options$document;

  var keydown = function keydown(event) {
    !isFocusedElementEditable() && isTypedCharValid(event) && callback(event);
  };
  if (document2) useEventListener(document2, "keydown", keydown, { passive: true });
}

function templateRef(key) {
  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var instance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["o" /* getCurrentInstance */])();
  var _trigger = function _trigger() {};
  var element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["p" /* customRef */])(function (track, trigger) {
    _trigger = trigger;
    return {
      get: function get() {
        var _a, _b;
        track();
        return (_b = (_a = instance == null ? void 0 : instance.proxy) == null ? void 0 : _a.$refs[key]) != null ? _b : initialValue;
      },
      set: function set() {}
    };
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["g" /* tryOnMounted */])(_trigger);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["q" /* onUpdated */])(_trigger);
  return element;
}

function useActiveElement() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _a;
  var _options$window2 = options.window,
      window = _options$window2 === undefined ? defaultWindow : _options$window2;

  var document = (_a = options.document) != null ? _a : window == null ? void 0 : window.document;
  var activeElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["h" /* computedWithControl */])(function () {
    return null;
  }, function () {
    return document == null ? void 0 : document.activeElement;
  });
  if (window) {
    useEventListener(window, "blur", function (event) {
      if (event.relatedTarget !== null) return;
      activeElement.trigger();
    }, true);
    useEventListener(window, "focus", activeElement.trigger, true);
  }
  return activeElement;
}

function useMounted() {
  var isMounted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["o" /* getCurrentInstance */])()) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["r" /* onMounted */])(function () {
      isMounted.value = true;
    });
  }
  return isMounted;
}

function useSupported(callback) {
  var isMounted = useMounted();
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    isMounted.value;
    return Boolean(callback());
  });
}

function useRafFn(fn) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$immediate = options.immediate,
      immediate = _options$immediate === undefined ? true : _options$immediate,
      _options$window3 = options.window,
      window = _options$window3 === undefined ? defaultWindow : _options$window3;

  var isActive = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var previousFrameTimestamp = 0;
  var rafId = null;
  function loop(timestamp) {
    if (!isActive.value || !window) return;
    var delta = timestamp - previousFrameTimestamp;
    fn({ delta: delta, timestamp: timestamp });
    previousFrameTimestamp = timestamp;
    rafId = window.requestAnimationFrame(loop);
  }
  function resume() {
    if (!isActive.value && window) {
      isActive.value = true;
      rafId = window.requestAnimationFrame(loop);
    }
  }
  function pause() {
    isActive.value = false;
    if (rafId != null && window) {
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }
  }
  if (immediate) resume();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(pause);
  return {
    isActive: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["s" /* readonly */])(isActive),
    pause: pause,
    resume: resume
  };
}

function useAnimate(target, keyframes, options) {
  var config = void 0;
  var animateOptions = void 0;
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["i" /* isObject */])(options)) {
    config = options;
    animateOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["j" /* objectOmit */])(options, ["window", "immediate", "commitStyles", "persist", "onReady", "onError"]);
  } else {
    config = { duration: options };
    animateOptions = options;
  }

  var _config = config,
      _config$window = _config.window,
      window = _config$window === undefined ? defaultWindow : _config$window,
      _config$immediate = _config.immediate,
      immediate = _config$immediate === undefined ? true : _config$immediate,
      commitStyles = _config.commitStyles,
      persist = _config.persist,
      _config$playbackRate = _config.playbackRate,
      _playbackRate = _config$playbackRate === undefined ? 1 : _config$playbackRate,
      onReady = _config.onReady,
      _config$onError = _config.onError,
      onError = _config$onError === undefined ? function (e) {
    console.error(e);
  } : _config$onError;

  var isSupported = useSupported(function () {
    return window && HTMLElement && "animate" in HTMLElement.prototype;
  });
  var animate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(void 0);
  var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["j" /* shallowReactive */])({
    startTime: null,
    currentTime: null,
    timeline: null,
    playbackRate: _playbackRate,
    pending: false,
    playState: immediate ? "idle" : "paused",
    replaceState: "active"
  });
  var pending = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return store.pending;
  });
  var playState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return store.playState;
  });
  var replaceState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return store.replaceState;
  });
  var startTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])({
    get: function get() {
      return store.startTime;
    },
    set: function set(value) {
      store.startTime = value;
      if (animate.value) animate.value.startTime = value;
    }
  });
  var currentTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])({
    get: function get() {
      return store.currentTime;
    },
    set: function set(value) {
      store.currentTime = value;
      if (animate.value) {
        animate.value.currentTime = value;
        syncResume();
      }
    }
  });
  var timeline = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])({
    get: function get() {
      return store.timeline;
    },
    set: function set(value) {
      store.timeline = value;
      if (animate.value) animate.value.timeline = value;
    }
  });
  var playbackRate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])({
    get: function get() {
      return store.playbackRate;
    },
    set: function set(value) {
      store.playbackRate = value;
      if (animate.value) animate.value.playbackRate = value;
    }
  });
  var play = function play() {
    if (animate.value) {
      try {
        animate.value.play();
        syncResume();
      } catch (e) {
        syncPause();
        onError(e);
      }
    } else {
      update();
    }
  };
  var pause = function pause() {
    var _a;
    try {
      (_a = animate.value) == null ? void 0 : _a.pause();
      syncPause();
    } catch (e) {
      onError(e);
    }
  };
  var reverse = function reverse() {
    var _a;
    !animate.value && update();
    try {
      (_a = animate.value) == null ? void 0 : _a.reverse();
      syncResume();
    } catch (e) {
      syncPause();
      onError(e);
    }
  };
  var finish = function finish() {
    var _a;
    try {
      (_a = animate.value) == null ? void 0 : _a.finish();
      syncPause();
    } catch (e) {
      onError(e);
    }
  };
  var cancel = function cancel() {
    var _a;
    try {
      (_a = animate.value) == null ? void 0 : _a.cancel();
      syncPause();
    } catch (e) {
      onError(e);
    }
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(function () {
    return unrefElement(target);
  }, function (el) {
    el && update();
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(function () {
    return keyframes;
  }, function (value) {
    !animate.value && update();
    if (!unrefElement(target) && animate.value) {
      animate.value.effect = new KeyframeEffect(unrefElement(target), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(value), animateOptions);
    }
  }, { deep: true });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["g" /* tryOnMounted */])(function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["t" /* nextTick */])(function () {
      return update(true);
    });
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(cancel);
  function update(init) {
    var el = unrefElement(target);
    if (!isSupported.value || !el) return;
    animate.value = el.animate(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(keyframes), animateOptions);
    if (commitStyles) animate.value.commitStyles();
    if (persist) animate.value.persist();
    if (_playbackRate !== 1) animate.value.playbackRate = _playbackRate;
    if (init && !immediate) animate.value.pause();else syncResume();
    onReady == null ? void 0 : onReady(animate.value);
  }
  useEventListener(animate, "cancel", syncPause);
  useEventListener(animate, "finish", syncPause);
  useEventListener(animate, "remove", syncPause);

  var _useRafFn = useRafFn(function () {
    if (!animate.value) return;
    store.pending = animate.value.pending;
    store.playState = animate.value.playState;
    store.replaceState = animate.value.replaceState;
    store.startTime = animate.value.startTime;
    store.currentTime = animate.value.currentTime;
    store.timeline = animate.value.timeline;
    store.playbackRate = animate.value.playbackRate;
  }, { immediate: false }),
      resumeRef = _useRafFn.resume,
      pauseRef = _useRafFn.pause;

  function syncResume() {
    if (isSupported.value) resumeRef();
  }
  function syncPause() {
    if (isSupported.value && window) window.requestAnimationFrame(pauseRef);
  }
  return {
    isSupported: isSupported,
    animate: animate,

    play: play,
    pause: pause,
    reverse: reverse,
    finish: finish,
    cancel: cancel,

    pending: pending,
    playState: playState,
    replaceState: replaceState,
    startTime: startTime,
    currentTime: currentTime,
    timeline: timeline,
    playbackRate: playbackRate
  };
}

function useAsyncQueue(tasks) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$interrupt = options.interrupt,
      interrupt = _options$interrupt === undefined ? true : _options$interrupt,
      _options$onError = options.onError,
      onError = _options$onError === undefined ? __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */] : _options$onError,
      _options$onFinished = options.onFinished,
      onFinished = _options$onFinished === undefined ? __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */] : _options$onFinished,
      signal = options.signal;

  var promiseState = {
    aborted: "aborted",
    fulfilled: "fulfilled",
    pending: "pending",
    rejected: "rejected"
  };
  var initialResult = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from___default()(new Array(tasks.length), function () {
    return { state: promiseState.pending, data: null };
  });
  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])(initialResult);
  var activeIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(-1);
  if (!tasks || tasks.length === 0) {
    onFinished();
    return {
      activeIndex: activeIndex,
      result: result
    };
  }
  function updateResult(state, res) {
    activeIndex.value++;
    result[activeIndex.value].data = res;
    result[activeIndex.value].state = state;
  }
  tasks.reduce(function (prev, curr) {
    return prev.then(function (prevRes) {
      var _a;
      if (signal == null ? void 0 : signal.aborted) {
        updateResult(promiseState.aborted, new Error("aborted"));
        return;
      }
      if (((_a = result[activeIndex.value]) == null ? void 0 : _a.state) === promiseState.rejected && interrupt) {
        onFinished();
        return;
      }
      var done = curr(prevRes).then(function (currentRes) {
        updateResult(promiseState.fulfilled, currentRes);
        activeIndex.value === tasks.length - 1 && onFinished();
        return currentRes;
      });
      if (!signal) return done;
      return __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a.race([done, whenAborted(signal)]);
    }).catch(function (e) {
      if (signal == null ? void 0 : signal.aborted) {
        updateResult(promiseState.aborted, e);
        return e;
      }
      updateResult(promiseState.rejected, e);
      onError();
      return e;
    });
  }, __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a.resolve());
  return {
    activeIndex: activeIndex,
    result: result
  };
}
function whenAborted(signal) {
  return new __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var error = new Error("aborted");
    if (signal.aborted) reject(error);else signal.addEventListener("abort", function () {
      return reject(error);
    }, { once: true });
  });
}

var __defProp$o = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __defProps$b = __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$b = __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$r = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$r = Object.prototype.hasOwnProperty;
var __propIsEnum$r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$o = function __defNormalProp$o(obj, key, value) {
  return key in obj ? __defProp$o(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$o = function __spreadValues$o(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$r.call(b, prop)) __defNormalProp$o(a, prop, b[prop]);
  }if (__getOwnPropSymbols$r) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$r(b)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var prop = _step3.value;

        if (__propIsEnum$r.call(b, prop)) __defNormalProp$o(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }return a;
};
var __spreadProps$b = function __spreadProps$b(a, b) {
  return __defProps$b(a, __getOwnPropDescs$b(b));
};
function useAsyncState(promise, initialState, options) {
  var execute = function () {
    var _ref9 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var delay2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      var _promise, data;

      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (resetOnExecute) state.value = initialState;
              error.value = void 0;
              isReady.value = false;
              isLoading.value = true;

              if (!(delay2 > 0)) {
                _context2.next = 7;
                break;
              }

              _context2.next = 7;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["k" /* promiseTimeout */])(delay2);

            case 7:
              _promise = typeof promise === "function" ? promise.apply(undefined, args) : promise;
              _context2.prev = 8;
              _context2.next = 11;
              return _promise;

            case 11:
              data = _context2.sent;

              state.value = data;
              isReady.value = true;
              onSuccess(data);
              _context2.next = 23;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2['catch'](8);

              error.value = _context2.t0;
              onError(_context2.t0);

              if (!throwError) {
                _context2.next = 23;
                break;
              }

              throw _context2.t0;

            case 23:
              _context2.prev = 23;

              isLoading.value = false;
              return _context2.finish(23);

            case 26:
              return _context2.abrupt('return', state.value);

            case 27:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[8, 17, 23, 26]]);
    }));

    return function execute() {
      return _ref9.apply(this, arguments);
    };
  }();

  var _ref8 = options != null ? options : {},
      _ref8$immediate = _ref8.immediate,
      immediate = _ref8$immediate === undefined ? true : _ref8$immediate,
      _ref8$delay = _ref8.delay,
      delay = _ref8$delay === undefined ? 0 : _ref8$delay,
      _ref8$onError = _ref8.onError,
      onError = _ref8$onError === undefined ? __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */] : _ref8$onError,
      _ref8$onSuccess = _ref8.onSuccess,
      onSuccess = _ref8$onSuccess === undefined ? __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */] : _ref8$onSuccess,
      _ref8$resetOnExecute = _ref8.resetOnExecute,
      resetOnExecute = _ref8$resetOnExecute === undefined ? true : _ref8$resetOnExecute,
      _ref8$shallow = _ref8.shallow,
      shallow = _ref8$shallow === undefined ? true : _ref8$shallow,
      throwError = _ref8.throwError;

  var state = shallow ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(initialState) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(initialState);
  var isReady = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var isLoading = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(void 0);

  if (immediate) execute(delay);
  var shell = {
    state: state,
    isReady: isReady,
    isLoading: isLoading,
    error: error,
    execute: execute
  };
  function waitUntilIsLoaded() {
    return new __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["l" /* until */])(isLoading).toBe(false).then(function () {
        return resolve(shell);
      }).catch(reject);
    });
  }
  return __spreadProps$b(__spreadValues$o({}, shell), {
    then: function then(onFulfilled, onRejected) {
      return waitUntilIsLoaded().then(onFulfilled, onRejected);
    }
  });
}

var defaults = {
  array: function array(v) {
    return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify___default()(v);
  },
  object: function object(v) {
    return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify___default()(v);
  },
  set: function set(v) {
    return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from___default()(v));
  },
  map: function map(v) {
    return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify___default()(Object.fromEntries(v));
  },
  null: function _null() {
    return "";
  }
};
function getDefaultSerialization(target) {
  if (!target) return defaults.null;
  if (target instanceof __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_map___default.a) return defaults.map;else if (target instanceof __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a) return defaults.set;else if (Array.isArray(target)) return defaults.array;else return defaults.object;
}

function useBase64(target, options) {
  var base64 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])("");
  var promise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  function execute() {
    if (!__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["d" /* isClient */]) return;
    promise.value = new __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      try {
        var _target = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target);
        if (_target == null) {
          resolve("");
        } else if (typeof _target === "string") {
          resolve(blobToBase64(new Blob([_target], { type: "text/plain" })));
        } else if (_target instanceof Blob) {
          resolve(blobToBase64(_target));
        } else if (_target instanceof ArrayBuffer) {
          resolve(window.btoa(String.fromCharCode.apply(String, __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray___default()(new Uint8Array(_target)))));
        } else if (_target instanceof HTMLCanvasElement) {
          resolve(_target.toDataURL(options == null ? void 0 : options.type, options == null ? void 0 : options.quality));
        } else if (_target instanceof HTMLImageElement) {
          var img = _target.cloneNode(false);
          img.crossOrigin = "Anonymous";
          imgLoaded(img).then(function () {
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            resolve(canvas.toDataURL(options == null ? void 0 : options.type, options == null ? void 0 : options.quality));
          }).catch(reject);
        } else if ((typeof _target === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(_target)) === "object") {
          var _serializeFn = (options == null ? void 0 : options.serializer) || getDefaultSerialization(_target);
          var serialized = _serializeFn(_target);
          return resolve(blobToBase64(new Blob([serialized], { type: "application/json" })));
        } else {
          reject(new Error("target is unsupported types"));
        }
      } catch (error) {
        reject(error);
      }
    });
    promise.value.then(function (res) {
      return base64.value = res;
    });
    return promise.value;
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["a" /* isRef */])(target) || typeof target === "function") __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(target, execute, { immediate: true });else execute();
  return {
    base64: base64,
    promise: promise,
    execute: execute
  };
}
function imgLoaded(img) {
  return new __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (!img.complete) {
      img.onload = function () {
        resolve();
      };
      img.onerror = reject;
    } else {
      resolve();
    }
  });
}
function blobToBase64(blob) {
  return new __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var fr = new FileReader();
    fr.onload = function (e) {
      resolve(e.target.result);
    };
    fr.onerror = reject;
    fr.readAsDataURL(blob);
  });
}

function useBattery() {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref10$navigator = _ref10.navigator,
      navigator = _ref10$navigator === undefined ? defaultNavigator : _ref10$navigator;

  var events = ["chargingchange", "chargingtimechange", "dischargingtimechange", "levelchange"];
  var isSupported = useSupported(function () {
    return navigator && "getBattery" in navigator;
  });
  var charging = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var chargingTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var dischargingTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var level = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(1);
  var battery = void 0;
  function updateBatteryInfo() {
    charging.value = this.charging;
    chargingTime.value = this.chargingTime || 0;
    dischargingTime.value = this.dischargingTime || 0;
    level.value = this.level;
  }
  if (isSupported.value) {
    navigator.getBattery().then(function (_battery) {
      battery = _battery;
      updateBatteryInfo.call(battery);
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(events), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var event = _step4.value;

          useEventListener(battery, event, updateBatteryInfo, { passive: true });
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    });
  }
  return {
    isSupported: isSupported,
    charging: charging,
    chargingTime: chargingTime,
    dischargingTime: dischargingTime,
    level: level
  };
}

function useBluetooth(options) {
  var requestDevice = function () {
    var _ref13 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (isSupported.value) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt('return');

            case 2:
              error.value = null;
              if (filters && filters.length > 0) acceptAllDevices = false;
              _context3.prev = 4;
              _context3.next = 7;
              return navigator == null ? void 0 : navigator.bluetooth.requestDevice({
                acceptAllDevices: acceptAllDevices,
                filters: filters,
                optionalServices: optionalServices
              });

            case 7:
              device.value = _context3.sent;
              _context3.next = 13;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3['catch'](4);

              error.value = _context3.t0;

            case 13:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[4, 10]]);
    }));

    return function requestDevice() {
      return _ref13.apply(this, arguments);
    };
  }();

  var connectToBluetoothGATTServer = function () {
    var _ref14 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              error.value = null;

              if (!(device.value && device.value.gatt)) {
                _context4.next = 12;
                break;
              }

              device.value.addEventListener("gattserverdisconnected", function () {});
              _context4.prev = 3;
              _context4.next = 6;
              return device.value.gatt.connect();

            case 6:
              server.value = _context4.sent;
              _context4.next = 12;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4['catch'](3);

              error.value = _context4.t0;

            case 12:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this, [[3, 9]]);
    }));

    return function connectToBluetoothGATTServer() {
      return _ref14.apply(this, arguments);
    };
  }();

  var _ref11 = options || {},
      _ref11$acceptAllDevic = _ref11.acceptAllDevices,
      acceptAllDevices = _ref11$acceptAllDevic === undefined ? false : _ref11$acceptAllDevic;

  var _ref12 = options || {},
      _ref12$filters = _ref12.filters,
      filters = _ref12$filters === undefined ? void 0 : _ref12$filters,
      _ref12$optionalServic = _ref12.optionalServices,
      optionalServices = _ref12$optionalServic === undefined ? void 0 : _ref12$optionalServic,
      _ref12$navigator = _ref12.navigator,
      navigator = _ref12$navigator === undefined ? defaultNavigator : _ref12$navigator;

  var isSupported = useSupported(function () {
    return navigator && "bluetooth" in navigator;
  });
  var device = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(void 0);
  var error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(null);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(device, function () {
    connectToBluetoothGATTServer();
  });

  var server = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  var isConnected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    var _a;
    return ((_a = server.value) == null ? void 0 : _a.connected) || false;
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["g" /* tryOnMounted */])(function () {
    var _a;
    if (device.value) (_a = device.value.gatt) == null ? void 0 : _a.connect();
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(function () {
    var _a;
    if (device.value) (_a = device.value.gatt) == null ? void 0 : _a.disconnect();
  });
  return {
    isSupported: isSupported,
    isConnected: isConnected,

    device: device,
    requestDevice: requestDevice,

    server: server,

    error: error
  };
}

function useMediaQuery(query) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$window4 = options.window,
      window = _options$window4 === undefined ? defaultWindow : _options$window4;

  var isSupported = useSupported(function () {
    return window && "matchMedia" in window && typeof window.matchMedia === "function";
  });
  var mediaQuery = void 0;
  var matches = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var cleanup = function cleanup() {
    if (!mediaQuery) return;
    if ("removeEventListener" in mediaQuery) mediaQuery.removeEventListener("change", update);else mediaQuery.removeListener(update);
  };
  var update = function update() {
    if (!isSupported.value) return;
    cleanup();
    mediaQuery = window.matchMedia(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["m" /* toRef */])(query).value);
    matches.value = !!(mediaQuery == null ? void 0 : mediaQuery.matches);
    if (!mediaQuery) return;
    if ("addEventListener" in mediaQuery) mediaQuery.addEventListener("change", update);else mediaQuery.addListener(update);
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["d" /* watchEffect */])(update);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(function () {
    return cleanup();
  });
  return matches;
}

var breakpointsTailwind = {
  "sm": 640,
  "md": 768,
  "lg": 1024,
  "xl": 1280,
  "2xl": 1536
};
var breakpointsBootstrapV5 = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
};
var breakpointsVuetify = {
  xs: 600,
  sm: 960,
  md: 1264,
  lg: 1904
};
var breakpointsAntDesign = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600
};
var breakpointsQuasar = {
  xs: 600,
  sm: 1024,
  md: 1440,
  lg: 1920
};
var breakpointsSematic = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptop: 1024,
  laptopL: 1440,
  desktop4K: 2560
};
var breakpointsMasterCss = {
  "3xs": 360,
  "2xs": 480,
  "xs": 600,
  "sm": 768,
  "md": 1024,
  "lg": 1280,
  "xl": 1440,
  "2xl": 1600,
  "3xl": 1920,
  "4xl": 2560
};

function useBreakpoints(breakpoints) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  function getValue(k, delta) {
    var v = breakpoints[k];
    if (delta != null) v = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["n" /* increaseWithUnit */])(v, delta);
    if (typeof v === "number") v = v + 'px';
    return v;
  }
  var _options$window5 = options.window,
      window = _options$window5 === undefined ? defaultWindow : _options$window5;

  function match(query) {
    if (!window) return false;
    return window.matchMedia(query).matches;
  }
  var greaterOrEqual = function greaterOrEqual(k) {
    return useMediaQuery('(min-width: ' + getValue(k) + ')', options);
  };
  var shortcutMethods = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(breakpoints).reduce(function (shortcuts, k) {
    __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default()(shortcuts, k, {
      get: function get() {
        return greaterOrEqual(k);
      },
      enumerable: true,
      configurable: true
    });
    return shortcuts;
  }, {});
  return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()(shortcutMethods, {
    greater: function greater(k) {
      return useMediaQuery('(min-width: ' + getValue(k, 0.1) + ')', options);
    },

    greaterOrEqual: greaterOrEqual,
    smaller: function smaller(k) {
      return useMediaQuery('(max-width: ' + getValue(k, -0.1) + ')', options);
    },
    smallerOrEqual: function smallerOrEqual(k) {
      return useMediaQuery('(max-width: ' + getValue(k) + ')', options);
    },
    between: function between(a, b) {
      return useMediaQuery('(min-width: ' + getValue(a) + ') and (max-width: ' + getValue(b, -0.1) + ')', options);
    },
    isGreater: function isGreater(k) {
      return match('(min-width: ' + getValue(k, 0.1) + ')');
    },
    isGreaterOrEqual: function isGreaterOrEqual(k) {
      return match('(min-width: ' + getValue(k) + ')');
    },
    isSmaller: function isSmaller(k) {
      return match('(max-width: ' + getValue(k, -0.1) + ')');
    },
    isSmallerOrEqual: function isSmallerOrEqual(k) {
      return match('(max-width: ' + getValue(k) + ')');
    },
    isInBetween: function isInBetween(a, b) {
      return match('(min-width: ' + getValue(a) + ') and (max-width: ' + getValue(b, -0.1) + ')');
    },
    current: function current() {
      var points = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(breakpoints).map(function (i) {
        return [i, greaterOrEqual(i)];
      });
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
        return points.filter(function (_ref15) {
          var _ref16 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref15, 2),
              v = _ref16[1];

          return v.value;
        }).map(function (_ref17) {
          var _ref18 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref17, 1),
              k = _ref18[0];

          return k;
        });
      });
    }
  });
}

function useBroadcastChannel(options) {
  var name = options.name,
      _options$window6 = options.window,
      window = _options$window6 === undefined ? defaultWindow : _options$window6;

  var isSupported = useSupported(function () {
    return window && "BroadcastChannel" in window;
  });
  var isClosed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var channel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  var error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(null);
  var post = function post(data2) {
    if (channel.value) channel.value.postMessage(data2);
  };
  var close = function close() {
    if (channel.value) channel.value.close();
    isClosed.value = true;
  };
  if (isSupported.value) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["g" /* tryOnMounted */])(function () {
      error.value = null;
      channel.value = new BroadcastChannel(name);
      channel.value.addEventListener("message", function (e) {
        data.value = e.data;
      }, { passive: true });
      channel.value.addEventListener("messageerror", function (e) {
        error.value = e;
      }, { passive: true });
      channel.value.addEventListener("close", function () {
        isClosed.value = true;
      });
    });
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(function () {
    close();
  });
  return {
    isSupported: isSupported,
    channel: channel,
    data: data,
    post: post,
    close: close,
    error: error,
    isClosed: isClosed
  };
}

var __defProp$n = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __getOwnPropSymbols$q = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$q = Object.prototype.hasOwnProperty;
var __propIsEnum$q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$n = function __defNormalProp$n(obj, key, value) {
  return key in obj ? __defProp$n(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$n = function __spreadValues$n(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$q.call(b, prop)) __defNormalProp$n(a, prop, b[prop]);
  }if (__getOwnPropSymbols$q) {
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$q(b)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var prop = _step5.value;

        if (__propIsEnum$q.call(b, prop)) __defNormalProp$n(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }
  }return a;
};
var WRITABLE_PROPERTIES = ["hash", "host", "hostname", "href", "pathname", "port", "protocol", "search"];
function useBrowserLocation() {
  var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref19$window = _ref19.window,
      window = _ref19$window === undefined ? defaultWindow : _ref19$window;

  var refs = Object.fromEntries(WRITABLE_PROPERTIES.map(function (key) {
    return [key, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])()];
  }));

  var _loop = function _loop(key, ref2) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(ref2, function (value) {
      if (!(window == null ? void 0 : window.location) || window.location[key] === value) return;
      window.location[key] = value;
    });
  };

  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["o" /* objectEntries */])(refs)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var _ref20 = _step6.value;

      var _ref21 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref20, 2);

      var key = _ref21[0];
      var ref2 = _ref21[1];

      _loop(key, ref2);
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  var buildState = function buildState(trigger) {
    var _a;

    var _ref22 = (window == null ? void 0 : window.history) || {},
        state2 = _ref22.state,
        length = _ref22.length;

    var _ref23 = (window == null ? void 0 : window.location) || {},
        origin = _ref23.origin;

    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(WRITABLE_PROPERTIES), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var key = _step7.value;

        refs[key].value = (_a = window == null ? void 0 : window.location) == null ? void 0 : _a[key];
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])(__spreadValues$n({
      trigger: trigger,
      state: state2,
      length: length,
      origin: origin
    }, refs));
  };
  var state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(buildState("load"));
  if (window) {
    useEventListener(window, "popstate", function () {
      return state.value = buildState("popstate");
    }, { passive: true });
    useEventListener(window, "hashchange", function () {
      return state.value = buildState("hashchange");
    }, { passive: true });
  }
  return state;
}

function useCached(refValue) {
  var comparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (a, b) {
    return a === b;
  };
  var watchOptions = arguments[2];

  var cachedValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(refValue.value);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(function () {
    return refValue.value;
  }, function (value) {
    if (!comparator(value, cachedValue.value)) cachedValue.value = value;
  }, watchOptions);
  return cachedValue;
}

function useClipboard() {
  var copy = function () {
    var _ref24 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(source);
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(isSupported.value && value != null)) {
                _context5.next = 10;
                break;
              }

              if (!isClipboardApiSupported.value) {
                _context5.next = 6;
                break;
              }

              _context5.next = 4;
              return navigator.clipboard.writeText(value);

            case 4:
              _context5.next = 7;
              break;

            case 6:
              legacyCopy(value);

            case 7:
              text.value = value;
              copied.value = true;
              timeout.start();

            case 10:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    return function copy() {
      return _ref24.apply(this, arguments);
    };
  }();

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$navigator = options.navigator,
      navigator = _options$navigator === undefined ? defaultNavigator : _options$navigator,
      _options$read = options.read,
      read = _options$read === undefined ? false : _options$read,
      source = options.source,
      _options$copiedDuring = options.copiedDuring,
      copiedDuring = _options$copiedDuring === undefined ? 1500 : _options$copiedDuring,
      _options$legacy = options.legacy,
      legacy = _options$legacy === undefined ? false : _options$legacy;

  var events = ["copy", "cut"];
  var isClipboardApiSupported = useSupported(function () {
    return navigator && "clipboard" in navigator;
  });
  var isSupported = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return isClipboardApiSupported.value || legacy;
  });
  var text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])("");
  var copied = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var timeout = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["p" /* useTimeoutFn */])(function () {
    return copied.value = false;
  }, copiedDuring);
  function updateText() {
    if (isClipboardApiSupported.value) {
      navigator.clipboard.readText().then(function (value) {
        text.value = value;
      });
    } else {
      text.value = legacyRead();
    }
  }
  if (isSupported.value && read) {
    var _iteratorNormalCompletion8 = true;
    var _didIteratorError8 = false;
    var _iteratorError8 = undefined;

    try {
      for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(events), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
        var event = _step8.value;

        useEventListener(event, updateText);
      }
    } catch (err) {
      _didIteratorError8 = true;
      _iteratorError8 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion8 && _iterator8.return) {
          _iterator8.return();
        }
      } finally {
        if (_didIteratorError8) {
          throw _iteratorError8;
        }
      }
    }
  }

  function legacyCopy(value) {
    var ta = document.createElement("textarea");
    ta.value = value != null ? value : "";
    ta.style.position = "absolute";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    ta.remove();
  }
  function legacyRead() {
    var _a, _b, _c;
    return (_c = (_b = (_a = document == null ? void 0 : document.getSelection) == null ? void 0 : _a.call(document)) == null ? void 0 : _b.toString()) != null ? _c : "";
  }
  return {
    isSupported: isSupported,
    text: text,
    copied: copied,
    copy: copy
  };
}

var __defProp$m = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __defProps$a = __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$a = __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$p = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$p = Object.prototype.hasOwnProperty;
var __propIsEnum$p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$m = function __defNormalProp$m(obj, key, value) {
  return key in obj ? __defProp$m(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$m = function __spreadValues$m(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$p.call(b, prop)) __defNormalProp$m(a, prop, b[prop]);
  }if (__getOwnPropSymbols$p) {
    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$p(b)), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        var prop = _step9.value;

        if (__propIsEnum$p.call(b, prop)) __defNormalProp$m(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9.return) {
          _iterator9.return();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }
  }return a;
};
var __spreadProps$a = function __spreadProps$a(a, b) {
  return __defProps$a(a, __getOwnPropDescs$a(b));
};
function cloneFnJSON(source) {
  return JSON.parse(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify___default()(source));
}
function useCloned(source) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var cloned = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])({});
  var manual = options.manual,
      _options$clone = options.clone,
      clone = _options$clone === undefined ? cloneFnJSON : _options$clone,
      _options$deep = options.deep,
      deep = _options$deep === undefined ? true : _options$deep,
      _options$immediate2 = options.immediate,
      immediate = _options$immediate2 === undefined ? true : _options$immediate2;

  function sync() {
    cloned.value = clone(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(source));
  }
  if (!manual && (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["a" /* isRef */])(source) || typeof source === "function")) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(source, sync, __spreadProps$a(__spreadValues$m({}, options), {
      deep: deep,
      immediate: immediate
    }));
  } else {
    sync();
  }
  return { cloned: cloned, sync: sync };
}

var _global = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var globalKey = "__vueuse_ssr_handlers__";
var handlers = getHandlers();
function getHandlers() {
  if (!(globalKey in _global)) _global[globalKey] = _global[globalKey] || {};
  return _global[globalKey];
}
function getSSRHandler(key, fallback) {
  return handlers[key] || fallback;
}
function setSSRHandler(key, fn) {
  handlers[key] = fn;
}

function guessSerializerType(rawInit) {
  return rawInit == null ? "any" : rawInit instanceof __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a ? "set" : rawInit instanceof __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_map___default.a ? "map" : rawInit instanceof Date ? "date" : typeof rawInit === "boolean" ? "boolean" : typeof rawInit === "string" ? "string" : (typeof rawInit === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(rawInit)) === "object" ? "object" : !__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_nan___default()(rawInit) ? "number" : "any";
}

var __defProp$l = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __getOwnPropSymbols$o = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$o = Object.prototype.hasOwnProperty;
var __propIsEnum$o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$l = function __defNormalProp$l(obj, key, value) {
  return key in obj ? __defProp$l(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$l = function __spreadValues$l(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$o.call(b, prop)) __defNormalProp$l(a, prop, b[prop]);
  }if (__getOwnPropSymbols$o) {
    var _iteratorNormalCompletion10 = true;
    var _didIteratorError10 = false;
    var _iteratorError10 = undefined;

    try {
      for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$o(b)), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
        var prop = _step10.value;

        if (__propIsEnum$o.call(b, prop)) __defNormalProp$l(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError10 = true;
      _iteratorError10 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion10 && _iterator10.return) {
          _iterator10.return();
        }
      } finally {
        if (_didIteratorError10) {
          throw _iteratorError10;
        }
      }
    }
  }return a;
};
var StorageSerializers = {
  boolean: {
    read: function read(v) {
      return v === "true";
    },
    write: function write(v) {
      return String(v);
    }
  },
  object: {
    read: function read(v) {
      return JSON.parse(v);
    },
    write: function write(v) {
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify___default()(v);
    }
  },
  number: {
    read: function read(v) {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(v);
    },
    write: function write(v) {
      return String(v);
    }
  },
  any: {
    read: function read(v) {
      return v;
    },
    write: function write(v) {
      return String(v);
    }
  },
  string: {
    read: function read(v) {
      return v;
    },
    write: function write(v) {
      return String(v);
    }
  },
  map: {
    read: function read(v) {
      return new __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_map___default.a(JSON.parse(v));
    },
    write: function write(v) {
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from___default()(v.entries()));
    }
  },
  set: {
    read: function read(v) {
      return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a(JSON.parse(v));
    },
    write: function write(v) {
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from___default()(v));
    }
  },
  date: {
    read: function read(v) {
      return new Date(v);
    },
    write: function write(v) {
      return v.toISOString();
    }
  }
};
var customStorageEventName = "vueuse-storage";
function useStorage(key, defaults, storage) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var _a;
  var _options$flush = options.flush,
      flush = _options$flush === undefined ? "pre" : _options$flush,
      _options$deep2 = options.deep,
      deep = _options$deep2 === undefined ? true : _options$deep2,
      _options$listenToStor = options.listenToStorageChanges,
      listenToStorageChanges = _options$listenToStor === undefined ? true : _options$listenToStor,
      _options$writeDefault = options.writeDefaults,
      writeDefaults = _options$writeDefault === undefined ? true : _options$writeDefault,
      _options$mergeDefault = options.mergeDefaults,
      mergeDefaults = _options$mergeDefault === undefined ? false : _options$mergeDefault,
      shallow = options.shallow,
      _options$window7 = options.window,
      window = _options$window7 === undefined ? defaultWindow : _options$window7,
      eventFilter = options.eventFilter,
      _options$onError2 = options.onError,
      onError = _options$onError2 === undefined ? function (e) {
    console.error(e);
  } : _options$onError2;

  var data = (shallow ? __WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */] : __WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(defaults);
  if (!storage) {
    try {
      storage = getSSRHandler("getDefaultStorage", function () {
        var _a2;
        return (_a2 = defaultWindow) == null ? void 0 : _a2.localStorage;
      })();
    } catch (e) {
      onError(e);
    }
  }
  if (!storage) return data;
  var rawInit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(defaults);
  var type = guessSerializerType(rawInit);
  var serializer = (_a = options.serializer) != null ? _a : StorageSerializers[type];

  var _pausableWatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["q" /* pausableWatch */])(data, function () {
    return write(data.value);
  }, { flush: flush, deep: deep, eventFilter: eventFilter }),
      pauseWatch = _pausableWatch.pause,
      resumeWatch = _pausableWatch.resume;

  if (window && listenToStorageChanges) {
    useEventListener(window, "storage", update);
    useEventListener(window, customStorageEventName, updateFromCustomEvent);
  }
  update();
  return data;
  function write(v) {
    try {
      if (v == null) {
        storage.removeItem(key);
      } else {
        var serialized = serializer.write(v);
        var oldValue = storage.getItem(key);
        if (oldValue !== serialized) {
          storage.setItem(key, serialized);
          if (window) {
            window.dispatchEvent(new CustomEvent(customStorageEventName, {
              detail: {
                key: key,
                oldValue: oldValue,
                newValue: serialized,
                storageArea: storage
              }
            }));
          }
        }
      }
    } catch (e) {
      onError(e);
    }
  }
  function read(event) {
    var rawValue = event ? event.newValue : storage.getItem(key);
    if (rawValue == null) {
      if (writeDefaults && rawInit !== null) storage.setItem(key, serializer.write(rawInit));
      return rawInit;
    } else if (!event && mergeDefaults) {
      var value = serializer.read(rawValue);
      if (typeof mergeDefaults === "function") return mergeDefaults(value, rawInit);else if (type === "object" && !Array.isArray(value)) return __spreadValues$l(__spreadValues$l({}, rawInit), value);
      return value;
    } else if (typeof rawValue !== "string") {
      return rawValue;
    } else {
      return serializer.read(rawValue);
    }
  }
  function updateFromCustomEvent(event) {
    update(event.detail);
  }
  function update(event) {
    if (event && event.storageArea !== storage) return;
    if (event && event.key == null) {
      data.value = rawInit;
      return;
    }
    if (event && event.key !== key) return;
    pauseWatch();
    try {
      data.value = read(event);
    } catch (e) {
      onError(e);
    } finally {
      if (event) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["t" /* nextTick */])(resumeWatch);else resumeWatch();
    }
  }
}

function usePreferredDark(options) {
  return useMediaQuery("(prefers-color-scheme: dark)", options);
}

var __defProp$k = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __getOwnPropSymbols$n = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$n = Object.prototype.hasOwnProperty;
var __propIsEnum$n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$k = function __defNormalProp$k(obj, key, value) {
  return key in obj ? __defProp$k(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$k = function __spreadValues$k(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$n.call(b, prop)) __defNormalProp$k(a, prop, b[prop]);
  }if (__getOwnPropSymbols$n) {
    var _iteratorNormalCompletion11 = true;
    var _didIteratorError11 = false;
    var _iteratorError11 = undefined;

    try {
      for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$n(b)), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
        var prop = _step11.value;

        if (__propIsEnum$n.call(b, prop)) __defNormalProp$k(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError11 = true;
      _iteratorError11 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion11 && _iterator11.return) {
          _iterator11.return();
        }
      } finally {
        if (_didIteratorError11) {
          throw _iteratorError11;
        }
      }
    }
  }return a;
};
function useColorMode() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$selector = options.selector,
      selector = _options$selector === undefined ? "html" : _options$selector,
      _options$attribute = options.attribute,
      attribute = _options$attribute === undefined ? "class" : _options$attribute,
      _options$initialValue = options.initialValue,
      initialValue = _options$initialValue === undefined ? "auto" : _options$initialValue,
      _options$window8 = options.window,
      window = _options$window8 === undefined ? defaultWindow : _options$window8,
      storage = options.storage,
      _options$storageKey = options.storageKey,
      storageKey = _options$storageKey === undefined ? "vueuse-color-scheme" : _options$storageKey,
      _options$listenToStor2 = options.listenToStorageChanges,
      listenToStorageChanges = _options$listenToStor2 === undefined ? true : _options$listenToStor2,
      storageRef = options.storageRef,
      emitAuto = options.emitAuto,
      _options$disableTrans = options.disableTransition,
      disableTransition = _options$disableTrans === undefined ? true : _options$disableTrans;

  var modes = __spreadValues$k({
    auto: "",
    light: "light",
    dark: "dark"
  }, options.modes || {});
  var preferredDark = usePreferredDark({ window: window });
  var system = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return preferredDark.value ? "dark" : "light";
  });
  var store = storageRef || (storageKey == null ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["m" /* toRef */])(initialValue) : useStorage(storageKey, initialValue, storage, { window: window, listenToStorageChanges: listenToStorageChanges }));
  var state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return store.value === "auto" ? system.value : store.value;
  });
  var updateHTMLAttrs = getSSRHandler("updateHTMLAttrs", function (selector2, attribute2, value) {
    var el = typeof selector2 === "string" ? window == null ? void 0 : window.document.querySelector(selector2) : unrefElement(selector2);
    if (!el) return;
    var style = void 0;
    if (disableTransition) {
      style = window.document.createElement("style");
      var styleString = "*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
      style.appendChild(document.createTextNode(styleString));
      window.document.head.appendChild(style);
    }
    if (attribute2 === "class") {
      var current = value.split(/\s/g);
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(modes).flatMap(function (i) {
        return (i || "").split(/\s/g);
      }).filter(Boolean).forEach(function (v) {
        if (current.includes(v)) el.classList.add(v);else el.classList.remove(v);
      });
    } else {
      el.setAttribute(attribute2, value);
    }
    if (disableTransition) {
      window.getComputedStyle(style).opacity;
      document.head.removeChild(style);
    }
  });
  function defaultOnChanged(mode) {
    var _a;
    updateHTMLAttrs(selector, attribute, (_a = modes[mode]) != null ? _a : mode);
  }
  function onChanged(mode) {
    if (options.onChanged) options.onChanged(mode, defaultOnChanged);else defaultOnChanged(mode);
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(state, onChanged, { flush: "post", immediate: true });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["g" /* tryOnMounted */])(function () {
    return onChanged(state.value);
  });
  var auto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])({
    get: function get() {
      return emitAuto ? store.value : state.value;
    },
    set: function set(v) {
      store.value = v;
    }
  });
  try {
    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()(auto, { store: store, system: system, state: state });
  } catch (e) {
    return auto;
  }
}

function useConfirmDialog() {
  var revealed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);

  var confirmHook = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["r" /* createEventHook */])();
  var cancelHook = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["r" /* createEventHook */])();
  var revealHook = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["r" /* createEventHook */])();
  var _resolve = __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */];
  var reveal = function reveal(data) {
    revealHook.trigger(data);
    revealed.value = true;
    return new __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a(function (resolve) {
      _resolve = resolve;
    });
  };
  var confirm = function confirm(data) {
    revealed.value = false;
    confirmHook.trigger(data);
    _resolve({ data: data, isCanceled: false });
  };
  var cancel = function cancel(data) {
    revealed.value = false;
    cancelHook.trigger(data);
    _resolve({ data: data, isCanceled: true });
  };
  return {
    isRevealed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
      return revealed.value;
    }),
    reveal: reveal,
    confirm: confirm,
    cancel: cancel,
    onReveal: revealHook.on,
    onConfirm: confirmHook.on,
    onCancel: cancelHook.on
  };
}

var __getOwnPropSymbols$m = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$m = Object.prototype.hasOwnProperty;
var __propIsEnum$m = Object.prototype.propertyIsEnumerable;
var __objRest$3 = function __objRest$3(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp$m.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }if (source != null && __getOwnPropSymbols$m) {
    var _iteratorNormalCompletion12 = true;
    var _didIteratorError12 = false;
    var _iteratorError12 = undefined;

    try {
      for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$m(source)), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
        var prop = _step12.value;

        if (exclude.indexOf(prop) < 0 && __propIsEnum$m.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _didIteratorError12 = true;
      _iteratorError12 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion12 && _iterator12.return) {
          _iterator12.return();
        }
      } finally {
        if (_didIteratorError12) {
          throw _iteratorError12;
        }
      }
    }
  }return target;
};
function useMutationObserver(target, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a = options,
      _a$window = _a.window,
      window = _a$window === undefined ? defaultWindow : _a$window,
      mutationOptions = __objRest$3(_a, ["window"]);
  var observer = void 0;
  var isSupported = useSupported(function () {
    return window && "MutationObserver" in window;
  });
  var cleanup = function cleanup() {
    if (observer) {
      observer.disconnect();
      observer = void 0;
    }
  };
  var stopWatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(function () {
    return unrefElement(target);
  }, function (el) {
    cleanup();
    if (isSupported.value && window && el) {
      observer = new MutationObserver(callback);
      observer.observe(el, mutationOptions);
    }
  }, { immediate: true });
  var stop = function stop() {
    cleanup();
    stopWatch();
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(stop);
  return {
    isSupported: isSupported,
    stop: stop
  };
}

function useCssVar(prop, target) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$window9 = options.window,
      window = _options$window9 === undefined ? defaultWindow : _options$window9,
      _options$initialValue2 = options.initialValue,
      initialValue = _options$initialValue2 === undefined ? "" : _options$initialValue2,
      _options$observe = options.observe,
      observe = _options$observe === undefined ? false : _options$observe;

  var variable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(initialValue);
  var elRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    var _a;
    return unrefElement(target) || ((_a = window == null ? void 0 : window.document) == null ? void 0 : _a.documentElement);
  });
  function updateCssVar() {
    var _a;
    var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(prop);
    var el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(elRef);
    if (el && window) {
      var value = (_a = window.getComputedStyle(el).getPropertyValue(key)) == null ? void 0 : _a.trim();
      variable.value = value || initialValue;
    }
  }
  if (observe) {
    useMutationObserver(elRef, updateCssVar, {
      attributeFilter: ["style", "class"],
      window: window
    });
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])([elRef, function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(prop);
  }], updateCssVar, { immediate: true });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(variable, function (val) {
    var _a;
    if ((_a = elRef.value) == null ? void 0 : _a.style) elRef.value.style.setProperty(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(prop), val);
  });
  return variable;
}

function useCurrentElement() {
  var vm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["o" /* getCurrentInstance */])();
  var currentElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["h" /* computedWithControl */])(function () {
    return null;
  }, function () {
    return vm.proxy.$el;
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["q" /* onUpdated */])(currentElement.trigger);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["r" /* onMounted */])(currentElement.trigger);
  return currentElement;
}

function useCycleList(list, options) {
  var state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(getInitialValue());
  var listRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["m" /* toRef */])(list);
  var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])({
    get: function get() {
      var _a;
      var targetList = listRef.value;
      var index2 = (options == null ? void 0 : options.getIndexOf) ? options.getIndexOf(state.value, targetList) : targetList.indexOf(state.value);
      if (index2 < 0) index2 = (_a = options == null ? void 0 : options.fallbackIndex) != null ? _a : 0;
      return index2;
    },
    set: function set(v) {
      _set(v);
    }
  });
  function _set(i) {
    var targetList = listRef.value;
    var length = targetList.length;
    var index2 = (i % length + length) % length;
    var value = targetList[index2];
    state.value = value;
    return value;
  }
  function shift() {
    var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return _set(index.value + delta);
  }
  function next() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return shift(n);
  }
  function prev() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return shift(-n);
  }
  function getInitialValue() {
    var _a, _b;
    return (_b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])((_a = options == null ? void 0 : options.initialValue) != null ? _a : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(list)[0])) != null ? _b : void 0;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(listRef, function () {
    return _set(index.value);
  });
  return {
    state: state,
    index: index,
    next: next,
    prev: prev
  };
}

var __defProp$j = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __defProps$9 = __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$9 = __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$l = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$l = Object.prototype.hasOwnProperty;
var __propIsEnum$l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$j = function __defNormalProp$j(obj, key, value) {
  return key in obj ? __defProp$j(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$j = function __spreadValues$j(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$l.call(b, prop)) __defNormalProp$j(a, prop, b[prop]);
  }if (__getOwnPropSymbols$l) {
    var _iteratorNormalCompletion13 = true;
    var _didIteratorError13 = false;
    var _iteratorError13 = undefined;

    try {
      for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$l(b)), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
        var prop = _step13.value;

        if (__propIsEnum$l.call(b, prop)) __defNormalProp$j(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError13 = true;
      _iteratorError13 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion13 && _iterator13.return) {
          _iterator13.return();
        }
      } finally {
        if (_didIteratorError13) {
          throw _iteratorError13;
        }
      }
    }
  }return a;
};
var __spreadProps$9 = function __spreadProps$9(a, b) {
  return __defProps$9(a, __getOwnPropDescs$9(b));
};
function useDark() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$valueDark = options.valueDark,
      valueDark = _options$valueDark === undefined ? "dark" : _options$valueDark,
      _options$valueLight = options.valueLight,
      valueLight = _options$valueLight === undefined ? "" : _options$valueLight;

  var mode = useColorMode(__spreadProps$9(__spreadValues$j({}, options), {
    onChanged: function onChanged(mode2, defaultHandler) {
      var _a;
      if (options.onChanged) (_a = options.onChanged) == null ? void 0 : _a.call(options, mode2 === "dark", defaultHandler, mode2);else defaultHandler(mode2);
    },
    modes: {
      dark: valueDark,
      light: valueLight
    }
  }));
  var isDark = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])({
    get: function get() {
      return mode.value === "dark";
    },
    set: function set(v) {
      var modeVal = v ? "dark" : "light";
      if (mode.system.value === modeVal) mode.value = "auto";else mode.value = modeVal;
    }
  });
  return isDark;
}

function fnBypass(v) {
  return v;
}
function fnSetSource(source, value) {
  return source.value = value;
}
function defaultDump(clone) {
  return clone ? typeof clone === "function" ? clone : cloneFnJSON : fnBypass;
}
function defaultParse(clone) {
  return clone ? typeof clone === "function" ? clone : cloneFnJSON : fnBypass;
}
function useManualRefHistory(source) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$clone2 = options.clone,
      clone = _options$clone2 === undefined ? false : _options$clone2,
      _options$dump = options.dump,
      dump = _options$dump === undefined ? defaultDump(clone) : _options$dump,
      _options$parse = options.parse,
      parse = _options$parse === undefined ? defaultParse(clone) : _options$parse,
      _options$setSource = options.setSource,
      setSource = _options$setSource === undefined ? fnSetSource : _options$setSource;

  function _createHistoryRecord() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["v" /* markRaw */])({
      snapshot: dump(source.value),
      timestamp: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["s" /* timestamp */])()
    });
  }
  var last = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(_createHistoryRecord());
  var undoStack = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])([]);
  var redoStack = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])([]);
  var _setSource = function _setSource(record) {
    setSource(source, parse(record.snapshot));
    last.value = record;
  };
  var commit = function commit() {
    undoStack.value.unshift(last.value);
    last.value = _createHistoryRecord();
    if (options.capacity && undoStack.value.length > options.capacity) undoStack.value.splice(options.capacity, Infinity);
    if (redoStack.value.length) redoStack.value.splice(0, redoStack.value.length);
  };
  var clear = function clear() {
    undoStack.value.splice(0, undoStack.value.length);
    redoStack.value.splice(0, redoStack.value.length);
  };
  var undo = function undo() {
    var state = undoStack.value.shift();
    if (state) {
      redoStack.value.unshift(last.value);
      _setSource(state);
    }
  };
  var redo = function redo() {
    var state = redoStack.value.shift();
    if (state) {
      undoStack.value.unshift(last.value);
      _setSource(state);
    }
  };
  var reset = function reset() {
    _setSource(last.value);
  };
  var history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return [last.value].concat(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray___default()(undoStack.value));
  });
  var canUndo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return undoStack.value.length > 0;
  });
  var canRedo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return redoStack.value.length > 0;
  });
  return {
    source: source,
    undoStack: undoStack,
    redoStack: redoStack,
    last: last,
    history: history,
    canUndo: canUndo,
    canRedo: canRedo,
    clear: clear,
    commit: commit,
    reset: reset,
    undo: undo,
    redo: redo
  };
}

var __defProp$i = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __defProps$8 = __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$8 = __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$k = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$k = Object.prototype.hasOwnProperty;
var __propIsEnum$k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$i = function __defNormalProp$i(obj, key, value) {
  return key in obj ? __defProp$i(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$i = function __spreadValues$i(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$k.call(b, prop)) __defNormalProp$i(a, prop, b[prop]);
  }if (__getOwnPropSymbols$k) {
    var _iteratorNormalCompletion14 = true;
    var _didIteratorError14 = false;
    var _iteratorError14 = undefined;

    try {
      for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$k(b)), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
        var prop = _step14.value;

        if (__propIsEnum$k.call(b, prop)) __defNormalProp$i(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError14 = true;
      _iteratorError14 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion14 && _iterator14.return) {
          _iterator14.return();
        }
      } finally {
        if (_didIteratorError14) {
          throw _iteratorError14;
        }
      }
    }
  }return a;
};
var __spreadProps$8 = function __spreadProps$8(a, b) {
  return __defProps$8(a, __getOwnPropDescs$8(b));
};
function useRefHistory(source) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$deep3 = options.deep,
      deep = _options$deep3 === undefined ? false : _options$deep3,
      _options$flush2 = options.flush,
      flush = _options$flush2 === undefined ? "pre" : _options$flush2,
      eventFilter = options.eventFilter;

  var _pausableFilter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["t" /* pausableFilter */])(eventFilter),
      composedFilter = _pausableFilter.eventFilter,
      pause = _pausableFilter.pause,
      resumeTracking = _pausableFilter.resume,
      isTracking = _pausableFilter.isActive;

  var _watchIgnorable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["u" /* watchIgnorable */])(source, commit, { deep: deep, flush: flush, eventFilter: composedFilter }),
      ignoreUpdates = _watchIgnorable.ignoreUpdates,
      ignorePrevAsyncUpdates = _watchIgnorable.ignorePrevAsyncUpdates,
      stop = _watchIgnorable.stop;

  function setSource(source2, value) {
    ignorePrevAsyncUpdates();
    ignoreUpdates(function () {
      source2.value = value;
    });
  }
  var manualHistory = useManualRefHistory(source, __spreadProps$8(__spreadValues$i({}, options), { clone: options.clone || deep, setSource: setSource }));
  var clear = manualHistory.clear,
      manualCommit = manualHistory.commit;

  function commit() {
    ignorePrevAsyncUpdates();
    manualCommit();
  }
  function resume(commitNow) {
    resumeTracking();
    if (commitNow) commit();
  }
  function batch(fn) {
    var canceled = false;
    var cancel = function cancel() {
      return canceled = true;
    };
    ignoreUpdates(function () {
      fn(cancel);
    });
    if (!canceled) commit();
  }
  function dispose() {
    stop();
    clear();
  }
  return __spreadProps$8(__spreadValues$i({}, manualHistory), {
    isTracking: isTracking,
    pause: pause,
    resume: resume,
    commit: commit,
    batch: batch,
    dispose: dispose
  });
}

var __defProp$h = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __defProps$7 = __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$7 = __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$j = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$j = Object.prototype.hasOwnProperty;
var __propIsEnum$j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$h = function __defNormalProp$h(obj, key, value) {
  return key in obj ? __defProp$h(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$h = function __spreadValues$h(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$j.call(b, prop)) __defNormalProp$h(a, prop, b[prop]);
  }if (__getOwnPropSymbols$j) {
    var _iteratorNormalCompletion15 = true;
    var _didIteratorError15 = false;
    var _iteratorError15 = undefined;

    try {
      for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$j(b)), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
        var prop = _step15.value;

        if (__propIsEnum$j.call(b, prop)) __defNormalProp$h(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError15 = true;
      _iteratorError15 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion15 && _iterator15.return) {
          _iterator15.return();
        }
      } finally {
        if (_didIteratorError15) {
          throw _iteratorError15;
        }
      }
    }
  }return a;
};
var __spreadProps$7 = function __spreadProps$7(a, b) {
  return __defProps$7(a, __getOwnPropDescs$7(b));
};
function useDebouncedRefHistory(source) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var filter = options.debounce ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["v" /* debounceFilter */])(options.debounce) : void 0;
  var history = useRefHistory(source, __spreadProps$7(__spreadValues$h({}, options), { eventFilter: filter }));
  return __spreadValues$h({}, history);
}

function useDeviceMotion() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window10 = options.window,
      window = _options$window10 === undefined ? defaultWindow : _options$window10,
      _options$eventFilter = options.eventFilter,
      eventFilter = _options$eventFilter === undefined ? __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["w" /* bypassFilter */] : _options$eventFilter;

  var acceleration = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])({ x: null, y: null, z: null });
  var rotationRate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])({ alpha: null, beta: null, gamma: null });
  var interval = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var accelerationIncludingGravity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])({
    x: null,
    y: null,
    z: null
  });
  if (window) {
    var onDeviceMotion = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["x" /* createFilterWrapper */])(eventFilter, function (event) {
      acceleration.value = event.acceleration;
      accelerationIncludingGravity.value = event.accelerationIncludingGravity;
      rotationRate.value = event.rotationRate;
      interval.value = event.interval;
    });
    useEventListener(window, "devicemotion", onDeviceMotion);
  }
  return {
    acceleration: acceleration,
    accelerationIncludingGravity: accelerationIncludingGravity,
    rotationRate: rotationRate,
    interval: interval
  };
}

function useDeviceOrientation() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window11 = options.window,
      window = _options$window11 === undefined ? defaultWindow : _options$window11;

  var isSupported = useSupported(function () {
    return window && "DeviceOrientationEvent" in window;
  });
  var isAbsolute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var alpha = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  var beta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  var gamma = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  if (window && isSupported.value) {
    useEventListener(window, "deviceorientation", function (event) {
      isAbsolute.value = event.absolute;
      alpha.value = event.alpha;
      beta.value = event.beta;
      gamma.value = event.gamma;
    });
  }
  return {
    isSupported: isSupported,
    isAbsolute: isAbsolute,
    alpha: alpha,
    beta: beta,
    gamma: gamma
  };
}

function useDevicePixelRatio() {
  var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref25$window = _ref25.window,
      window = _ref25$window === undefined ? defaultWindow : _ref25$window;

  var pixelRatio = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(1);
  if (window) {
    var observe = function observe() {
      pixelRatio.value = window.devicePixelRatio;
      cleanup();
      media = window.matchMedia('(resolution: ' + pixelRatio.value + 'dppx)');
      media.addEventListener("change", observe, { once: true });
    },
        cleanup = function cleanup() {
      media == null ? void 0 : media.removeEventListener("change", observe);
    };
    var media = void 0;
    observe();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(cleanup);
  }
  return { pixelRatio: pixelRatio };
}

function usePermission(permissionDesc) {
  var _this2 = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$controls = options.controls,
      controls = _options$controls === undefined ? false : _options$controls,
      _options$navigator2 = options.navigator,
      navigator = _options$navigator2 === undefined ? defaultNavigator : _options$navigator2;

  var isSupported = useSupported(function () {
    return navigator && "permissions" in navigator;
  });
  var permissionStatus = void 0;
  var desc = typeof permissionDesc === "string" ? { name: permissionDesc } : permissionDesc;
  var state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  var onChange = function onChange() {
    if (permissionStatus) state.value = permissionStatus.state;
  };
  var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["y" /* createSingletonPromise */])(__WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee6() {
    return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (isSupported.value) {
              _context6.next = 2;
              break;
            }

            return _context6.abrupt('return');

          case 2:
            if (permissionStatus) {
              _context6.next = 14;
              break;
            }

            _context6.prev = 3;
            _context6.next = 6;
            return navigator.permissions.query(desc);

          case 6:
            permissionStatus = _context6.sent;

            useEventListener(permissionStatus, "change", onChange);
            onChange();
            _context6.next = 14;
            break;

          case 11:
            _context6.prev = 11;
            _context6.t0 = _context6['catch'](3);

            state.value = "prompt";

          case 14:
            return _context6.abrupt('return', permissionStatus);

          case 15:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this2, [[3, 11]]);
  })));
  query();
  if (controls) {
    return {
      state: state,
      isSupported: isSupported,
      query: query
    };
  } else {
    return state;
  }
}

function useDevicesList() {
  var update = function () {
    var _ref27 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (isSupported.value) {
                _context7.next = 2;
                break;
              }

              return _context7.abrupt('return');

            case 2:
              _context7.next = 4;
              return navigator.mediaDevices.enumerateDevices();

            case 4:
              devices.value = _context7.sent;

              onUpdated == null ? void 0 : onUpdated(devices.value);
              if (stream) {
                stream.getTracks().forEach(function (t) {
                  return t.stop();
                });
                stream = null;
              }

            case 7:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    return function update() {
      return _ref27.apply(this, arguments);
    };
  }();

  var ensurePermissions = function () {
    var _ref28 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var _usePermission, state, query;

      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (isSupported.value) {
                _context8.next = 2;
                break;
              }

              return _context8.abrupt('return', false);

            case 2:
              if (!permissionGranted.value) {
                _context8.next = 4;
                break;
              }

              return _context8.abrupt('return', true);

            case 4:
              _usePermission = usePermission("camera", { controls: true }), state = _usePermission.state, query = _usePermission.query;
              _context8.next = 7;
              return query();

            case 7:
              if (!(state.value !== "granted")) {
                _context8.next = 15;
                break;
              }

              _context8.next = 10;
              return navigator.mediaDevices.getUserMedia(constraints);

            case 10:
              stream = _context8.sent;

              update();
              permissionGranted.value = true;
              _context8.next = 16;
              break;

            case 15:
              permissionGranted.value = true;

            case 16:
              return _context8.abrupt('return', permissionGranted.value);

            case 17:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    return function ensurePermissions() {
      return _ref28.apply(this, arguments);
    };
  }();

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$navigator3 = options.navigator,
      navigator = _options$navigator3 === undefined ? defaultNavigator : _options$navigator3,
      _options$requestPermi = options.requestPermissions,
      requestPermissions = _options$requestPermi === undefined ? false : _options$requestPermi,
      _options$constraints = options.constraints,
      constraints = _options$constraints === undefined ? { audio: true, video: true } : _options$constraints,
      onUpdated = options.onUpdated;

  var devices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])([]);
  var videoInputs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return devices.value.filter(function (i) {
      return i.kind === "videoinput";
    });
  });
  var audioInputs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return devices.value.filter(function (i) {
      return i.kind === "audioinput";
    });
  });
  var audioOutputs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return devices.value.filter(function (i) {
      return i.kind === "audiooutput";
    });
  });
  var isSupported = useSupported(function () {
    return navigator && navigator.mediaDevices && navigator.mediaDevices.enumerateDevices;
  });
  var permissionGranted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var stream = void 0;

  if (isSupported.value) {
    if (requestPermissions) ensurePermissions();
    useEventListener(navigator.mediaDevices, "devicechange", update);
    update();
  }
  return {
    devices: devices,
    ensurePermissions: ensurePermissions,
    permissionGranted: permissionGranted,
    videoInputs: videoInputs,
    audioInputs: audioInputs,
    audioOutputs: audioOutputs,
    isSupported: isSupported
  };
}

function useDisplayMedia() {
  var _start = function () {
    var _ref29 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (!(!isSupported.value || stream.value)) {
                _context9.next = 2;
                break;
              }

              return _context9.abrupt('return');

            case 2:
              _context9.next = 4;
              return navigator.mediaDevices.getDisplayMedia(constraint);

            case 4:
              stream.value = _context9.sent;
              return _context9.abrupt('return', stream.value);

            case 6:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    return function _start() {
      return _ref29.apply(this, arguments);
    };
  }();

  var _stop = function () {
    var _ref30 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var _a2;

      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              (_a2 = stream.value) == null ? void 0 : _a2.getTracks().forEach(function (t) {
                return t.stop();
              });
              stream.value = void 0;

            case 2:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    return function _stop() {
      return _ref30.apply(this, arguments);
    };
  }();

  var start = function () {
    var _ref31 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _start();

            case 2:
              if (stream.value) enabled.value = true;
              return _context11.abrupt('return', stream.value);

            case 4:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    return function start() {
      return _ref31.apply(this, arguments);
    };
  }();

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _a;
  var enabled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])((_a = options.enabled) != null ? _a : false);
  var video = options.video;
  var audio = options.audio;
  var _options$navigator4 = options.navigator,
      navigator = _options$navigator4 === undefined ? defaultNavigator : _options$navigator4;

  var isSupported = useSupported(function () {
    var _a2;
    return (_a2 = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : _a2.getDisplayMedia;
  });
  var constraint = { audio: audio, video: video };
  var stream = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])();

  function stop() {
    _stop();
    enabled.value = false;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(enabled, function (v) {
    if (v) _start();else _stop();
  }, { immediate: true });
  return {
    isSupported: isSupported,
    stream: stream,
    start: start,
    stop: stop,
    enabled: enabled
  };
}

function useDocumentVisibility() {
  var _ref32 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref32$document = _ref32.document,
      document = _ref32$document === undefined ? defaultDocument : _ref32$document;

  if (!document) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])("visible");
  var visibility = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(document.visibilityState);
  useEventListener(document, "visibilitychange", function () {
    visibility.value = document.visibilityState;
  });
  return visibility;
}

var __defProp$g = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __defProps$6 = __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$6 = __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$i = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$i = Object.prototype.hasOwnProperty;
var __propIsEnum$i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$g = function __defNormalProp$g(obj, key, value) {
  return key in obj ? __defProp$g(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$g = function __spreadValues$g(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$i.call(b, prop)) __defNormalProp$g(a, prop, b[prop]);
  }if (__getOwnPropSymbols$i) {
    var _iteratorNormalCompletion16 = true;
    var _didIteratorError16 = false;
    var _iteratorError16 = undefined;

    try {
      for (var _iterator16 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$i(b)), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
        var prop = _step16.value;

        if (__propIsEnum$i.call(b, prop)) __defNormalProp$g(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError16 = true;
      _iteratorError16 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion16 && _iterator16.return) {
          _iterator16.return();
        }
      } finally {
        if (_didIteratorError16) {
          throw _iteratorError16;
        }
      }
    }
  }return a;
};
var __spreadProps$6 = function __spreadProps$6(a, b) {
  return __defProps$6(a, __getOwnPropDescs$6(b));
};
function useDraggable(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _a, _b;
  var pointerTypes = options.pointerTypes,
      preventDefault = options.preventDefault,
      stopPropagation = options.stopPropagation,
      exact = options.exact,
      onMove = options.onMove,
      onEnd = options.onEnd,
      onStart = options.onStart,
      initialValue = options.initialValue,
      _options$axis = options.axis,
      axis = _options$axis === undefined ? "both" : _options$axis,
      _options$draggingElem = options.draggingElement,
      draggingElement = _options$draggingElem === undefined ? defaultWindow : _options$draggingElem,
      _options$handle = options.handle,
      draggingHandle = _options$handle === undefined ? target : _options$handle;

  var position = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])((_a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(initialValue)) != null ? _a : { x: 0, y: 0 });
  var pressedDelta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  var filterEvent = function filterEvent(e) {
    if (pointerTypes) return pointerTypes.includes(e.pointerType);
    return true;
  };
  var handleEvent = function handleEvent(e) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(preventDefault)) e.preventDefault();
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(stopPropagation)) e.stopPropagation();
  };
  var start = function start(e) {
    if (!filterEvent(e)) return;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(exact) && e.target !== __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target)) return;
    var rect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target).getBoundingClientRect();
    var pos = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    };
    if ((onStart == null ? void 0 : onStart(pos, e)) === false) return;
    pressedDelta.value = pos;
    handleEvent(e);
  };
  var move = function move(e) {
    if (!filterEvent(e)) return;
    if (!pressedDelta.value) return;
    var _position$value = position.value,
        x = _position$value.x,
        y = _position$value.y;

    if (axis === "x" || axis === "both") x = e.clientX - pressedDelta.value.x;
    if (axis === "y" || axis === "both") y = e.clientY - pressedDelta.value.y;
    position.value = {
      x: x,
      y: y
    };
    onMove == null ? void 0 : onMove(position.value, e);
    handleEvent(e);
  };
  var end = function end(e) {
    if (!filterEvent(e)) return;
    if (!pressedDelta.value) return;
    pressedDelta.value = void 0;
    onEnd == null ? void 0 : onEnd(position.value, e);
    handleEvent(e);
  };
  if (__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["d" /* isClient */]) {
    var config = { capture: (_b = options.capture) != null ? _b : true };
    useEventListener(draggingHandle, "pointerdown", start, config);
    useEventListener(draggingElement, "pointermove", move, config);
    useEventListener(draggingElement, "pointerup", end, config);
  }
  return __spreadProps$6(__spreadValues$g({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["z" /* toRefs */])(position)), {
    position: position,
    isDragging: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
      return !!pressedDelta.value;
    }),
    style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
      return 'left:' + position.value.x + 'px;top:' + position.value.y + 'px;';
    })
  });
}

function useDropZone(target, onDrop) {
  var isOverDropZone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var counter = 0;
  if (__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["d" /* isClient */]) {
    useEventListener(target, "dragenter", function (event) {
      event.preventDefault();
      counter += 1;
      isOverDropZone.value = true;
    });
    useEventListener(target, "dragover", function (event) {
      event.preventDefault();
    });
    useEventListener(target, "dragleave", function (event) {
      event.preventDefault();
      counter -= 1;
      if (counter === 0) isOverDropZone.value = false;
    });
    useEventListener(target, "drop", function (event) {
      var _a, _b;
      event.preventDefault();
      counter = 0;
      isOverDropZone.value = false;
      var files = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from___default()((_b = (_a = event.dataTransfer) == null ? void 0 : _a.files) != null ? _b : []);
      onDrop == null ? void 0 : onDrop(files.length === 0 ? null : files);
    });
  }
  return {
    isOverDropZone: isOverDropZone
  };
}

var __getOwnPropSymbols$h = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$h = Object.prototype.hasOwnProperty;
var __propIsEnum$h = Object.prototype.propertyIsEnumerable;
var __objRest$2 = function __objRest$2(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp$h.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }if (source != null && __getOwnPropSymbols$h) {
    var _iteratorNormalCompletion17 = true;
    var _didIteratorError17 = false;
    var _iteratorError17 = undefined;

    try {
      for (var _iterator17 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$h(source)), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
        var prop = _step17.value;

        if (exclude.indexOf(prop) < 0 && __propIsEnum$h.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _didIteratorError17 = true;
      _iteratorError17 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion17 && _iterator17.return) {
          _iterator17.return();
        }
      } finally {
        if (_didIteratorError17) {
          throw _iteratorError17;
        }
      }
    }
  }return target;
};
function useResizeObserver(target, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a = options,
      _a$window2 = _a.window,
      window = _a$window2 === undefined ? defaultWindow : _a$window2,
      observerOptions = __objRest$2(_a, ["window"]);
  var observer = void 0;
  var isSupported = useSupported(function () {
    return window && "ResizeObserver" in window;
  });
  var cleanup = function cleanup() {
    if (observer) {
      observer.disconnect();
      observer = void 0;
    }
  };
  var targets = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return Array.isArray(target) ? target.map(function (el) {
      return unrefElement(el);
    }) : [unrefElement(target)];
  });
  var stopWatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(targets, function (els) {
    cleanup();
    if (isSupported.value && window) {
      observer = new ResizeObserver(callback);
      var _iteratorNormalCompletion18 = true;
      var _didIteratorError18 = false;
      var _iteratorError18 = undefined;

      try {
        for (var _iterator18 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(els), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
          var _el = _step18.value;

          _el && observer.observe(_el, observerOptions);
        }
      } catch (err) {
        _didIteratorError18 = true;
        _iteratorError18 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion18 && _iterator18.return) {
            _iterator18.return();
          }
        } finally {
          if (_didIteratorError18) {
            throw _iteratorError18;
          }
        }
      }
    }
  }, { immediate: true, flush: "post", deep: true });
  var stop = function stop() {
    cleanup();
    stopWatch();
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(stop);
  return {
    isSupported: isSupported,
    stop: stop
  };
}

function useElementBounding(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$reset = options.reset,
      reset = _options$reset === undefined ? true : _options$reset,
      _options$windowResize = options.windowResize,
      windowResize = _options$windowResize === undefined ? true : _options$windowResize,
      _options$windowScroll = options.windowScroll,
      windowScroll = _options$windowScroll === undefined ? true : _options$windowScroll,
      _options$immediate3 = options.immediate,
      immediate = _options$immediate3 === undefined ? true : _options$immediate3;

  var height = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var bottom = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var left = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var right = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var top = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var width = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  function update() {
    var el = unrefElement(target);
    if (!el) {
      if (reset) {
        height.value = 0;
        bottom.value = 0;
        left.value = 0;
        right.value = 0;
        top.value = 0;
        width.value = 0;
        x.value = 0;
        y.value = 0;
      }
      return;
    }
    var rect = el.getBoundingClientRect();
    height.value = rect.height;
    bottom.value = rect.bottom;
    left.value = rect.left;
    right.value = rect.right;
    top.value = rect.top;
    width.value = rect.width;
    x.value = rect.x;
    y.value = rect.y;
  }
  useResizeObserver(target, update);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(function () {
    return unrefElement(target);
  }, function (ele) {
    return !ele && update();
  });
  if (windowScroll) useEventListener("scroll", update, { capture: true, passive: true });
  if (windowResize) useEventListener("resize", update, { passive: true });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["g" /* tryOnMounted */])(function () {
    if (immediate) update();
  });
  return {
    height: height,
    bottom: bottom,
    left: left,
    right: right,
    top: top,
    width: width,
    x: x,
    y: y,
    update: update
  };
}

var __defProp$f = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __getOwnPropSymbols$g = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$g = Object.prototype.hasOwnProperty;
var __propIsEnum$g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$f = function __defNormalProp$f(obj, key, value) {
  return key in obj ? __defProp$f(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$f = function __spreadValues$f(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$g.call(b, prop)) __defNormalProp$f(a, prop, b[prop]);
  }if (__getOwnPropSymbols$g) {
    var _iteratorNormalCompletion19 = true;
    var _didIteratorError19 = false;
    var _iteratorError19 = undefined;

    try {
      for (var _iterator19 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$g(b)), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
        var prop = _step19.value;

        if (__propIsEnum$g.call(b, prop)) __defNormalProp$f(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError19 = true;
      _iteratorError19 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion19 && _iterator19.return) {
          _iterator19.return();
        }
      } finally {
        if (_didIteratorError19) {
          throw _iteratorError19;
        }
      }
    }
  }return a;
};
function useElementByPoint(options) {
  var x = options.x,
      y = options.y,
      _options$document2 = options.document,
      document = _options$document2 === undefined ? defaultDocument : _options$document2,
      multiple = options.multiple,
      _options$interval = options.interval,
      interval = _options$interval === undefined ? "requestAnimationFrame" : _options$interval,
      _options$immediate4 = options.immediate,
      immediate = _options$immediate4 === undefined ? true : _options$immediate4;

  var isSupported = useSupported(function () {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(multiple)) return document && "elementsFromPoint" in document;
    return document && "elementFromPoint" in document;
  });
  var element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  var cb = function cb() {
    var _a, _b;
    element.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(multiple) ? (_a = document == null ? void 0 : document.elementsFromPoint(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(x), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(y))) != null ? _a : [] : (_b = document == null ? void 0 : document.elementFromPoint(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(x), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(y))) != null ? _b : null;
  };
  var controls = interval === "requestAnimationFrame" ? useRafFn(cb, { immediate: immediate }) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["A" /* useIntervalFn */])(cb, interval, { immediate: immediate });
  return __spreadValues$f({
    isSupported: isSupported,
    element: element
  }, controls);
}

function useElementHover(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$delayEnter = options.delayEnter,
      delayEnter = _options$delayEnter === undefined ? 0 : _options$delayEnter,
      _options$delayLeave = options.delayLeave,
      delayLeave = _options$delayLeave === undefined ? 0 : _options$delayLeave,
      _options$window12 = options.window,
      window = _options$window12 === undefined ? defaultWindow : _options$window12;

  var isHovered = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var timer = void 0;
  var toggle = function toggle(entering) {
    var delay = entering ? delayEnter : delayLeave;
    if (timer) {
      clearTimeout(timer);
      timer = void 0;
    }
    if (delay) timer = setTimeout(function () {
      return isHovered.value = entering;
    }, delay);else isHovered.value = entering;
  };
  if (!window) return isHovered;
  useEventListener(el, "mouseenter", function () {
    return toggle(true);
  }, { passive: true });
  useEventListener(el, "mouseleave", function () {
    return toggle(false);
  }, { passive: true });
  return isHovered;
}

function useElementSize(target) {
  var initialSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { width: 0, height: 0 };
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$window13 = options.window,
      window = _options$window13 === undefined ? defaultWindow : _options$window13,
      _options$box = options.box,
      box = _options$box === undefined ? "content-box" : _options$box;

  var isSVG = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    var _a, _b;
    return (_b = (_a = unrefElement(target)) == null ? void 0 : _a.namespaceURI) == null ? void 0 : _b.includes("svg");
  });
  var width = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(initialSize.width);
  var height = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(initialSize.height);
  useResizeObserver(target, function (_ref33) {
    var _ref34 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref33, 1),
        entry = _ref34[0];

    var boxSize = box === "border-box" ? entry.borderBoxSize : box === "content-box" ? entry.contentBoxSize : entry.devicePixelContentBoxSize;
    if (window && isSVG.value) {
      var $elem = unrefElement(target);
      if ($elem) {
        var styles = window.getComputedStyle($elem);
        width.value = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(styles.width);
        height.value = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(styles.height);
      }
    } else {
      if (boxSize) {
        var formatBoxSize = Array.isArray(boxSize) ? boxSize : [boxSize];
        width.value = formatBoxSize.reduce(function (acc, _ref35) {
          var inlineSize = _ref35.inlineSize;
          return acc + inlineSize;
        }, 0);
        height.value = formatBoxSize.reduce(function (acc, _ref36) {
          var blockSize = _ref36.blockSize;
          return acc + blockSize;
        }, 0);
      } else {
        width.value = entry.contentRect.width;
        height.value = entry.contentRect.height;
      }
    }
  }, options);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(function () {
    return unrefElement(target);
  }, function (ele) {
    width.value = ele ? initialSize.width : 0;
    height.value = ele ? initialSize.height : 0;
  });
  return {
    width: width,
    height: height
  };
}

function useIntersectionObserver(target, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var root = options.root,
      _options$rootMargin = options.rootMargin,
      rootMargin = _options$rootMargin === undefined ? "0px" : _options$rootMargin,
      _options$threshold = options.threshold,
      threshold = _options$threshold === undefined ? 0.1 : _options$threshold,
      _options$window14 = options.window,
      window = _options$window14 === undefined ? defaultWindow : _options$window14,
      _options$immediate5 = options.immediate,
      immediate = _options$immediate5 === undefined ? true : _options$immediate5;

  var isSupported = useSupported(function () {
    return window && "IntersectionObserver" in window;
  });
  var targets = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    var _target = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target);
    return (Array.isArray(_target) ? _target : [_target]).map(unrefElement).filter(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["B" /* notNullish */]);
  });
  var _cleanup = __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */];
  var isActive = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(immediate);
  var stopWatch = isSupported.value ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(function () {
    return [targets.value, unrefElement(root), isActive.value];
  }, function (_ref37) {
    var _ref38 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref37, 2),
        targets2 = _ref38[0],
        root2 = _ref38[1];

    _cleanup();
    if (!isActive.value) return;
    if (!targets2.length) return;
    var observer = new IntersectionObserver(callback, {
      root: unrefElement(root2),
      rootMargin: rootMargin,
      threshold: threshold
    });
    targets2.forEach(function (el) {
      return el && observer.observe(el);
    });
    _cleanup = function cleanup() {
      observer.disconnect();
      _cleanup = __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */];
    };
  }, { immediate: immediate, flush: "post" }) : __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */];
  var stop = function stop() {
    _cleanup();
    stopWatch();
    isActive.value = false;
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(stop);
  return {
    isSupported: isSupported,
    isActive: isActive,
    pause: function pause() {
      _cleanup();
      isActive.value = false;
    },
    resume: function resume() {
      isActive.value = true;
    },

    stop: stop
  };
}

function useElementVisibility(element) {
  var _ref39 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref39$window = _ref39.window,
      window = _ref39$window === undefined ? defaultWindow : _ref39$window,
      scrollTarget = _ref39.scrollTarget;

  var elementIsVisible = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  useIntersectionObserver(element, function (_ref40) {
    var _ref41 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref40, 1),
        isIntersecting = _ref41[0].isIntersecting;

    elementIsVisible.value = isIntersecting;
  }, {
    root: scrollTarget,
    window: window
  });
  return elementIsVisible;
}

var events = new __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_map___default.a();

function useEventBus(key) {
  var scope = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["w" /* getCurrentScope */])();
  function on(listener) {
    var _a;
    var listeners = events.get(key) || new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a();
    listeners.add(listener);
    events.set(key, listeners);
    var _off = function _off() {
      return off(listener);
    };
    (_a = scope == null ? void 0 : scope.cleanups) == null ? void 0 : _a.push(_off);
    return _off;
  }
  function once(listener) {
    function _listener() {
      off(_listener);
      listener.apply(undefined, arguments);
    }
    return on(_listener);
  }
  function off(listener) {
    var listeners = events.get(key);
    if (!listeners) return;
    listeners.delete(listener);
    if (!listeners.size) reset();
  }
  function reset() {
    events.delete(key);
  }
  function emit(event, payload) {
    var _a;
    (_a = events.get(key)) == null ? void 0 : _a.forEach(function (v) {
      return v(event, payload);
    });
  }
  return { on: on, once: once, off: off, emit: emit, reset: reset };
}

function useEventSource(url) {
  var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  var status = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])("CONNECTING");
  var eventSource = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  var error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(null);
  var _options$withCredenti = options.withCredentials,
      withCredentials = _options$withCredenti === undefined ? false : _options$withCredenti;

  var close = function close() {
    if (eventSource.value) {
      eventSource.value.close();
      eventSource.value = null;
      status.value = "CLOSED";
    }
  };
  var es = new EventSource(url, { withCredentials: withCredentials });
  eventSource.value = es;
  es.onopen = function () {
    status.value = "OPEN";
    error.value = null;
  };
  es.onerror = function (e) {
    status.value = "CLOSED";
    error.value = e;
  };
  es.onmessage = function (e) {
    event.value = null;
    data.value = e.data;
  };

  var _loop2 = function _loop2(event_name) {
    useEventListener(es, event_name, function (e) {
      event.value = event_name;
      data.value = e.data || null;
    });
  };

  var _iteratorNormalCompletion20 = true;
  var _didIteratorError20 = false;
  var _iteratorError20 = undefined;

  try {
    for (var _iterator20 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(events), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
      var event_name = _step20.value;

      _loop2(event_name);
    }
  } catch (err) {
    _didIteratorError20 = true;
    _iteratorError20 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion20 && _iterator20.return) {
        _iterator20.return();
      }
    } finally {
      if (_didIteratorError20) {
        throw _iteratorError20;
      }
    }
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(function () {
    close();
  });
  return {
    eventSource: eventSource,
    event: event,
    data: data,
    status: status,
    error: error,
    close: close
  };
}

function useEyeDropper() {
  var open = function () {
    var _ref42 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee12(openOptions) {
      var eyeDropper, result;
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              if (isSupported.value) {
                _context12.next = 2;
                break;
              }

              return _context12.abrupt('return');

            case 2:
              eyeDropper = new window.EyeDropper();
              _context12.next = 5;
              return eyeDropper.open(openOptions);

            case 5:
              result = _context12.sent;

              sRGBHex.value = result.sRGBHex;
              return _context12.abrupt('return', result);

            case 8:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    return function open(_x52) {
      return _ref42.apply(this, arguments);
    };
  }();

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$initialValue3 = options.initialValue,
      initialValue = _options$initialValue3 === undefined ? "" : _options$initialValue3;

  var isSupported = useSupported(function () {
    return typeof window !== "undefined" && "EyeDropper" in window;
  });
  var sRGBHex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(initialValue);

  return { isSupported: isSupported, sRGBHex: sRGBHex, open: open };
}

function useFavicon() {
  var newIcon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$baseUrl = options.baseUrl,
      baseUrl = _options$baseUrl === undefined ? "" : _options$baseUrl,
      _options$rel = options.rel,
      rel = _options$rel === undefined ? "icon" : _options$rel,
      _options$document3 = options.document,
      document = _options$document3 === undefined ? defaultDocument : _options$document3;

  var favicon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["m" /* toRef */])(newIcon);
  var applyIcon = function applyIcon(icon) {
    document == null ? void 0 : document.head.querySelectorAll('link[rel*="' + rel + '"]').forEach(function (el) {
      return el.href = '' + baseUrl + icon;
    });
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(favicon, function (i, o) {
    if (typeof i === "string" && i !== o) applyIcon(i);
  }, { immediate: true });
  return favicon;
}

var __defProp$e = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __defProps$5 = __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$5 = __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$f = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$f = Object.prototype.hasOwnProperty;
var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = function __defNormalProp$e(obj, key, value) {
  return key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$e = function __spreadValues$e(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$f.call(b, prop)) __defNormalProp$e(a, prop, b[prop]);
  }if (__getOwnPropSymbols$f) {
    var _iteratorNormalCompletion21 = true;
    var _didIteratorError21 = false;
    var _iteratorError21 = undefined;

    try {
      for (var _iterator21 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$f(b)), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
        var prop = _step21.value;

        if (__propIsEnum$f.call(b, prop)) __defNormalProp$e(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError21 = true;
      _iteratorError21 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion21 && _iterator21.return) {
          _iterator21.return();
        }
      } finally {
        if (_didIteratorError21) {
          throw _iteratorError21;
        }
      }
    }
  }return a;
};
var __spreadProps$5 = function __spreadProps$5(a, b) {
  return __defProps$5(a, __getOwnPropDescs$5(b));
};
var payloadMapping = {
  json: "application/json",
  text: "text/plain"
};
function isFetchOptions(obj) {
  return obj && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["C" /* containsProp */])(obj, "immediate", "refetch", "initialData", "timeout", "beforeFetch", "afterFetch", "onFetchError", "fetch");
}
function isAbsoluteURL(url) {
  return (/^([a-z][a-z\d+\-.]*:)?\/\//i.test(url)
  );
}
function headersToObject(headers) {
  if (typeof Headers !== "undefined" && headers instanceof Headers) return Object.fromEntries([].concat(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray___default()(headers.entries())));
  return headers;
}
function combineCallbacks(combination) {
  var _this3 = this;

  for (var _len5 = arguments.length, callbacks = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    callbacks[_key5 - 1] = arguments[_key5];
  }

  if (combination === "overwrite") {
    return function () {
      var _ref43 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee13(ctx) {
        var callback;
        return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                callback = callbacks[callbacks.length - 1];

                if (!callback) {
                  _context13.next = 8;
                  break;
                }

                _context13.t0 = __spreadValues$e;
                _context13.t1 = __spreadValues$e({}, ctx);
                _context13.next = 6;
                return callback(ctx);

              case 6:
                _context13.t2 = _context13.sent;
                return _context13.abrupt('return', (0, _context13.t0)(_context13.t1, _context13.t2));

              case 8:
                return _context13.abrupt('return', ctx);

              case 9:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this3);
      }));

      return function (_x55) {
        return _ref43.apply(this, arguments);
      };
    }();
  } else {
    return function () {
      var _ref44 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee14(ctx) {
        var _iteratorNormalCompletion22, _didIteratorError22, _iteratorError22, _iterator22, _step22, callback;

        return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _iteratorNormalCompletion22 = true;
                _didIteratorError22 = false;
                _iteratorError22 = undefined;
                _context14.prev = 3;
                _iterator22 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(callbacks);

              case 5:
                if (_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done) {
                  _context14.next = 17;
                  break;
                }

                callback = _step22.value;

                if (!callback) {
                  _context14.next = 14;
                  break;
                }

                _context14.t0 = __spreadValues$e;
                _context14.t1 = __spreadValues$e({}, ctx);
                _context14.next = 12;
                return callback(ctx);

              case 12:
                _context14.t2 = _context14.sent;
                ctx = (0, _context14.t0)(_context14.t1, _context14.t2);

              case 14:
                _iteratorNormalCompletion22 = true;
                _context14.next = 5;
                break;

              case 17:
                _context14.next = 23;
                break;

              case 19:
                _context14.prev = 19;
                _context14.t3 = _context14['catch'](3);
                _didIteratorError22 = true;
                _iteratorError22 = _context14.t3;

              case 23:
                _context14.prev = 23;
                _context14.prev = 24;

                if (!_iteratorNormalCompletion22 && _iterator22.return) {
                  _iterator22.return();
                }

              case 26:
                _context14.prev = 26;

                if (!_didIteratorError22) {
                  _context14.next = 29;
                  break;
                }

                throw _iteratorError22;

              case 29:
                return _context14.finish(26);

              case 30:
                return _context14.finish(23);

              case 31:
                return _context14.abrupt('return', ctx);

              case 32:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this3, [[3, 19, 23, 31], [24,, 26, 30]]);
      }));

      return function (_x56) {
        return _ref44.apply(this, arguments);
      };
    }();
  }
}
function createFetch() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _combination = config.combination || "chain";
  var _options = config.options || {};
  var _fetchOptions = config.fetchOptions || {};
  function useFactoryFetch(url) {
    var computedUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
      var baseUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(config.baseUrl);
      var targetUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(url);
      return baseUrl && !isAbsoluteURL(targetUrl) ? joinPaths(baseUrl, targetUrl) : targetUrl;
    });
    var options = _options;
    var fetchOptions = _fetchOptions;

    for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      args[_key6 - 1] = arguments[_key6];
    }

    if (args.length > 0) {
      if (isFetchOptions(args[0])) {
        options = __spreadProps$5(__spreadValues$e(__spreadValues$e({}, options), args[0]), {
          beforeFetch: combineCallbacks(_combination, _options.beforeFetch, args[0].beforeFetch),
          afterFetch: combineCallbacks(_combination, _options.afterFetch, args[0].afterFetch),
          onFetchError: combineCallbacks(_combination, _options.onFetchError, args[0].onFetchError)
        });
      } else {
        fetchOptions = __spreadProps$5(__spreadValues$e(__spreadValues$e({}, fetchOptions), args[0]), {
          headers: __spreadValues$e(__spreadValues$e({}, headersToObject(fetchOptions.headers) || {}), headersToObject(args[0].headers) || {})
        });
      }
    }
    if (args.length > 1 && isFetchOptions(args[1])) {
      options = __spreadProps$5(__spreadValues$e(__spreadValues$e({}, options), args[1]), {
        beforeFetch: combineCallbacks(_combination, _options.beforeFetch, args[1].beforeFetch),
        afterFetch: combineCallbacks(_combination, _options.afterFetch, args[1].afterFetch),
        onFetchError: combineCallbacks(_combination, _options.onFetchError, args[1].onFetchError)
      });
    }
    return useFetch(computedUrl, fetchOptions, options);
  }
  return useFactoryFetch;
}
function useFetch(url) {
  var _this4 = this;

  var _a;
  var supportsAbort = typeof AbortController === "function";
  var fetchOptions = {};
  var options = { immediate: true, refetch: false, timeout: 0 };
  var config = {
    method: "GET",
    type: "text",
    payload: void 0
  };
  if ((arguments.length <= 1 ? 0 : arguments.length - 1) > 0) {
    if (isFetchOptions(arguments.length <= 1 ? undefined : arguments[1])) options = __spreadValues$e(__spreadValues$e({}, options), arguments.length <= 1 ? undefined : arguments[1]);else fetchOptions = arguments.length <= 1 ? undefined : arguments[1];
  }
  if ((arguments.length <= 1 ? 0 : arguments.length - 1) > 1) {
    if (isFetchOptions(arguments.length <= 2 ? undefined : arguments[2])) options = __spreadValues$e(__spreadValues$e({}, options), arguments.length <= 2 ? undefined : arguments[2]);
  }
  var _options4 = options,
      _options4$fetch = _options4.fetch,
      fetch = _options4$fetch === undefined ? (_a = defaultWindow) == null ? void 0 : _a.fetch : _options4$fetch,
      initialData = _options4.initialData,
      timeout = _options4.timeout;

  var responseEvent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["r" /* createEventHook */])();
  var errorEvent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["r" /* createEventHook */])();
  var finallyEvent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["r" /* createEventHook */])();
  var isFinished = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var isFetching = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var aborted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var statusCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  var response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(null);
  var error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(null);
  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(initialData || null);
  var canAbort = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return supportsAbort && isFetching.value;
  });
  var controller = void 0;
  var timer = void 0;
  var abort = function abort() {
    if (supportsAbort) {
      controller == null ? void 0 : controller.abort();
      controller = new AbortController();
      controller.signal.onabort = function () {
        return aborted.value = true;
      };
      fetchOptions = __spreadProps$5(__spreadValues$e({}, fetchOptions), {
        signal: controller.signal
      });
    }
  };
  var loading = function loading(isLoading) {
    isFetching.value = isLoading;
    isFinished.value = !isLoading;
  };
  if (timeout) timer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["p" /* useTimeoutFn */])(abort, timeout, { immediate: false });
  var execute = function () {
    var _ref45 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee17() {
      var throwOnFailed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var _a2, defaultFetchOptions, headers, payload, isCanceled, context, responseData;

      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              abort();
              loading(true);
              error.value = null;
              statusCode.value = null;
              aborted.value = false;
              defaultFetchOptions = {
                method: config.method,
                headers: {}
              };

              if (config.payload) {
                headers = headersToObject(defaultFetchOptions.headers);

                if (config.payloadType) headers["Content-Type"] = (_a2 = payloadMapping[config.payloadType]) != null ? _a2 : config.payloadType;
                payload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(config.payload);

                defaultFetchOptions.body = config.payloadType === "json" ? __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify___default()(payload) : payload;
              }
              isCanceled = false;
              context = {
                url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(url),
                options: __spreadValues$e(__spreadValues$e({}, defaultFetchOptions), fetchOptions),
                cancel: function cancel() {
                  isCanceled = true;
                }
              };

              if (!options.beforeFetch) {
                _context17.next = 16;
                break;
              }

              _context17.t0 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default.a;
              _context17.t1 = context;
              _context17.next = 14;
              return options.beforeFetch(context);

            case 14:
              _context17.t2 = _context17.sent;
              (0, _context17.t0)(_context17.t1, _context17.t2);

            case 16:
              if (!(isCanceled || !fetch)) {
                _context17.next = 19;
                break;
              }

              loading(false);
              return _context17.abrupt('return', __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a.resolve(null));

            case 19:
              responseData = null;

              if (timer) timer.start();
              return _context17.abrupt('return', new __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var _a3;
                fetch(context.url, __spreadProps$5(__spreadValues$e(__spreadValues$e({}, defaultFetchOptions), context.options), {
                  headers: __spreadValues$e(__spreadValues$e({}, headersToObject(defaultFetchOptions.headers)), headersToObject((_a3 = context.options) == null ? void 0 : _a3.headers))
                })).then(function () {
                  var _ref46 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee15(fetchResponse) {
                    var _ref47;

                    return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
                      while (1) {
                        switch (_context15.prev = _context15.next) {
                          case 0:
                            response.value = fetchResponse;
                            statusCode.value = fetchResponse.status;
                            _context15.next = 4;
                            return fetchResponse[config.type]();

                          case 4:
                            responseData = _context15.sent;

                            if (fetchResponse.ok) {
                              _context15.next = 8;
                              break;
                            }

                            data.value = initialData || null;
                            throw new Error(fetchResponse.statusText);

                          case 8:
                            if (!options.afterFetch) {
                              _context15.next = 14;
                              break;
                            }

                            ;
                            _context15.next = 12;
                            return options.afterFetch({ data: responseData, response: fetchResponse });

                          case 12:
                            _ref47 = _context15.sent;
                            responseData = _ref47.data;

                          case 14:
                            data.value = responseData;
                            responseEvent.trigger(fetchResponse);
                            return _context15.abrupt('return', resolve(fetchResponse));

                          case 17:
                          case 'end':
                            return _context15.stop();
                        }
                      }
                    }, _callee15, _this4);
                  }));

                  return function (_x59) {
                    return _ref46.apply(this, arguments);
                  };
                }()).catch(function () {
                  var _ref48 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee16(fetchError) {
                    var errorData, _ref49;

                    return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
                      while (1) {
                        switch (_context16.prev = _context16.next) {
                          case 0:
                            errorData = fetchError.message || fetchError.name;

                            if (!options.onFetchError) {
                              _context16.next = 7;
                              break;
                            }

                            ;
                            _context16.next = 5;
                            return options.onFetchError({ data: responseData, error: fetchError, response: response.value });

                          case 5:
                            _ref49 = _context16.sent;
                            errorData = _ref49.error;

                          case 7:
                            error.value = errorData;
                            errorEvent.trigger(fetchError);

                            if (!throwOnFailed) {
                              _context16.next = 11;
                              break;
                            }

                            return _context16.abrupt('return', reject(fetchError));

                          case 11:
                            return _context16.abrupt('return', resolve(null));

                          case 12:
                          case 'end':
                            return _context16.stop();
                        }
                      }
                    }, _callee16, _this4);
                  }));

                  return function (_x60) {
                    return _ref48.apply(this, arguments);
                  };
                }()).finally(function () {
                  loading(false);
                  if (timer) timer.stop();
                  finallyEvent.trigger(null);
                });
              }));

            case 22:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this4);
    }));

    return function execute() {
      return _ref45.apply(this, arguments);
    };
  }();
  var refetch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["m" /* toRef */])(options.refetch);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])([refetch, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["m" /* toRef */])(url)], function (_ref50) {
    var _ref51 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref50, 1),
        refetch2 = _ref51[0];

    return refetch2 && execute();
  }, { deep: true });
  var shell = {
    isFinished: isFinished,
    statusCode: statusCode,
    response: response,
    error: error,
    data: data,
    isFetching: isFetching,
    canAbort: canAbort,
    aborted: aborted,
    abort: abort,
    execute: execute,
    onFetchResponse: responseEvent.on,
    onFetchError: errorEvent.on,
    onFetchFinally: finallyEvent.on,

    get: setMethod("GET"),
    put: setMethod("PUT"),
    post: setMethod("POST"),
    delete: setMethod("DELETE"),
    patch: setMethod("PATCH"),
    head: setMethod("HEAD"),
    options: setMethod("OPTIONS"),

    json: setType("json"),
    text: setType("text"),
    blob: setType("blob"),
    arrayBuffer: setType("arrayBuffer"),
    formData: setType("formData")
  };
  function setMethod(method) {
    return function (payload, payloadType) {
      if (!isFetching.value) {
        config.method = method;
        config.payload = payload;
        config.payloadType = payloadType;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["a" /* isRef */])(config.payload)) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])([refetch, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["m" /* toRef */])(config.payload)], function (_ref52) {
            var _ref53 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref52, 1),
                refetch2 = _ref53[0];

            return refetch2 && execute();
          }, { deep: true });
        }
        var rawPayload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(config.payload);
        if (!payloadType && rawPayload && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(rawPayload) === Object.prototype && !(rawPayload instanceof FormData)) config.payloadType = "json";
        return __spreadProps$5(__spreadValues$e({}, shell), {
          then: function then(onFulfilled, onRejected) {
            return waitUntilFinished().then(onFulfilled, onRejected);
          }
        });
      }
      return void 0;
    };
  }
  function waitUntilFinished() {
    return new __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["l" /* until */])(isFinished).toBe(true).then(function () {
        return resolve(shell);
      }).catch(function (error2) {
        return reject(error2);
      });
    });
  }
  function setType(type) {
    return function () {
      if (!isFetching.value) {
        config.type = type;
        return __spreadProps$5(__spreadValues$e({}, shell), {
          then: function then(onFulfilled, onRejected) {
            return waitUntilFinished().then(onFulfilled, onRejected);
          }
        });
      }
      return void 0;
    };
  }
  if (options.immediate) __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a.resolve().then(function () {
    return execute();
  });
  return __spreadProps$5(__spreadValues$e({}, shell), {
    then: function then(onFulfilled, onRejected) {
      return waitUntilFinished().then(onFulfilled, onRejected);
    }
  });
}
function joinPaths(start, end) {
  if (!start.endsWith("/") && !end.startsWith("/")) return start + '/' + end;
  return '' + start + end;
}

var __defProp$d = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __getOwnPropSymbols$e = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$e = Object.prototype.hasOwnProperty;
var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = function __defNormalProp$d(obj, key, value) {
  return key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$d = function __spreadValues$d(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$e.call(b, prop)) __defNormalProp$d(a, prop, b[prop]);
  }if (__getOwnPropSymbols$e) {
    var _iteratorNormalCompletion23 = true;
    var _didIteratorError23 = false;
    var _iteratorError23 = undefined;

    try {
      for (var _iterator23 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$e(b)), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
        var prop = _step23.value;

        if (__propIsEnum$e.call(b, prop)) __defNormalProp$d(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError23 = true;
      _iteratorError23 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion23 && _iterator23.return) {
          _iterator23.return();
        }
      } finally {
        if (_didIteratorError23) {
          throw _iteratorError23;
        }
      }
    }
  }return a;
};
var DEFAULT_OPTIONS = {
  multiple: true,
  accept: "*",
  reset: false
};
function useFileDialog() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$document4 = options.document,
      document = _options$document4 === undefined ? defaultDocument : _options$document4;

  var files = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);

  var _createEventHook = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["r" /* createEventHook */])(),
      onChange = _createEventHook.on,
      trigger = _createEventHook.trigger;

  var input = void 0;
  if (document) {
    input = document.createElement("input");
    input.type = "file";
    input.onchange = function (event) {
      var result = event.target;
      files.value = result.files;
      trigger(files.value);
    };
  }
  var reset = function reset() {
    files.value = null;
    if (input) input.value = "";
  };
  var open = function open(localOptions) {
    if (!input) return;
    var _options = __spreadValues$d(__spreadValues$d(__spreadValues$d({}, DEFAULT_OPTIONS), options), localOptions);
    input.multiple = _options.multiple;
    input.accept = _options.accept;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["D" /* hasOwn */])(_options, "capture")) input.capture = _options.capture;
    if (_options.reset) reset();
    input.click();
  };
  return {
    files: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["s" /* readonly */])(files),
    open: open,
    reset: reset,
    onChange: onChange
  };
}

var __defProp$c = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __getOwnPropSymbols$d = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = function __defNormalProp$c(obj, key, value) {
  return key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$c = function __spreadValues$c(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$d.call(b, prop)) __defNormalProp$c(a, prop, b[prop]);
  }if (__getOwnPropSymbols$d) {
    var _iteratorNormalCompletion24 = true;
    var _didIteratorError24 = false;
    var _iteratorError24 = undefined;

    try {
      for (var _iterator24 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$d(b)), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
        var prop = _step24.value;

        if (__propIsEnum$d.call(b, prop)) __defNormalProp$c(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError24 = true;
      _iteratorError24 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion24 && _iterator24.return) {
          _iterator24.return();
        }
      } finally {
        if (_didIteratorError24) {
          throw _iteratorError24;
        }
      }
    }
  }return a;
};
function useFileSystemAccess() {
  var open = function () {
    var _ref54 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee18() {
      var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref55, _ref56, handle;

      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              if (isSupported.value) {
                _context18.next = 2;
                break;
              }

              return _context18.abrupt('return');

            case 2:
              _context18.next = 4;
              return window.showOpenFilePicker(__spreadValues$c(__spreadValues$c({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(options)), _options));

            case 4:
              _ref55 = _context18.sent;
              _ref56 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref55, 1);
              handle = _ref56[0];

              fileHandle.value = handle;
              _context18.next = 10;
              return updateFile();

            case 10:
              _context18.next = 12;
              return updateData();

            case 12:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, this);
    }));

    return function open() {
      return _ref54.apply(this, arguments);
    };
  }();

  var create = function () {
    var _ref57 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee19() {
      var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              if (isSupported.value) {
                _context19.next = 2;
                break;
              }

              return _context19.abrupt('return');

            case 2:
              _context19.next = 4;
              return window.showSaveFilePicker(__spreadValues$c(__spreadValues$c({}, options), _options));

            case 4:
              fileHandle.value = _context19.sent;

              data.value = void 0;
              _context19.next = 8;
              return updateFile();

            case 8:
              _context19.next = 10;
              return updateData();

            case 10:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, this);
    }));

    return function create() {
      return _ref57.apply(this, arguments);
    };
  }();

  var save = function () {
    var _ref58 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee20() {
      var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var writableStream;
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              if (isSupported.value) {
                _context20.next = 2;
                break;
              }

              return _context20.abrupt('return');

            case 2:
              if (fileHandle.value) {
                _context20.next = 4;
                break;
              }

              return _context20.abrupt('return', saveAs(_options));

            case 4:
              if (!data.value) {
                _context20.next = 12;
                break;
              }

              _context20.next = 7;
              return fileHandle.value.createWritable();

            case 7:
              writableStream = _context20.sent;
              _context20.next = 10;
              return writableStream.write(data.value);

            case 10:
              _context20.next = 12;
              return writableStream.close();

            case 12:
              _context20.next = 14;
              return updateFile();

            case 14:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, this);
    }));

    return function save() {
      return _ref58.apply(this, arguments);
    };
  }();

  var saveAs = function () {
    var _ref59 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee21() {
      var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var writableStream;
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              if (isSupported.value) {
                _context21.next = 2;
                break;
              }

              return _context21.abrupt('return');

            case 2:
              _context21.next = 4;
              return window.showSaveFilePicker(__spreadValues$c(__spreadValues$c({}, options), _options));

            case 4:
              fileHandle.value = _context21.sent;

              if (!data.value) {
                _context21.next = 13;
                break;
              }

              _context21.next = 8;
              return fileHandle.value.createWritable();

            case 8:
              writableStream = _context21.sent;
              _context21.next = 11;
              return writableStream.write(data.value);

            case 11:
              _context21.next = 13;
              return writableStream.close();

            case 13:
              _context21.next = 15;
              return updateFile();

            case 15:
            case 'end':
              return _context21.stop();
          }
        }
      }, _callee21, this);
    }));

    return function saveAs() {
      return _ref59.apply(this, arguments);
    };
  }();

  var updateFile = function () {
    var _ref60 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee22() {
      var _a;

      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return (_a = fileHandle.value) == null ? void 0 : _a.getFile();

            case 2:
              file.value = _context22.sent;

            case 3:
            case 'end':
              return _context22.stop();
          }
        }
      }, _callee22, this);
    }));

    return function updateFile() {
      return _ref60.apply(this, arguments);
    };
  }();

  var updateData = function () {
    var _ref61 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee23() {
      var _a, _b, type;

      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(dataType);

              if (!(type === "Text")) {
                _context23.next = 7;
                break;
              }

              _context23.next = 4;
              return (_a = file.value) == null ? void 0 : _a.text();

            case 4:
              data.value = _context23.sent;
              _context23.next = 14;
              break;

            case 7:
              if (!(type === "ArrayBuffer")) {
                _context23.next = 13;
                break;
              }

              _context23.next = 10;
              return (_b = file.value) == null ? void 0 : _b.arrayBuffer();

            case 10:
              data.value = _context23.sent;
              _context23.next = 14;
              break;

            case 13:
              if (type === "Blob") data.value = file.value;

            case 14:
            case 'end':
              return _context23.stop();
          }
        }
      }, _callee23, this);
    }));

    return function updateData() {
      return _ref61.apply(this, arguments);
    };
  }();

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$window15 = options.window,
      _window = _options$window15 === undefined ? defaultWindow : _options$window15,
      _options$dataType = options.dataType,
      dataType = _options$dataType === undefined ? "Text" : _options$dataType;

  var window = _window;
  var isSupported = useSupported(function () {
    return window && "showSaveFilePicker" in window && "showOpenFilePicker" in window;
  });
  var fileHandle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  var file = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  var fileName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    var _a, _b;
    return (_b = (_a = file.value) == null ? void 0 : _a.name) != null ? _b : "";
  });
  var fileMIME = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    var _a, _b;
    return (_b = (_a = file.value) == null ? void 0 : _a.type) != null ? _b : "";
  });
  var fileSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    var _a, _b;
    return (_b = (_a = file.value) == null ? void 0 : _a.size) != null ? _b : 0;
  });
  var fileLastModified = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    var _a, _b;
    return (_b = (_a = file.value) == null ? void 0 : _a.lastModified) != null ? _b : 0;
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(dataType);
  }, updateData);
  return {
    isSupported: isSupported,
    data: data,
    file: file,
    fileName: fileName,
    fileMIME: fileMIME,
    fileSize: fileSize,
    fileLastModified: fileLastModified,
    open: open,
    create: create,
    save: save,
    saveAs: saveAs,
    updateData: updateData
  };
}

function useFocus(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$initialValue4 = options.initialValue,
      initialValue = _options$initialValue4 === undefined ? false : _options$initialValue4;

  var innerFocused = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var targetElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return unrefElement(target);
  });
  useEventListener(targetElement, "focus", function () {
    return innerFocused.value = true;
  });
  useEventListener(targetElement, "blur", function () {
    return innerFocused.value = false;
  });
  var focused = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])({
    get: function get() {
      return innerFocused.value;
    },
    set: function set(value) {
      var _a, _b;
      if (!value && innerFocused.value) (_a = targetElement.value) == null ? void 0 : _a.blur();else if (value && !innerFocused.value) (_b = targetElement.value) == null ? void 0 : _b.focus();
    }
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(targetElement, function () {
    focused.value = initialValue;
  }, { immediate: true, flush: "post" });
  return { focused: focused };
}

function useFocusWithin(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var activeElement = useActiveElement(options);
  var targetElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return unrefElement(target);
  });
  var focused = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return targetElement.value && activeElement.value ? targetElement.value.contains(activeElement.value) : false;
  });
  return { focused: focused };
}

function useFps(options) {
  var _a;
  var fps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  if (typeof performance === "undefined") return fps;
  var every = (_a = options == null ? void 0 : options.every) != null ? _a : 10;
  var last = performance.now();
  var ticks = 0;
  useRafFn(function () {
    ticks += 1;
    if (ticks >= every) {
      var now = performance.now();
      var diff = now - last;
      fps.value = Math.round(1e3 / (diff / ticks));
      last = now;
      ticks = 0;
    }
  });
  return fps;
}

var eventHandlers = ["fullscreenchange", "webkitfullscreenchange", "webkitendfullscreen", "mozfullscreenchange", "MSFullscreenChange"];
function useFullscreen(target) {
  var exit = function () {
    var _ref62 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee24() {
      var target2;
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              if (isSupported.value) {
                _context24.next = 2;
                break;
              }

              return _context24.abrupt('return');

            case 2:
              if (!exitMethod.value) {
                _context24.next = 12;
                break;
              }

              if (!((document == null ? void 0 : document[exitMethod.value]) != null)) {
                _context24.next = 8;
                break;
              }

              _context24.next = 6;
              return document[exitMethod.value]();

            case 6:
              _context24.next = 12;
              break;

            case 8:
              target2 = targetRef.value;

              if (!((target2 == null ? void 0 : target2[exitMethod.value]) != null)) {
                _context24.next = 12;
                break;
              }

              _context24.next = 12;
              return target2[exitMethod.value]();

            case 12:
              isFullscreen.value = false;

            case 13:
            case 'end':
              return _context24.stop();
          }
        }
      }, _callee24, this);
    }));

    return function exit() {
      return _ref62.apply(this, arguments);
    };
  }();

  var enter = function () {
    var _ref63 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee25() {
      var target2;
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              if (isSupported.value) {
                _context25.next = 2;
                break;
              }

              return _context25.abrupt('return');

            case 2:
              if (!isElementFullScreen()) {
                _context25.next = 5;
                break;
              }

              _context25.next = 5;
              return exit();

            case 5:
              target2 = targetRef.value;

              if (!(requestMethod.value && (target2 == null ? void 0 : target2[requestMethod.value]) != null)) {
                _context25.next = 10;
                break;
              }

              _context25.next = 9;
              return target2[requestMethod.value]();

            case 9:
              isFullscreen.value = true;

            case 10:
            case 'end':
              return _context25.stop();
          }
        }
      }, _callee25, this);
    }));

    return function enter() {
      return _ref63.apply(this, arguments);
    };
  }();

  var toggle = function () {
    var _ref64 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee26() {
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return isFullscreen.value ? exit() : enter();

            case 2:
            case 'end':
              return _context26.stop();
          }
        }
      }, _callee26, this);
    }));

    return function toggle() {
      return _ref64.apply(this, arguments);
    };
  }();

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$document5 = options.document,
      document = _options$document5 === undefined ? defaultDocument : _options$document5,
      _options$autoExit = options.autoExit,
      autoExit = _options$autoExit === undefined ? false : _options$autoExit;

  var targetRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    var _a;
    return (_a = unrefElement(target)) != null ? _a : document == null ? void 0 : document.querySelector("html");
  });
  var isFullscreen = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var requestMethod = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return ["requestFullscreen", "webkitRequestFullscreen", "webkitEnterFullscreen", "webkitEnterFullScreen", "webkitRequestFullScreen", "mozRequestFullScreen", "msRequestFullscreen"].find(function (m) {
      return document && m in document || targetRef.value && m in targetRef.value;
    });
  });
  var exitMethod = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return ["exitFullscreen", "webkitExitFullscreen", "webkitExitFullScreen", "webkitCancelFullScreen", "mozCancelFullScreen", "msExitFullscreen"].find(function (m) {
      return document && m in document || targetRef.value && m in targetRef.value;
    });
  });
  var fullscreenEnabled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return ["fullScreen", "webkitIsFullScreen", "webkitDisplayingFullscreen", "mozFullScreen", "msFullscreenElement"].find(function (m) {
      return document && m in document || targetRef.value && m in targetRef.value;
    });
  });
  var fullscreenElementMethod = ["fullscreenElement", "webkitFullscreenElement", "mozFullScreenElement", "msFullscreenElement"].find(function (m) {
    return document && m in document;
  });
  var isSupported = useSupported(function () {
    return targetRef.value && document && requestMethod.value !== void 0 && exitMethod.value !== void 0 && fullscreenEnabled.value !== void 0;
  });
  var isCurrentElementFullScreen = function isCurrentElementFullScreen() {
    if (fullscreenElementMethod) return (document == null ? void 0 : document[fullscreenElementMethod]) === targetRef.value;
    return false;
  };
  var isElementFullScreen = function isElementFullScreen() {
    if (fullscreenEnabled.value) {
      if (document && document[fullscreenEnabled.value] != null) {
        return document[fullscreenEnabled.value];
      } else {
        var target2 = targetRef.value;
        if ((target2 == null ? void 0 : target2[fullscreenEnabled.value]) != null) {
          return Boolean(target2[fullscreenEnabled.value]);
        }
      }
    }
    return false;
  };

  var handlerCallback = function handlerCallback() {
    var isElementFullScreenValue = isElementFullScreen();
    if (!isElementFullScreenValue || isElementFullScreenValue && isCurrentElementFullScreen()) isFullscreen.value = isElementFullScreenValue;
  };
  useEventListener(document, eventHandlers, handlerCallback, false);
  useEventListener(function () {
    return unrefElement(targetRef);
  }, eventHandlers, handlerCallback, false);
  if (autoExit) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(exit);
  return {
    isSupported: isSupported,
    isFullscreen: isFullscreen,
    enter: enter,
    exit: exit,
    toggle: toggle
  };
}

var __defProp$b = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __defProps$4 = __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$4 = __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$c = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = function __defNormalProp$b(obj, key, value) {
  return key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$b = function __spreadValues$b(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$c.call(b, prop)) __defNormalProp$b(a, prop, b[prop]);
  }if (__getOwnPropSymbols$c) {
    var _iteratorNormalCompletion25 = true;
    var _didIteratorError25 = false;
    var _iteratorError25 = undefined;

    try {
      for (var _iterator25 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$c(b)), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
        var prop = _step25.value;

        if (__propIsEnum$c.call(b, prop)) __defNormalProp$b(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError25 = true;
      _iteratorError25 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion25 && _iterator25.return) {
          _iterator25.return();
        }
      } finally {
        if (_didIteratorError25) {
          throw _iteratorError25;
        }
      }
    }
  }return a;
};
var __spreadProps$4 = function __spreadProps$4(a, b) {
  return __defProps$4(a, __getOwnPropDescs$4(b));
};
function mapGamepadToXbox360Controller(gamepad) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    if (gamepad.value) {
      return {
        buttons: {
          a: gamepad.value.buttons[0],
          b: gamepad.value.buttons[1],
          x: gamepad.value.buttons[2],
          y: gamepad.value.buttons[3]
        },
        bumper: {
          left: gamepad.value.buttons[4],
          right: gamepad.value.buttons[5]
        },
        triggers: {
          left: gamepad.value.buttons[6],
          right: gamepad.value.buttons[7]
        },
        stick: {
          left: {
            horizontal: gamepad.value.axes[0],
            vertical: gamepad.value.axes[1],
            button: gamepad.value.buttons[10]
          },
          right: {
            horizontal: gamepad.value.axes[2],
            vertical: gamepad.value.axes[3],
            button: gamepad.value.buttons[11]
          }
        },
        dpad: {
          up: gamepad.value.buttons[12],
          down: gamepad.value.buttons[13],
          left: gamepad.value.buttons[14],
          right: gamepad.value.buttons[15]
        },
        back: gamepad.value.buttons[8],
        start: gamepad.value.buttons[9]
      };
    }
    return null;
  });
}
function useGamepad() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$navigator5 = options.navigator,
      navigator = _options$navigator5 === undefined ? defaultNavigator : _options$navigator5;

  var isSupported = useSupported(function () {
    return navigator && "getGamepads" in navigator;
  });
  var gamepads = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])([]);
  var onConnectedHook = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["r" /* createEventHook */])();
  var onDisconnectedHook = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["r" /* createEventHook */])();
  var stateFromGamepad = function stateFromGamepad(gamepad) {
    var hapticActuators = [];
    var vibrationActuator = "vibrationActuator" in gamepad ? gamepad.vibrationActuator : null;
    if (vibrationActuator) hapticActuators.push(vibrationActuator);
    if (gamepad.hapticActuators) hapticActuators.push.apply(hapticActuators, __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray___default()(gamepad.hapticActuators));
    return __spreadProps$4(__spreadValues$b({}, gamepad), {
      id: gamepad.id,
      hapticActuators: hapticActuators,
      axes: gamepad.axes.map(function (axes) {
        return axes;
      }),
      buttons: gamepad.buttons.map(function (button) {
        return { pressed: button.pressed, touched: button.touched, value: button.value };
      })
    });
  };
  var updateGamepadState = function updateGamepadState() {
    var _gamepads = (navigator == null ? void 0 : navigator.getGamepads()) || [];

    var _loop3 = function _loop3(i) {
      var gamepad = _gamepads[i];
      if (gamepad) {
        var index = gamepads.value.findIndex(function (_ref65) {
          var index2 = _ref65.index;
          return index2 === gamepad.index;
        });
        if (index > -1) gamepads.value[index] = stateFromGamepad(gamepad);
      }
    };

    for (var i = 0; i < _gamepads.length; ++i) {
      _loop3(i);
    }
  };

  var _useRafFn2 = useRafFn(updateGamepadState),
      isActive = _useRafFn2.isActive,
      pause = _useRafFn2.pause,
      resume = _useRafFn2.resume;

  var onGamepadConnected = function onGamepadConnected(gamepad) {
    if (!gamepads.value.some(function (_ref66) {
      var index = _ref66.index;
      return index === gamepad.index;
    })) {
      gamepads.value.push(stateFromGamepad(gamepad));
      onConnectedHook.trigger(gamepad.index);
    }
    resume();
  };
  var onGamepadDisconnected = function onGamepadDisconnected(gamepad) {
    gamepads.value = gamepads.value.filter(function (x) {
      return x.index !== gamepad.index;
    });
    onDisconnectedHook.trigger(gamepad.index);
  };
  useEventListener("gamepadconnected", function (e) {
    return onGamepadConnected(e.gamepad);
  });
  useEventListener("gamepaddisconnected", function (e) {
    return onGamepadDisconnected(e.gamepad);
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["g" /* tryOnMounted */])(function () {
    var _gamepads = (navigator == null ? void 0 : navigator.getGamepads()) || [];
    if (_gamepads) {
      for (var i = 0; i < _gamepads.length; ++i) {
        var _gamepad = _gamepads[i];
        if (_gamepad) onGamepadConnected(_gamepad);
      }
    }
  });
  pause();
  return {
    isSupported: isSupported,
    onConnected: onConnectedHook.on,
    onDisconnected: onDisconnectedHook.on,
    gamepads: gamepads,
    pause: pause,
    resume: resume,
    isActive: isActive
  };
}

function useGeolocation() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$enableHighAc = options.enableHighAccuracy,
      enableHighAccuracy = _options$enableHighAc === undefined ? true : _options$enableHighAc,
      _options$maximumAge = options.maximumAge,
      maximumAge = _options$maximumAge === undefined ? 3e4 : _options$maximumAge,
      _options$timeout = options.timeout,
      timeout = _options$timeout === undefined ? 27e3 : _options$timeout,
      _options$navigator6 = options.navigator,
      navigator = _options$navigator6 === undefined ? defaultNavigator : _options$navigator6,
      _options$immediate6 = options.immediate,
      immediate = _options$immediate6 === undefined ? true : _options$immediate6;

  var isSupported = useSupported(function () {
    return navigator && "geolocation" in navigator;
  });
  var locatedAt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  var error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(null);
  var coords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])({
    accuracy: 0,
    latitude: Infinity,
    longitude: Infinity,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    speed: null
  });
  function updatePosition(position) {
    locatedAt.value = position.timestamp;
    coords.value = position.coords;
    error.value = null;
  }
  var watcher = void 0;
  function resume() {
    if (isSupported.value) {
      watcher = navigator.geolocation.watchPosition(updatePosition, function (err) {
        return error.value = err;
      }, {
        enableHighAccuracy: enableHighAccuracy,
        maximumAge: maximumAge,
        timeout: timeout
      });
    }
  }
  if (immediate) resume();
  function pause() {
    if (watcher && navigator) navigator.geolocation.clearWatch(watcher);
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(function () {
    pause();
  });
  return {
    isSupported: isSupported,
    coords: coords,
    locatedAt: locatedAt,
    error: error,
    resume: resume,
    pause: pause
  };
}

var defaultEvents$1 = ["mousemove", "mousedown", "resize", "keydown", "touchstart", "wheel"];
var oneMinute = 6e4;
function useIdle() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : oneMinute;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$initialState = options.initialState,
      initialState = _options$initialState === undefined ? false : _options$initialState,
      _options$listenForVis = options.listenForVisibilityChange,
      listenForVisibilityChange = _options$listenForVis === undefined ? true : _options$listenForVis,
      _options$events = options.events,
      events = _options$events === undefined ? defaultEvents$1 : _options$events,
      _options$window16 = options.window,
      window = _options$window16 === undefined ? defaultWindow : _options$window16,
      _options$eventFilter2 = options.eventFilter,
      eventFilter = _options$eventFilter2 === undefined ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["E" /* throttleFilter */])(50) : _options$eventFilter2;

  var idle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(initialState);
  var lastActive = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["s" /* timestamp */])());
  var timer = void 0;
  var reset = function reset() {
    idle.value = false;
    clearTimeout(timer);
    timer = setTimeout(function () {
      return idle.value = true;
    }, timeout);
  };
  var onEvent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["x" /* createFilterWrapper */])(eventFilter, function () {
    lastActive.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["s" /* timestamp */])();
    reset();
  });
  if (window) {
    var _document2 = window.document;
    var _iteratorNormalCompletion26 = true;
    var _didIteratorError26 = false;
    var _iteratorError26 = undefined;

    try {
      for (var _iterator26 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(events), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
        var event = _step26.value;

        useEventListener(window, event, onEvent, { passive: true });
      }
    } catch (err) {
      _didIteratorError26 = true;
      _iteratorError26 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion26 && _iterator26.return) {
          _iterator26.return();
        }
      } finally {
        if (_didIteratorError26) {
          throw _iteratorError26;
        }
      }
    }

    if (listenForVisibilityChange) {
      useEventListener(_document2, "visibilitychange", function () {
        if (!_document2.hidden) onEvent();
      });
    }
    reset();
  }
  return {
    idle: idle,
    lastActive: lastActive,
    reset: reset
  };
}

var __defProp$a = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __getOwnPropSymbols$b = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = function __defNormalProp$a(obj, key, value) {
  return key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$a = function __spreadValues$a(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$b.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
  }if (__getOwnPropSymbols$b) {
    var _iteratorNormalCompletion27 = true;
    var _didIteratorError27 = false;
    var _iteratorError27 = undefined;

    try {
      for (var _iterator27 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$b(b)), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
        var prop = _step27.value;

        if (__propIsEnum$b.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError27 = true;
      _iteratorError27 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion27 && _iterator27.return) {
          _iterator27.return();
        }
      } finally {
        if (_didIteratorError27) {
          throw _iteratorError27;
        }
      }
    }
  }return a;
};

function useImage(options) {
  var asyncStateOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var state = useAsyncState(function () {
    return loadImage(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(options));
  }, void 0, __spreadValues$a({
    resetOnExecute: true
  }, asyncStateOptions));
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(options);
  }, function () {
    return state.execute(asyncStateOptions.delay);
  }, { deep: true });
  return state;
}

var ARRIVED_STATE_THRESHOLD_PIXELS = 1;
function useScroll(element) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$throttle = options.throttle,
      throttle = _options$throttle === undefined ? 0 : _options$throttle,
      _options$idle = options.idle,
      idle = _options$idle === undefined ? 200 : _options$idle,
      _options$onStop = options.onStop,
      onStop = _options$onStop === undefined ? __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */] : _options$onStop,
      _options$onScroll = options.onScroll,
      onScroll = _options$onScroll === undefined ? __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */] : _options$onScroll,
      _options$offset = options.offset,
      offset = _options$offset === undefined ? {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  } : _options$offset,
      _options$eventListene = options.eventListenerOptions,
      eventListenerOptions = _options$eventListene === undefined ? {
    capture: false,
    passive: true
  } : _options$eventListene,
      _options$behavior = options.behavior,
      behavior = _options$behavior === undefined ? "auto" : _options$behavior;

  var internalX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var internalY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])({
    get: function get() {
      return internalX.value;
    },
    set: function set(x2) {
      scrollTo(x2, void 0);
    }
  });
  var y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])({
    get: function get() {
      return internalY.value;
    },
    set: function set(y2) {
      scrollTo(void 0, y2);
    }
  });
  function scrollTo(_x, _y) {
    var _a, _b, _c;
    var _element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(element);
    if (!_element) return;
    (_c = _element instanceof Document ? document.body : _element) == null ? void 0 : _c.scrollTo({
      top: (_a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(_y)) != null ? _a : y.value,
      left: (_b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(_x)) != null ? _b : x.value,
      behavior: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(behavior)
    });
  }
  var isScrolling = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var arrivedState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])({
    left: true,
    right: false,
    top: true,
    bottom: false
  });
  var directions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])({
    left: false,
    right: false,
    top: false,
    bottom: false
  });
  var onScrollEnd = function onScrollEnd(e) {
    if (!isScrolling.value) return;
    isScrolling.value = false;
    directions.left = false;
    directions.right = false;
    directions.top = false;
    directions.bottom = false;
    onStop(e);
  };
  var onScrollEndDebounced = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["F" /* useDebounceFn */])(onScrollEnd, throttle + idle);
  var setArrivedState = function setArrivedState(target) {
    var el = target === window ? target.document.documentElement : target === document ? target.documentElement : target;

    var _getComputedStyle = getComputedStyle(el),
        display = _getComputedStyle.display,
        flexDirection = _getComputedStyle.flexDirection;

    var scrollLeft = el.scrollLeft;
    directions.left = scrollLeft < internalX.value;
    directions.right = scrollLeft > internalX.value;
    var left = Math.abs(scrollLeft) <= 0 + (offset.left || 0);
    var right = Math.abs(scrollLeft) + el.clientWidth >= el.scrollWidth - (offset.right || 0) - ARRIVED_STATE_THRESHOLD_PIXELS;
    if (display === "flex" && flexDirection === "row-reverse") {
      arrivedState.left = right;
      arrivedState.right = left;
    } else {
      arrivedState.left = left;
      arrivedState.right = right;
    }
    internalX.value = scrollLeft;
    var scrollTop = el.scrollTop;
    if (target === document && !scrollTop) scrollTop = document.body.scrollTop;
    directions.top = scrollTop < internalY.value;
    directions.bottom = scrollTop > internalY.value;
    var top = Math.abs(scrollTop) <= 0 + (offset.top || 0);
    var bottom = Math.abs(scrollTop) + el.clientHeight >= el.scrollHeight - (offset.bottom || 0) - ARRIVED_STATE_THRESHOLD_PIXELS;
    if (display === "flex" && flexDirection === "column-reverse") {
      arrivedState.top = bottom;
      arrivedState.bottom = top;
    } else {
      arrivedState.top = top;
      arrivedState.bottom = bottom;
    }
    internalY.value = scrollTop;
  };
  var onScrollHandler = function onScrollHandler(e) {
    var eventTarget = e.target === document ? e.target.documentElement : e.target;
    setArrivedState(eventTarget);
    isScrolling.value = true;
    onScrollEndDebounced(e);
    onScroll(e);
  };
  useEventListener(element, "scroll", throttle ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["G" /* useThrottleFn */])(onScrollHandler, throttle, true, false) : onScrollHandler, eventListenerOptions);
  useEventListener(element, "scrollend", onScrollEnd, eventListenerOptions);
  return {
    x: x,
    y: y,
    isScrolling: isScrolling,
    arrivedState: arrivedState,
    directions: directions,
    measure: function measure() {
      var _element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(element);
      if (_element) setArrivedState(_element);
    }
  };
}

var __defProp$9 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __defProps$3 = __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$3 = __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$a = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = function __defNormalProp$9(obj, key, value) {
  return key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$9 = function __spreadValues$9(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$a.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
  }if (__getOwnPropSymbols$a) {
    var _iteratorNormalCompletion28 = true;
    var _didIteratorError28 = false;
    var _iteratorError28 = undefined;

    try {
      for (var _iterator28 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$a(b)), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
        var prop = _step28.value;

        if (__propIsEnum$a.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError28 = true;
      _iteratorError28 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion28 && _iterator28.return) {
          _iterator28.return();
        }
      } finally {
        if (_didIteratorError28) {
          throw _iteratorError28;
        }
      }
    }
  }return a;
};
var __spreadProps$3 = function __spreadProps$3(a, b) {
  return __defProps$3(a, __getOwnPropDescs$3(b));
};
function useInfiniteScroll(element, onLoadMore) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _a;
  var _options$direction = options.direction,
      direction = _options$direction === undefined ? "bottom" : _options$direction,
      _options$interval2 = options.interval,
      interval = _options$interval2 === undefined ? 100 : _options$interval2;

  var state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])(useScroll(element, __spreadProps$3(__spreadValues$9({}, options), {
    offset: __spreadValues$9(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, direction, (_a = options.distance) != null ? _a : 0), options.offset)
  })));
  var promise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  var isLoading = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return !!promise.value;
  });
  function checkAndLoad() {
    state.measure();
    var el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(element);
    if (!el) return;
    var isNarrower = direction === "bottom" || direction === "top" ? el.scrollHeight <= el.clientHeight : el.scrollWidth <= el.clientWidth;
    if (state.arrivedState[direction] || isNarrower) {
      if (!promise.value) {
        promise.value = __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a.all([onLoadMore(state), new __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a(function (resolve) {
          return setTimeout(resolve, interval);
        })]).finally(function () {
          promise.value = null;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["t" /* nextTick */])(function () {
            return checkAndLoad();
          });
        });
      }
    }
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(function () {
    return [state.arrivedState[direction], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(element)];
  }, checkAndLoad, { immediate: true });
  return {
    isLoading: isLoading
  };
}

var defaultEvents = ["mousedown", "mouseup", "keydown", "keyup"];
function useKeyModifier(modifier) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$events2 = options.events,
      events = _options$events2 === undefined ? defaultEvents : _options$events2,
      _options$document6 = options.document,
      document = _options$document6 === undefined ? defaultDocument : _options$document6,
      _options$initial = options.initial,
      initial = _options$initial === undefined ? null : _options$initial;

  var state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(initial);
  if (document) {
    events.forEach(function (listenerEvent) {
      useEventListener(document, listenerEvent, function (evt) {
        if (typeof evt.getModifierState === "function") state.value = evt.getModifierState(modifier);
      });
    });
  }
  return state;
}

function useLocalStorage(key, initialValue) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$window17 = options.window,
      window = _options$window17 === undefined ? defaultWindow : _options$window17;

  return useStorage(key, initialValue, window == null ? void 0 : window.localStorage, options);
}

var DefaultMagicKeysAliasMap = {
  ctrl: "control",
  command: "meta",
  cmd: "meta",
  option: "alt",
  up: "arrowup",
  down: "arrowdown",
  left: "arrowleft",
  right: "arrowright"
};

function useMagicKeys() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$reactive = options.reactive,
      useReactive = _options$reactive === undefined ? false : _options$reactive,
      _options$target = options.target,
      target = _options$target === undefined ? defaultWindow : _options$target,
      _options$aliasMap = options.aliasMap,
      aliasMap = _options$aliasMap === undefined ? DefaultMagicKeysAliasMap : _options$aliasMap,
      _options$passive = options.passive,
      passive = _options$passive === undefined ? true : _options$passive,
      _options$onEventFired = options.onEventFired,
      onEventFired = _options$onEventFired === undefined ? __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */] : _options$onEventFired;

  var current = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])(new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a());
  var obj = {
    toJSON: function toJSON() {
      return {};
    },

    current: current
  };
  var refs = useReactive ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])(obj) : obj;
  var metaDeps = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a();
  var usedKeys = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a();
  function setRefs(key, value) {
    if (key in refs) {
      if (useReactive) refs[key] = value;else refs[key].value = value;
    }
  }
  function reset() {
    current.clear();
    var _iteratorNormalCompletion29 = true;
    var _didIteratorError29 = false;
    var _iteratorError29 = undefined;

    try {
      for (var _iterator29 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(usedKeys), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
        var key = _step29.value;

        setRefs(key, false);
      }
    } catch (err) {
      _didIteratorError29 = true;
      _iteratorError29 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion29 && _iterator29.return) {
          _iterator29.return();
        }
      } finally {
        if (_didIteratorError29) {
          throw _iteratorError29;
        }
      }
    }
  }
  function updateRefs(e, value) {
    var _a, _b;
    var key = (_a = e.key) == null ? void 0 : _a.toLowerCase();
    var code = (_b = e.code) == null ? void 0 : _b.toLowerCase();
    var values = [code, key].filter(Boolean);
    if (key) {
      if (value) current.add(key);else current.delete(key);
    }
    var _iteratorNormalCompletion30 = true;
    var _didIteratorError30 = false;
    var _iteratorError30 = undefined;

    try {
      for (var _iterator30 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(values), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
        var key2 = _step30.value;

        usedKeys.add(key2);
        setRefs(key2, value);
      }
    } catch (err) {
      _didIteratorError30 = true;
      _iteratorError30 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion30 && _iterator30.return) {
          _iterator30.return();
        }
      } finally {
        if (_didIteratorError30) {
          throw _iteratorError30;
        }
      }
    }

    if (key === "meta" && !value) {
      metaDeps.forEach(function (key2) {
        current.delete(key2);
        setRefs(key2, false);
      });
      metaDeps.clear();
    } else if (typeof e.getModifierState === "function" && e.getModifierState("Meta") && value) {
      [].concat(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray___default()(current), __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray___default()(values)).forEach(function (key2) {
        return metaDeps.add(key2);
      });
    }
  }
  useEventListener(target, "keydown", function (e) {
    updateRefs(e, true);
    return onEventFired(e);
  }, { passive: passive });
  useEventListener(target, "keyup", function (e) {
    updateRefs(e, false);
    return onEventFired(e);
  }, { passive: passive });
  useEventListener("blur", reset, { passive: true });
  useEventListener("focus", reset, { passive: true });
  var proxy = new Proxy(refs, {
    get: function get(target2, prop, rec) {
      if (typeof prop !== "string") return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_get___default()(target2, prop, rec);
      prop = prop.toLowerCase();
      if (prop in aliasMap) prop = aliasMap[prop];
      if (!(prop in refs)) {
        if (/[+_-]/.test(prop)) {
          var _keys = prop.split(/[+_-]/g).map(function (i) {
            return i.trim();
          });
          refs[prop] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
            return _keys.every(function (key) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(proxy[key]);
            });
          });
        } else {
          refs[prop] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
        }
      }
      var r = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_get___default()(target2, prop, rec);
      return useReactive ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(r) : r;
    }
  });
  return proxy;
}

var __defProp$8 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __getOwnPropSymbols$9 = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = function __defNormalProp$8(obj, key, value) {
  return key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$8 = function __spreadValues$8(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$9.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
  }if (__getOwnPropSymbols$9) {
    var _iteratorNormalCompletion31 = true;
    var _didIteratorError31 = false;
    var _iteratorError31 = undefined;

    try {
      for (var _iterator31 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$9(b)), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
        var prop = _step31.value;

        if (__propIsEnum$9.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError31 = true;
      _iteratorError31 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion31 && _iterator31.return) {
          _iterator31.return();
        }
      } finally {
        if (_didIteratorError31) {
          throw _iteratorError31;
        }
      }
    }
  }return a;
};
function usingElRef(source, cb) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(source)) cb(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(source));
}
function timeRangeToArray(timeRanges) {
  var ranges = [];
  for (var i = 0; i < timeRanges.length; ++i) {
    ranges = [].concat(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray___default()(ranges), [[timeRanges.start(i), timeRanges.end(i)]]);
  }return ranges;
}
function tracksToArray(tracks) {
  return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from___default()(tracks).map(function (_ref68, id) {
    var label = _ref68.label,
        kind = _ref68.kind,
        language = _ref68.language,
        mode = _ref68.mode,
        activeCues = _ref68.activeCues,
        cues = _ref68.cues,
        inBandMetadataTrackDispatchType = _ref68.inBandMetadataTrackDispatchType;
    return { id: id, label: label, kind: kind, language: language, mode: mode, activeCues: activeCues, cues: cues, inBandMetadataTrackDispatchType: inBandMetadataTrackDispatchType };
  });
}
var defaultOptions = {
  src: "",
  tracks: []
};
function useMediaControls(target) {
  var _this5 = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  options = __spreadValues$8(__spreadValues$8({}, defaultOptions), options);
  var _options5 = options,
      _options5$document = _options5.document,
      document = _options5$document === undefined ? defaultDocument : _options5$document;

  var currentTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var duration = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var seeking = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var volume = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(1);
  var waiting = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var ended = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var playing = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var rate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(1);
  var stalled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var buffered = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])([]);
  var tracks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])([]);
  var selectedTrack = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(-1);
  var isPictureInPicture = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var muted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var supportsPictureInPicture = document && "pictureInPictureEnabled" in document;
  var sourceErrorEvent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["r" /* createEventHook */])();
  var disableTrack = function disableTrack(track) {
    usingElRef(target, function (el) {
      if (track) {
        var id = typeof track === "number" ? track : track.id;
        el.textTracks[id].mode = "disabled";
      } else {
        for (var i = 0; i < el.textTracks.length; ++i) {
          el.textTracks[i].mode = "disabled";
        }
      }
      selectedTrack.value = -1;
    });
  };
  var enableTrack = function enableTrack(track) {
    var disableTracks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    usingElRef(target, function (el) {
      var id = typeof track === "number" ? track : track.id;
      if (disableTracks) disableTrack();
      el.textTracks[id].mode = "showing";
      selectedTrack.value = id;
    });
  };
  var togglePictureInPicture = function togglePictureInPicture() {
    return new __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      usingElRef(target, function () {
        var _ref69 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee28(el) {
          return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
            while (1) {
              switch (_context28.prev = _context28.next) {
                case 0:
                  if (supportsPictureInPicture) {
                    if (!isPictureInPicture.value) {
                      el.requestPictureInPicture().then(resolve).catch(reject);
                    } else {
                      document.exitPictureInPicture().then(resolve).catch(reject);
                    }
                  }

                case 1:
                case 'end':
                  return _context28.stop();
              }
            }
          }, _callee28, _this5);
        }));

        return function (_x83) {
          return _ref69.apply(this, arguments);
        };
      }());
    });
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["d" /* watchEffect */])(function () {
    if (!document) return;
    var el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target);
    if (!el) return;
    var src = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(options.src);
    var sources = [];
    if (!src) return;
    if (typeof src === "string") sources = [{ src: src }];else if (Array.isArray(src)) sources = src;else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["i" /* isObject */])(src)) sources = [src];
    el.querySelectorAll("source").forEach(function (e) {
      e.removeEventListener("error", sourceErrorEvent.trigger);
      e.remove();
    });
    sources.forEach(function (_ref70) {
      var src2 = _ref70.src,
          type = _ref70.type;

      var source = document.createElement("source");
      source.setAttribute("src", src2);
      source.setAttribute("type", type || "");
      source.addEventListener("error", sourceErrorEvent.trigger);
      el.appendChild(source);
    });
    el.load();
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(function () {
    var el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target);
    if (!el) return;
    el.querySelectorAll("source").forEach(function (e) {
      return e.removeEventListener("error", sourceErrorEvent.trigger);
    });
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])([target, volume], function () {
    var el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target);
    if (!el) return;
    el.volume = volume.value;
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])([target, muted], function () {
    var el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target);
    if (!el) return;
    el.muted = muted.value;
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])([target, rate], function () {
    var el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target);
    if (!el) return;
    el.playbackRate = rate.value;
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["d" /* watchEffect */])(function () {
    if (!document) return;
    var textTracks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(options.tracks);
    var el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target);
    if (!textTracks || !textTracks.length || !el) return;
    el.querySelectorAll("track").forEach(function (e) {
      return e.remove();
    });
    textTracks.forEach(function (_ref71, i) {
      var isDefault = _ref71.default,
          kind = _ref71.kind,
          label = _ref71.label,
          src = _ref71.src,
          srcLang = _ref71.srcLang;

      var track = document.createElement("track");
      track.default = isDefault || false;
      track.kind = kind;
      track.label = label;
      track.src = src;
      track.srclang = srcLang;
      if (track.default) selectedTrack.value = i;
      el.appendChild(track);
    });
  });

  var _watchIgnorable2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["u" /* watchIgnorable */])(currentTime, function (time) {
    var el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target);
    if (!el) return;
    el.currentTime = time;
  }),
      ignoreCurrentTimeUpdates = _watchIgnorable2.ignoreUpdates;

  var _watchIgnorable3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["u" /* watchIgnorable */])(playing, function (isPlaying) {
    var el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target);
    if (!el) return;
    isPlaying ? el.play() : el.pause();
  }),
      ignorePlayingUpdates = _watchIgnorable3.ignoreUpdates;

  useEventListener(target, "timeupdate", function () {
    return ignoreCurrentTimeUpdates(function () {
      return currentTime.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target).currentTime;
    });
  });
  useEventListener(target, "durationchange", function () {
    return duration.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target).duration;
  });
  useEventListener(target, "progress", function () {
    return buffered.value = timeRangeToArray(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target).buffered);
  });
  useEventListener(target, "seeking", function () {
    return seeking.value = true;
  });
  useEventListener(target, "seeked", function () {
    return seeking.value = false;
  });
  useEventListener(target, ["waiting", "loadstart"], function () {
    waiting.value = true;
    ignorePlayingUpdates(function () {
      return playing.value = false;
    });
  });
  useEventListener(target, "loadeddata", function () {
    return waiting.value = false;
  });
  useEventListener(target, "playing", function () {
    waiting.value = false;
    ended.value = false;
    ignorePlayingUpdates(function () {
      return playing.value = true;
    });
  });
  useEventListener(target, "ratechange", function () {
    return rate.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target).playbackRate;
  });
  useEventListener(target, "stalled", function () {
    return stalled.value = true;
  });
  useEventListener(target, "ended", function () {
    return ended.value = true;
  });
  useEventListener(target, "pause", function () {
    return ignorePlayingUpdates(function () {
      return playing.value = false;
    });
  });
  useEventListener(target, "play", function () {
    return ignorePlayingUpdates(function () {
      return playing.value = true;
    });
  });
  useEventListener(target, "enterpictureinpicture", function () {
    return isPictureInPicture.value = true;
  });
  useEventListener(target, "leavepictureinpicture", function () {
    return isPictureInPicture.value = false;
  });
  useEventListener(target, "volumechange", function () {
    var el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target);
    if (!el) return;
    volume.value = el.volume;
    muted.value = el.muted;
  });
  var listeners = [];
  var stop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])([target], function () {
    var el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(target);
    if (!el) return;
    stop();
    listeners[0] = useEventListener(el.textTracks, "addtrack", function () {
      return tracks.value = tracksToArray(el.textTracks);
    });
    listeners[1] = useEventListener(el.textTracks, "removetrack", function () {
      return tracks.value = tracksToArray(el.textTracks);
    });
    listeners[2] = useEventListener(el.textTracks, "change", function () {
      return tracks.value = tracksToArray(el.textTracks);
    });
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(function () {
    return listeners.forEach(function (listener) {
      return listener();
    });
  });
  return {
    currentTime: currentTime,
    duration: duration,
    waiting: waiting,
    seeking: seeking,
    ended: ended,
    stalled: stalled,
    buffered: buffered,
    playing: playing,
    rate: rate,

    volume: volume,
    muted: muted,

    tracks: tracks,
    selectedTrack: selectedTrack,
    enableTrack: enableTrack,
    disableTrack: disableTrack,

    supportsPictureInPicture: supportsPictureInPicture,
    togglePictureInPicture: togglePictureInPicture,
    isPictureInPicture: isPictureInPicture,

    onSourceError: sourceErrorEvent.on
  };
}

function getMapVue2Compat() {
  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])({});
  return {
    get: function get(key) {
      return data[key];
    },
    set: function set(key, value) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["x" /* set */])(data, key, value);
    },
    has: function has(key) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["D" /* hasOwn */])(data, key);
    },
    delete: function _delete(key) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["y" /* del */])(data, key);
    },
    clear: function clear() {
      __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["y" /* del */])(data, key);
      });
    }
  };
}
function useMemoize(resolver, options) {
  var initCache = function initCache() {
    if (options == null ? void 0 : options.cache) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])(options.cache);
    if (__WEBPACK_IMPORTED_MODULE_25_vue_demi__["z" /* isVue2 */]) return getMapVue2Compat();
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])(new __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_map___default.a());
  };
  var cache = initCache();
  var generateKey = function generateKey() {
    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return (options == null ? void 0 : options.getKey) ? options.getKey.apply(options, args) : __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify___default()(args);
  };
  var _loadData = function _loadData(key) {
    for (var _len8 = arguments.length, args = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
      args[_key8 - 1] = arguments[_key8];
    }

    cache.set(key, resolver.apply(undefined, args));
    return cache.get(key);
  };
  var loadData = function loadData() {
    for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    return _loadData.apply(undefined, [generateKey.apply(undefined, args)].concat(args));
  };
  var deleteData = function deleteData() {
    cache.delete(generateKey.apply(undefined, arguments));
  };
  var clearData = function clearData() {
    cache.clear();
  };
  var memoized = function memoized() {
    for (var _len10 = arguments.length, args = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }

    var key = generateKey.apply(undefined, args);
    if (cache.has(key)) return cache.get(key);
    return _loadData.apply(undefined, [key].concat(args));
  };
  memoized.load = loadData;
  memoized.delete = deleteData;
  memoized.clear = clearData;
  memoized.generateKey = generateKey;
  memoized.cache = cache;
  return memoized;
}

function useMemory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var memory = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  var isSupported = useSupported(function () {
    return typeof performance !== "undefined" && "memory" in performance;
  });
  if (isSupported.value) {
    var _options$interval3 = options.interval,
        interval = _options$interval3 === undefined ? 1e3 : _options$interval3;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["A" /* useIntervalFn */])(function () {
      memory.value = performance.memory;
    }, interval, { immediate: options.immediate, immediateCallback: options.immediateCallback });
  }
  return { isSupported: isSupported, memory: memory };
}

var BuiltinExtractors = {
  page: function page(event) {
    return [event.pageX, event.pageY];
  },
  client: function client(event) {
    return [event.clientX, event.clientY];
  },
  screen: function screen(event) {
    return [event.screenX, event.screenY];
  },
  movement: function movement(event) {
    return event instanceof Touch ? null : [event.movementX, event.movementY];
  }
};
function useMouse() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$type = options.type,
      type = _options$type === undefined ? "page" : _options$type,
      _options$touch = options.touch,
      touch = _options$touch === undefined ? true : _options$touch,
      _options$resetOnTouch = options.resetOnTouchEnds,
      resetOnTouchEnds = _options$resetOnTouch === undefined ? false : _options$resetOnTouch,
      _options$initialValue5 = options.initialValue,
      initialValue = _options$initialValue5 === undefined ? { x: 0, y: 0 } : _options$initialValue5,
      _options$window18 = options.window,
      window = _options$window18 === undefined ? defaultWindow : _options$window18,
      _options$target2 = options.target,
      target = _options$target2 === undefined ? window : _options$target2,
      eventFilter = options.eventFilter;

  var x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(initialValue.x);
  var y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(initialValue.y);
  var sourceType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  var extractor = typeof type === "function" ? type : BuiltinExtractors[type];
  var mouseHandler = function mouseHandler(event) {
    var result = extractor(event);
    if (result) {
      var _result = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(result, 2);

      x.value = _result[0];
      y.value = _result[1];

      sourceType.value = "mouse";
    }
  };
  var touchHandler = function touchHandler(event) {
    if (event.touches.length > 0) {
      var result = extractor(event.touches[0]);
      if (result) {
        var _result2 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(result, 2);

        x.value = _result2[0];
        y.value = _result2[1];

        sourceType.value = "touch";
      }
    }
  };
  var reset = function reset() {
    x.value = initialValue.x;
    y.value = initialValue.y;
  };
  var mouseHandlerWrapper = eventFilter ? function (event) {
    return eventFilter(function () {
      return mouseHandler(event);
    }, {});
  } : function (event) {
    return mouseHandler(event);
  };
  var touchHandlerWrapper = eventFilter ? function (event) {
    return eventFilter(function () {
      return touchHandler(event);
    }, {});
  } : function (event) {
    return touchHandler(event);
  };
  if (target) {
    useEventListener(target, "mousemove", mouseHandlerWrapper, { passive: true });
    useEventListener(target, "dragover", mouseHandlerWrapper, { passive: true });
    if (touch && type !== "movement") {
      useEventListener(target, "touchstart", touchHandlerWrapper, { passive: true });
      useEventListener(target, "touchmove", touchHandlerWrapper, { passive: true });
      if (resetOnTouchEnds) useEventListener(target, "touchend", reset, { passive: true });
    }
  }
  return {
    x: x,
    y: y,
    sourceType: sourceType
  };
}

function useMouseInElement(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$handleOutsid = options.handleOutside,
      handleOutside = _options$handleOutsid === undefined ? true : _options$handleOutsid,
      _options$window19 = options.window,
      window = _options$window19 === undefined ? defaultWindow : _options$window19;

  var _useMouse = useMouse(options),
      x = _useMouse.x,
      y = _useMouse.y,
      sourceType = _useMouse.sourceType;

  var targetRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(target != null ? target : window == null ? void 0 : window.document.body);
  var elementX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var elementY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var elementPositionX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var elementPositionY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var elementHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var elementWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0);
  var isOutside = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(true);
  var stop = function stop() {};
  if (window) {
    stop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])([targetRef, x, y], function () {
      var el = unrefElement(targetRef);
      if (!el) return;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          left = _el$getBoundingClient.left,
          top = _el$getBoundingClient.top,
          width = _el$getBoundingClient.width,
          height = _el$getBoundingClient.height;

      elementPositionX.value = left + window.pageXOffset;
      elementPositionY.value = top + window.pageYOffset;
      elementHeight.value = height;
      elementWidth.value = width;
      var elX = x.value - elementPositionX.value;
      var elY = y.value - elementPositionY.value;
      isOutside.value = width === 0 || height === 0 || elX < 0 || elY < 0 || elX > width || elY > height;
      if (handleOutside || !isOutside.value) {
        elementX.value = elX;
        elementY.value = elY;
      }
    }, { immediate: true });
    useEventListener(document, "mouseleave", function () {
      isOutside.value = true;
    });
  }
  return {
    x: x,
    y: y,
    sourceType: sourceType,
    elementX: elementX,
    elementY: elementY,
    elementPositionX: elementPositionX,
    elementPositionY: elementPositionY,
    elementHeight: elementHeight,
    elementWidth: elementWidth,
    isOutside: isOutside,
    stop: stop
  };
}

function useMousePressed() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$touch2 = options.touch,
      touch = _options$touch2 === undefined ? true : _options$touch2,
      _options$drag = options.drag,
      drag = _options$drag === undefined ? true : _options$drag,
      _options$initialValue6 = options.initialValue,
      initialValue = _options$initialValue6 === undefined ? false : _options$initialValue6,
      _options$window20 = options.window,
      window = _options$window20 === undefined ? defaultWindow : _options$window20;

  var pressed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(initialValue);
  var sourceType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  if (!window) {
    return {
      pressed: pressed,
      sourceType: sourceType
    };
  }
  var onPressed = function onPressed(srcType) {
    return function () {
      pressed.value = true;
      sourceType.value = srcType;
    };
  };
  var onReleased = function onReleased() {
    pressed.value = false;
    sourceType.value = null;
  };
  var target = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return unrefElement(options.target) || window;
  });
  useEventListener(target, "mousedown", onPressed("mouse"), { passive: true });
  useEventListener(window, "mouseleave", onReleased, { passive: true });
  useEventListener(window, "mouseup", onReleased, { passive: true });
  if (drag) {
    useEventListener(target, "dragstart", onPressed("mouse"), { passive: true });
    useEventListener(window, "drop", onReleased, { passive: true });
    useEventListener(window, "dragend", onReleased, { passive: true });
  }
  if (touch) {
    useEventListener(target, "touchstart", onPressed("touch"), { passive: true });
    useEventListener(window, "touchend", onReleased, { passive: true });
    useEventListener(window, "touchcancel", onReleased, { passive: true });
  }
  return {
    pressed: pressed,
    sourceType: sourceType
  };
}

function useNavigatorLanguage() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window21 = options.window,
      window = _options$window21 === undefined ? defaultWindow : _options$window21;

  var navigator = window == null ? void 0 : window.navigator;
  var isSupported = useSupported(function () {
    return navigator && "language" in navigator;
  });
  var language = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(navigator == null ? void 0 : navigator.language);
  useEventListener(window, "languagechange", function () {
    if (navigator) language.value = navigator.language;
  });
  return {
    isSupported: isSupported,
    language: language
  };
}

function useNetwork() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window22 = options.window,
      window = _options$window22 === undefined ? defaultWindow : _options$window22;

  var navigator = window == null ? void 0 : window.navigator;
  var isSupported = useSupported(function () {
    return navigator && "connection" in navigator;
  });
  var isOnline = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(true);
  var saveData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var offlineAt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(void 0);
  var onlineAt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(void 0);
  var downlink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(void 0);
  var downlinkMax = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(void 0);
  var rtt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(void 0);
  var effectiveType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(void 0);
  var type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])("unknown");
  var connection = isSupported.value && navigator.connection;
  function updateNetworkInformation() {
    if (!navigator) return;
    isOnline.value = navigator.onLine;
    offlineAt.value = isOnline.value ? void 0 : Date.now();
    onlineAt.value = isOnline.value ? Date.now() : void 0;
    if (connection) {
      downlink.value = connection.downlink;
      downlinkMax.value = connection.downlinkMax;
      effectiveType.value = connection.effectiveType;
      rtt.value = connection.rtt;
      saveData.value = connection.saveData;
      type.value = connection.type;
    }
  }
  if (window) {
    useEventListener(window, "offline", function () {
      isOnline.value = false;
      offlineAt.value = Date.now();
    });
    useEventListener(window, "online", function () {
      isOnline.value = true;
      onlineAt.value = Date.now();
    });
  }
  if (connection) useEventListener(connection, "change", updateNetworkInformation, false);
  updateNetworkInformation();
  return {
    isSupported: isSupported,
    isOnline: isOnline,
    saveData: saveData,
    offlineAt: offlineAt,
    onlineAt: onlineAt,
    downlink: downlink,
    downlinkMax: downlinkMax,
    effectiveType: effectiveType,
    rtt: rtt,
    type: type
  };
}

var __defProp$7 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __getOwnPropSymbols$8 = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = function __defNormalProp$7(obj, key, value) {
  return key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$7 = function __spreadValues$7(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$8.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
  }if (__getOwnPropSymbols$8) {
    var _iteratorNormalCompletion32 = true;
    var _didIteratorError32 = false;
    var _iteratorError32 = undefined;

    try {
      for (var _iterator32 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$8(b)), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
        var prop = _step32.value;

        if (__propIsEnum$8.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError32 = true;
      _iteratorError32 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion32 && _iterator32.return) {
          _iterator32.return();
        }
      } finally {
        if (_didIteratorError32) {
          throw _iteratorError32;
        }
      }
    }
  }return a;
};
function useNow() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$controls2 = options.controls,
      exposeControls = _options$controls2 === undefined ? false : _options$controls2,
      _options$interval4 = options.interval,
      interval = _options$interval4 === undefined ? "requestAnimationFrame" : _options$interval4;

  var now = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(new Date());
  var update = function update() {
    return now.value = new Date();
  };
  var controls = interval === "requestAnimationFrame" ? useRafFn(update, { immediate: true }) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["A" /* useIntervalFn */])(update, interval, { immediate: true });
  if (exposeControls) {
    return __spreadValues$7({
      now: now
    }, controls);
  } else {
    return now;
  }
}

function useObjectUrl(object) {
  var url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  var release = function release() {
    if (url.value) URL.revokeObjectURL(url.value);
    url.value = void 0;
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(object);
  }, function (newObject) {
    release();
    if (newObject) url.value = URL.createObjectURL(newObject);
  }, { immediate: true });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(release);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["s" /* readonly */])(url);
}

function useClamp(value, min, max) {
  if (typeof value === "function" || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["A" /* isReadonly */])(value)) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["H" /* clamp */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(value), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(min), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(max));
  });
  var _value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(value);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])({
    get: function get() {
      return _value.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["H" /* clamp */])(_value.value, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(min), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(max));
    },
    set: function set(value2) {
      _value.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["H" /* clamp */])(value2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(min), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(max));
    }
  });
}

function useOffsetPagination(options) {
  var _options$total = options.total,
      total = _options$total === undefined ? Infinity : _options$total,
      _options$pageSize = options.pageSize,
      pageSize = _options$pageSize === undefined ? 10 : _options$pageSize,
      _options$page = options.page,
      page = _options$page === undefined ? 1 : _options$page,
      _options$onPageChange = options.onPageChange,
      onPageChange = _options$onPageChange === undefined ? __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */] : _options$onPageChange,
      _options$onPageSizeCh = options.onPageSizeChange,
      onPageSizeChange = _options$onPageSizeCh === undefined ? __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */] : _options$onPageSizeCh,
      _options$onPageCountC = options.onPageCountChange,
      onPageCountChange = _options$onPageCountC === undefined ? __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */] : _options$onPageCountC;

  var currentPageSize = useClamp(pageSize, 1, Infinity);
  var pageCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return Math.max(1, Math.ceil(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(total) / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(currentPageSize)));
  });
  var currentPage = useClamp(page, 1, pageCount);
  var isFirstPage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return currentPage.value === 1;
  });
  var isLastPage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return currentPage.value === pageCount.value;
  });
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["a" /* isRef */])(page)) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["I" /* syncRef */])(page, currentPage);
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["a" /* isRef */])(pageSize)) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["I" /* syncRef */])(pageSize, currentPageSize);
  function prev() {
    currentPage.value--;
  }
  function next() {
    currentPage.value++;
  }
  var returnValue = {
    currentPage: currentPage,
    currentPageSize: currentPageSize,
    pageCount: pageCount,
    isFirstPage: isFirstPage,
    isLastPage: isLastPage,
    prev: prev,
    next: next
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(currentPage, function () {
    onPageChange(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])(returnValue));
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(currentPageSize, function () {
    onPageSizeChange(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])(returnValue));
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(pageCount, function () {
    onPageCountChange(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])(returnValue));
  });
  return returnValue;
}

function useOnline() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useNetwork = useNetwork(options),
      isOnline = _useNetwork.isOnline;

  return isOnline;
}

function usePageLeave() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window23 = options.window,
      window = _options$window23 === undefined ? defaultWindow : _options$window23;

  var isLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var handler = function handler(event) {
    if (!window) return;
    event = event || window.event;
    var from = event.relatedTarget || event.toElement;
    isLeft.value = !from;
  };
  if (window) {
    useEventListener(window, "mouseout", handler, { passive: true });
    useEventListener(window.document, "mouseleave", handler, { passive: true });
    useEventListener(window.document, "mouseenter", handler, { passive: true });
  }
  return isLeft;
}

function useParallax(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$deviceOrient = options.deviceOrientationTiltAdjust,
      deviceOrientationTiltAdjust = _options$deviceOrient === undefined ? function (i) {
    return i;
  } : _options$deviceOrient,
      _options$deviceOrient2 = options.deviceOrientationRollAdjust,
      deviceOrientationRollAdjust = _options$deviceOrient2 === undefined ? function (i) {
    return i;
  } : _options$deviceOrient2,
      _options$mouseTiltAdj = options.mouseTiltAdjust,
      mouseTiltAdjust = _options$mouseTiltAdj === undefined ? function (i) {
    return i;
  } : _options$mouseTiltAdj,
      _options$mouseRollAdj = options.mouseRollAdjust,
      mouseRollAdjust = _options$mouseRollAdj === undefined ? function (i) {
    return i;
  } : _options$mouseRollAdj,
      _options$window24 = options.window,
      window = _options$window24 === undefined ? defaultWindow : _options$window24;

  var orientation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])(useDeviceOrientation({ window: window }));

  var _useMouseInElement = useMouseInElement(target, { handleOutside: false, window: window }),
      x = _useMouseInElement.elementX,
      y = _useMouseInElement.elementY,
      width = _useMouseInElement.elementWidth,
      height = _useMouseInElement.elementHeight;

  var source = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    if (orientation.isSupported && (orientation.alpha != null && orientation.alpha !== 0 || orientation.gamma != null && orientation.gamma !== 0)) return "deviceOrientation";
    return "mouse";
  });
  var roll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    if (source.value === "deviceOrientation") {
      var value = -orientation.beta / 90;
      return deviceOrientationRollAdjust(value);
    } else {
      var _value2 = -(y.value - height.value / 2) / height.value;
      return mouseRollAdjust(_value2);
    }
  });
  var tilt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    if (source.value === "deviceOrientation") {
      var value = orientation.gamma / 90;
      return deviceOrientationTiltAdjust(value);
    } else {
      var _value3 = (x.value - width.value / 2) / width.value;
      return mouseTiltAdjust(_value3);
    }
  });
  return { roll: roll, tilt: tilt, source: source };
}

function useParentElement() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : useCurrentElement();

  var parentElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])();
  var update = function update() {
    var el = unrefElement(element);
    if (el) parentElement.value = el.parentElement;
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["g" /* tryOnMounted */])(update);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(element);
  }, update);
  return parentElement;
}

var __getOwnPropSymbols$7 = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __objRest$1 = function __objRest$1(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp$7.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }if (source != null && __getOwnPropSymbols$7) {
    var _iteratorNormalCompletion33 = true;
    var _didIteratorError33 = false;
    var _iteratorError33 = undefined;

    try {
      for (var _iterator33 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$7(source)), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
        var prop = _step33.value;

        if (exclude.indexOf(prop) < 0 && __propIsEnum$7.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _didIteratorError33 = true;
      _iteratorError33 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion33 && _iterator33.return) {
          _iterator33.return();
        }
      } finally {
        if (_didIteratorError33) {
          throw _iteratorError33;
        }
      }
    }
  }return target;
};
function usePerformanceObserver(options, callback) {
  var _a = options,
      _a$window3 = _a.window,
      window = _a$window3 === undefined ? defaultWindow : _a$window3,
      _a$immediate = _a.immediate,
      immediate = _a$immediate === undefined ? true : _a$immediate,
      performanceOptions = __objRest$1(_a, ["window", "immediate"]);
  var isSupported = useSupported(function () {
    return window && "PerformanceObserver" in window;
  });
  var observer = void 0;
  var stop = function stop() {
    observer == null ? void 0 : observer.disconnect();
  };
  var start = function start() {
    if (isSupported.value) {
      stop();
      observer = new PerformanceObserver(callback);
      observer.observe(performanceOptions);
    }
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(stop);
  if (immediate) start();
  return {
    isSupported: isSupported,
    start: start,
    stop: stop
  };
}

var __defProp$6 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __defProps$2 = __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$2 = __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$6 = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = function __defNormalProp$6(obj, key, value) {
  return key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$6 = function __spreadValues$6(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
  }if (__getOwnPropSymbols$6) {
    var _iteratorNormalCompletion34 = true;
    var _didIteratorError34 = false;
    var _iteratorError34 = undefined;

    try {
      for (var _iterator34 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$6(b)), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
        var prop = _step34.value;

        if (__propIsEnum$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError34 = true;
      _iteratorError34 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion34 && _iterator34.return) {
          _iterator34.return();
        }
      } finally {
        if (_didIteratorError34) {
          throw _iteratorError34;
        }
      }
    }
  }return a;
};
var __spreadProps$2 = function __spreadProps$2(a, b) {
  return __defProps$2(a, __getOwnPropDescs$2(b));
};
var defaultState = {
  x: 0,
  y: 0,
  pointerId: 0,
  pressure: 0,
  tiltX: 0,
  tiltY: 0,
  width: 0,
  height: 0,
  twist: 0,
  pointerType: null
};
var keys = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(defaultState);
function usePointer() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$target3 = options.target,
      target = _options$target3 === undefined ? defaultWindow : _options$target3;

  var isInside = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(options.initialValue || {});
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()(state.value, defaultState, state.value);
  var handler = function handler(event) {
    isInside.value = true;
    if (options.pointerTypes && !options.pointerTypes.includes(event.pointerType)) return;
    state.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["J" /* objectPick */])(event, keys, false);
  };
  if (target) {
    useEventListener(target, "pointerdown", handler, { passive: true });
    useEventListener(target, "pointermove", handler, { passive: true });
    useEventListener(target, "pointerleave", function () {
      return isInside.value = false;
    }, { passive: true });
  }
  return __spreadProps$2(__spreadValues$6({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["z" /* toRefs */])(state)), {
    isInside: isInside
  });
}

function usePointerLock(target) {
  var lock = function () {
    var _ref72 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee29(e, options2) {
      var _a;

      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              if (isSupported.value) {
                _context29.next = 2;
                break;
              }

              throw new Error("Pointer Lock API is not supported by your browser.");

            case 2:
              triggerElement.value = e instanceof Event ? e.currentTarget : null;
              targetElement = e instanceof Event ? (_a = unrefElement(target)) != null ? _a : triggerElement.value : unrefElement(e);

              if (targetElement) {
                _context29.next = 6;
                break;
              }

              throw new Error("Target element undefined.");

            case 6:
              targetElement.requestPointerLock(options2 != null ? options2 : pointerLockOptions);
              _context29.next = 9;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["l" /* until */])(element).toBe(targetElement);

            case 9:
              return _context29.abrupt('return', _context29.sent);

            case 10:
            case 'end':
              return _context29.stop();
          }
        }
      }, _callee29, this);
    }));

    return function lock(_x97, _x98) {
      return _ref72.apply(this, arguments);
    };
  }();

  var unlock = function () {
    var _ref73 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee30() {
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              if (element.value) {
                _context30.next = 2;
                break;
              }

              return _context30.abrupt('return', false);

            case 2:
              document.exitPointerLock();
              _context30.next = 5;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["l" /* until */])(element).toBeNull();

            case 5:
              return _context30.abrupt('return', true);

            case 6:
            case 'end':
              return _context30.stop();
          }
        }
      }, _callee30, this);
    }));

    return function unlock() {
      return _ref73.apply(this, arguments);
    };
  }();

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$document7 = options.document,
      document = _options$document7 === undefined ? defaultDocument : _options$document7,
      pointerLockOptions = options.pointerLockOptions;

  var isSupported = useSupported(function () {
    return document && "pointerLockElement" in document;
  });
  var element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  var triggerElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  var targetElement = void 0;
  if (isSupported.value) {
    useEventListener(document, "pointerlockchange", function () {
      var _a;
      var currentElement = (_a = document.pointerLockElement) != null ? _a : element.value;
      if (targetElement && currentElement === targetElement) {
        element.value = document.pointerLockElement;
        if (!element.value) targetElement = triggerElement.value = null;
      }
    });
    useEventListener(document, "pointerlockerror", function () {
      var _a;
      var currentElement = (_a = document.pointerLockElement) != null ? _a : element.value;
      if (targetElement && currentElement === targetElement) {
        var action = document.pointerLockElement ? "release" : "acquire";
        throw new Error('Failed to ' + action + ' pointer lock.');
      }
    });
  }

  return {
    isSupported: isSupported,
    element: element,
    triggerElement: triggerElement,
    lock: lock,
    unlock: unlock
  };
}

function usePointerSwipe(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var targetRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["m" /* toRef */])(target);
  var _options$threshold2 = options.threshold,
      threshold = _options$threshold2 === undefined ? 50 : _options$threshold2,
      onSwipe = options.onSwipe,
      onSwipeEnd = options.onSwipeEnd,
      onSwipeStart = options.onSwipeStart;

  var posStart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])({ x: 0, y: 0 });
  var updatePosStart = function updatePosStart(x, y) {
    posStart.x = x;
    posStart.y = y;
  };
  var posEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])({ x: 0, y: 0 });
  var updatePosEnd = function updatePosEnd(x, y) {
    posEnd.x = x;
    posEnd.y = y;
  };
  var distanceX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return posStart.x - posEnd.x;
  });
  var distanceY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return posStart.y - posEnd.y;
  });
  var max = Math.max,
      abs = Math.abs;

  var isThresholdExceeded = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return max(abs(distanceX.value), abs(distanceY.value)) >= threshold;
  });
  var isSwiping = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var isPointerDown = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var direction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    if (!isThresholdExceeded.value) return "none";
    if (abs(distanceX.value) > abs(distanceY.value)) {
      return distanceX.value > 0 ? "left" : "right";
    } else {
      return distanceY.value > 0 ? "up" : "down";
    }
  });
  var eventIsAllowed = function eventIsAllowed(e) {
    var _a, _b, _c;
    var isReleasingButton = e.buttons === 0;
    var isPrimaryButton = e.buttons === 1;
    return (_c = (_b = (_a = options.pointerTypes) == null ? void 0 : _a.includes(e.pointerType)) != null ? _b : isReleasingButton || isPrimaryButton) != null ? _c : true;
  };
  var stops = [useEventListener(target, "pointerdown", function (e) {
    var _a, _b;
    if (!eventIsAllowed(e)) return;
    isPointerDown.value = true;
    (_b = (_a = targetRef.value) == null ? void 0 : _a.style) == null ? void 0 : _b.setProperty("touch-action", "none");
    var eventTarget = e.target;
    eventTarget == null ? void 0 : eventTarget.setPointerCapture(e.pointerId);
    var x = e.clientX,
        y = e.clientY;

    updatePosStart(x, y);
    updatePosEnd(x, y);
    onSwipeStart == null ? void 0 : onSwipeStart(e);
  }), useEventListener(target, "pointermove", function (e) {
    if (!eventIsAllowed(e)) return;
    if (!isPointerDown.value) return;
    var x = e.clientX,
        y = e.clientY;

    updatePosEnd(x, y);
    if (!isSwiping.value && isThresholdExceeded.value) isSwiping.value = true;
    if (isSwiping.value) onSwipe == null ? void 0 : onSwipe(e);
  }), useEventListener(target, "pointerup", function (e) {
    var _a, _b;
    if (!eventIsAllowed(e)) return;
    if (isSwiping.value) onSwipeEnd == null ? void 0 : onSwipeEnd(e, direction.value);
    isPointerDown.value = false;
    isSwiping.value = false;
    (_b = (_a = targetRef.value) == null ? void 0 : _a.style) == null ? void 0 : _b.setProperty("touch-action", "initial");
  })];
  var stop = function stop() {
    return stops.forEach(function (s) {
      return s();
    });
  };
  return {
    isSwiping: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["s" /* readonly */])(isSwiping),
    direction: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["s" /* readonly */])(direction),
    posStart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["s" /* readonly */])(posStart),
    posEnd: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["s" /* readonly */])(posEnd),
    distanceX: distanceX,
    distanceY: distanceY,
    stop: stop
  };
}

function usePreferredColorScheme(options) {
  var isLight = useMediaQuery("(prefers-color-scheme: light)", options);
  var isDark = useMediaQuery("(prefers-color-scheme: dark)", options);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    if (isDark.value) return "dark";
    if (isLight.value) return "light";
    return "no-preference";
  });
}

function usePreferredContrast(options) {
  var isMore = useMediaQuery("(prefers-contrast: more)", options);
  var isLess = useMediaQuery("(prefers-contrast: less)", options);
  var isCustom = useMediaQuery("(prefers-contrast: custom)", options);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    if (isMore.value) return "more";
    if (isLess.value) return "less";
    if (isCustom.value) return "custom";
    return "no-preference";
  });
}

function usePreferredLanguages() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window25 = options.window,
      window = _options$window25 === undefined ? defaultWindow : _options$window25;

  if (!window) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(["en"]);
  var navigator = window.navigator;
  var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(navigator.languages);
  useEventListener(window, "languagechange", function () {
    value.value = navigator.languages;
  });
  return value;
}

function usePreferredReducedMotion(options) {
  var isReduced = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    if (isReduced.value) return "reduce";
    return "no-preference";
  });
}

function usePrevious(value, initialValue) {
  var previous = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(initialValue);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["m" /* toRef */])(value), function (_, oldValue) {
    previous.value = oldValue;
  }, { flush: "sync" });
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["s" /* readonly */])(previous);
}

function useScreenOrientation() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window26 = options.window,
      window = _options$window26 === undefined ? defaultWindow : _options$window26;

  var isSupported = useSupported(function () {
    return window && "screen" in window && "orientation" in window.screen;
  });
  var screenOrientation = isSupported.value ? window.screen.orientation : {};
  var orientation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(screenOrientation.type);
  var angle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(screenOrientation.angle || 0);
  if (isSupported.value) {
    useEventListener(window, "orientationchange", function () {
      orientation.value = screenOrientation.type;
      angle.value = screenOrientation.angle;
    });
  }
  var lockOrientation = function lockOrientation(type) {
    if (!isSupported.value) return __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a.reject(new Error("Not supported"));
    return screenOrientation.lock(type);
  };
  var unlockOrientation = function unlockOrientation() {
    if (isSupported.value) screenOrientation.unlock();
  };
  return {
    isSupported: isSupported,
    orientation: orientation,
    angle: angle,
    lockOrientation: lockOrientation,
    unlockOrientation: unlockOrientation
  };
}

var topVarName = "--vueuse-safe-area-top";
var rightVarName = "--vueuse-safe-area-right";
var bottomVarName = "--vueuse-safe-area-bottom";
var leftVarName = "--vueuse-safe-area-left";
function useScreenSafeArea() {
  var top = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])("");
  var right = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])("");
  var bottom = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])("");
  var left = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])("");
  if (__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["d" /* isClient */]) {
    var topCssVar = useCssVar(topVarName);
    var rightCssVar = useCssVar(rightVarName);
    var bottomCssVar = useCssVar(bottomVarName);
    var leftCssVar = useCssVar(leftVarName);
    topCssVar.value = "env(safe-area-inset-top, 0px)";
    rightCssVar.value = "env(safe-area-inset-right, 0px)";
    bottomCssVar.value = "env(safe-area-inset-bottom, 0px)";
    leftCssVar.value = "env(safe-area-inset-left, 0px)";
    update();
    useEventListener("resize", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["F" /* useDebounceFn */])(update));
  }
  function update() {
    top.value = getValue(topVarName);
    right.value = getValue(rightVarName);
    bottom.value = getValue(bottomVarName);
    left.value = getValue(leftVarName);
  }
  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    update: update
  };
}
function getValue(position) {
  return getComputedStyle(document.documentElement).getPropertyValue(position);
}

function useScriptTag(src) {
  var onLoaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */];
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$immediate7 = options.immediate,
      immediate = _options$immediate7 === undefined ? true : _options$immediate7,
      _options$manual = options.manual,
      manual = _options$manual === undefined ? false : _options$manual,
      _options$type2 = options.type,
      type = _options$type2 === undefined ? "text/javascript" : _options$type2,
      _options$async = options.async,
      async = _options$async === undefined ? true : _options$async,
      crossOrigin = options.crossOrigin,
      referrerPolicy = options.referrerPolicy,
      noModule = options.noModule,
      defer = options.defer,
      _options$document8 = options.document,
      document = _options$document8 === undefined ? defaultDocument : _options$document8,
      _options$attrs = options.attrs,
      attrs = _options$attrs === undefined ? {} : _options$attrs;

  var scriptTag = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  var _promise = null;
  var loadScript = function loadScript(waitForScriptLoad) {
    return new __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var resolveWithElement = function resolveWithElement(el2) {
        scriptTag.value = el2;
        resolve(el2);
        return el2;
      };
      if (!document) {
        resolve(false);
        return;
      }
      var shouldAppend = false;
      var el = document.querySelector('script[src="' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(src) + '"]');
      if (!el) {
        el = document.createElement("script");
        el.type = type;
        el.async = async;
        el.src = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(src);
        if (defer) el.defer = defer;
        if (crossOrigin) el.crossOrigin = crossOrigin;
        if (noModule) el.noModule = noModule;
        if (referrerPolicy) el.referrerPolicy = referrerPolicy;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(attrs).forEach(function (_ref74) {
          var _ref75 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref74, 2),
              name = _ref75[0],
              value = _ref75[1];

          return el == null ? void 0 : el.setAttribute(name, value);
        });
        shouldAppend = true;
      } else if (el.hasAttribute("data-loaded")) {
        resolveWithElement(el);
      }
      el.addEventListener("error", function (event) {
        return reject(event);
      });
      el.addEventListener("abort", function (event) {
        return reject(event);
      });
      el.addEventListener("load", function () {
        el.setAttribute("data-loaded", "true");
        onLoaded(el);
        resolveWithElement(el);
      });
      if (shouldAppend) el = document.head.appendChild(el);
      if (!waitForScriptLoad) resolveWithElement(el);
    });
  };
  var load = function load() {
    var waitForScriptLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (!_promise) _promise = loadScript(waitForScriptLoad);
    return _promise;
  };
  var unload = function unload() {
    if (!document) return;
    _promise = null;
    if (scriptTag.value) scriptTag.value = null;
    var el = document.querySelector('script[src="' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(src) + '"]');
    if (el) document.head.removeChild(el);
  };
  if (immediate && !manual) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["g" /* tryOnMounted */])(load);
  if (!manual) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["K" /* tryOnUnmounted */])(unload);
  return { scriptTag: scriptTag, load: load, unload: unload };
}

function checkOverflowScroll(ele) {
  var style = window.getComputedStyle(ele);
  if (style.overflowX === "scroll" || style.overflowY === "scroll" || style.overflowX === "auto" && ele.clientWidth < ele.scrollWidth || style.overflowY === "auto" && ele.clientHeight < ele.scrollHeight) {
    return true;
  } else {
    var parent = ele.parentNode;
    if (!parent || parent.tagName === "BODY") return false;
    return checkOverflowScroll(parent);
  }
}
function preventDefault(rawEvent) {
  var e = rawEvent || window.event;
  var _target = e.target;
  if (checkOverflowScroll(_target)) return false;
  if (e.touches.length > 1) return true;
  if (e.preventDefault) e.preventDefault();
  return false;
}
function useScrollLock(element) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var isLocked = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(initialState);
  var stopTouchMoveListener = null;
  var initialOverflow = void 0;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["m" /* toRef */])(element), function (el) {
    if (el) {
      var ele = el;
      initialOverflow = ele.style.overflow;
      if (isLocked.value) ele.style.overflow = "hidden";
    }
  }, {
    immediate: true
  });
  var lock = function lock() {
    var ele = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(element);
    if (!ele || isLocked.value) return;
    if (__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["f" /* isIOS */]) {
      stopTouchMoveListener = useEventListener(ele, "touchmove", function (e) {
        preventDefault(e);
      }, { passive: false });
    }
    ele.style.overflow = "hidden";
    isLocked.value = true;
  };
  var unlock = function unlock() {
    var ele = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(element);
    if (!ele || !isLocked.value) return;
    __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["f" /* isIOS */] && (stopTouchMoveListener == null ? void 0 : stopTouchMoveListener());
    ele.style.overflow = initialOverflow;
    isLocked.value = false;
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(unlock);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])({
    get: function get() {
      return isLocked.value;
    },
    set: function set(v) {
      if (v) lock();else unlock();
    }
  });
}

function useSessionStorage(key, initialValue) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$window27 = options.window,
      window = _options$window27 === undefined ? defaultWindow : _options$window27;

  return useStorage(key, initialValue, window == null ? void 0 : window.sessionStorage, options);
}

var __defProp$5 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __getOwnPropSymbols$5 = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = function __defNormalProp$5(obj, key, value) {
  return key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$5 = function __spreadValues$5(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
  }if (__getOwnPropSymbols$5) {
    var _iteratorNormalCompletion35 = true;
    var _didIteratorError35 = false;
    var _iteratorError35 = undefined;

    try {
      for (var _iterator35 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$5(b)), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
        var prop = _step35.value;

        if (__propIsEnum$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError35 = true;
      _iteratorError35 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion35 && _iterator35.return) {
          _iterator35.return();
        }
      } finally {
        if (_didIteratorError35) {
          throw _iteratorError35;
        }
      }
    }
  }return a;
};
function useShare() {
  var _this6 = this;

  var shareOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$navigator7 = options.navigator,
      navigator = _options$navigator7 === undefined ? defaultNavigator : _options$navigator7;

  var _navigator = navigator;
  var isSupported = useSupported(function () {
    return _navigator && "canShare" in _navigator;
  });
  var share = function () {
    var _ref76 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee31() {
      var overrideOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var data, granted;
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              if (!isSupported.value) {
                _context31.next = 6;
                break;
              }

              data = __spreadValues$5(__spreadValues$5({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(shareOptions)), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(overrideOptions));
              granted = true;

              if (data.files && _navigator.canShare) granted = _navigator.canShare({ files: data.files });

              if (!granted) {
                _context31.next = 6;
                break;
              }

              return _context31.abrupt('return', _navigator.share(data));

            case 6:
            case 'end':
              return _context31.stop();
          }
        }
      }, _callee31, _this6);
    }));

    return function share() {
      return _ref76.apply(this, arguments);
    };
  }();
  return {
    isSupported: isSupported,
    share: share
  };
}

var defaultSortFn = function defaultSortFn(source, compareFn) {
  return source.sort(compareFn);
};
var defaultCompare = function defaultCompare(a, b) {
  return a - b;
};
function useSorted() {
  var _a, _b, _c, _d;

  for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
    args[_key11] = arguments[_key11];
  }

  var source = args[0];

  var compareFn = defaultCompare;
  var options = {};
  if (args.length === 2) {
    if (__WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(args[1]) === "object") {
      options = args[1];
      compareFn = (_a = options.compareFn) != null ? _a : defaultCompare;
    } else {
      compareFn = (_b = args[1]) != null ? _b : defaultCompare;
    }
  } else if (args.length > 2) {
    compareFn = (_c = args[1]) != null ? _c : defaultCompare;
    options = (_d = args[2]) != null ? _d : {};
  }
  var _options6 = options,
      _options6$dirty = _options6.dirty,
      dirty = _options6$dirty === undefined ? false : _options6$dirty,
      _options6$sortFn = _options6.sortFn,
      sortFn = _options6$sortFn === undefined ? defaultSortFn : _options6$sortFn;

  if (!dirty) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return sortFn([].concat(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(source))), compareFn);
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["d" /* watchEffect */])(function () {
    var result = sortFn(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(source), compareFn);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["a" /* isRef */])(source)) source.value = result;else source.splice.apply(source, [0, source.length].concat(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray___default()(result)));
  });
  return source;
}

function useSpeechRecognition() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$interimResul = options.interimResults,
      interimResults = _options$interimResul === undefined ? true : _options$interimResul,
      _options$continuous = options.continuous,
      continuous = _options$continuous === undefined ? true : _options$continuous,
      _options$window28 = options.window,
      window = _options$window28 === undefined ? defaultWindow : _options$window28;

  var lang = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["m" /* toRef */])(options.lang || "en-US");
  var isListening = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var isFinal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])("");
  var error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(void 0);
  var toggle = function toggle() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !isListening.value;

    isListening.value = value;
  };
  var start = function start() {
    isListening.value = true;
  };
  var stop = function stop() {
    isListening.value = false;
  };
  var SpeechRecognition = window && (window.SpeechRecognition || window.webkitSpeechRecognition);
  var isSupported = useSupported(function () {
    return SpeechRecognition;
  });
  var recognition = void 0;
  if (isSupported.value) {
    recognition = new SpeechRecognition();
    recognition.continuous = continuous;
    recognition.interimResults = interimResults;
    recognition.lang = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(lang);
    recognition.onstart = function () {
      isFinal.value = false;
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(lang, function (lang2) {
      if (recognition && !isListening.value) recognition.lang = lang2;
    });
    recognition.onresult = function (event) {
      var transcript = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from___default()(event.results).map(function (result2) {
        isFinal.value = result2.isFinal;
        return result2[0];
      }).map(function (result2) {
        return result2.transcript;
      }).join("");
      result.value = transcript;
      error.value = void 0;
    };
    recognition.onerror = function (event) {
      error.value = event;
    };
    recognition.onend = function () {
      isListening.value = false;
      recognition.lang = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(lang);
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(isListening, function () {
      if (isListening.value) recognition.start();else recognition.stop();
    });
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(function () {
    isListening.value = false;
  });
  return {
    isSupported: isSupported,
    isListening: isListening,
    isFinal: isFinal,
    recognition: recognition,
    result: result,
    error: error,
    toggle: toggle,
    start: start,
    stop: stop
  };
}

function useSpeechSynthesis(text) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$pitch = options.pitch,
      pitch = _options$pitch === undefined ? 1 : _options$pitch,
      _options$rate = options.rate,
      rate = _options$rate === undefined ? 1 : _options$rate,
      _options$volume = options.volume,
      volume = _options$volume === undefined ? 1 : _options$volume,
      _options$window29 = options.window,
      window = _options$window29 === undefined ? defaultWindow : _options$window29;

  var synth = window && window.speechSynthesis;
  var isSupported = useSupported(function () {
    return synth;
  });
  var isPlaying = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var status = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])("init");
  var spokenText = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["m" /* toRef */])(text || "");
  var lang = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["m" /* toRef */])(options.lang || "en-US");
  var error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(void 0);
  var toggle = function toggle() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !isPlaying.value;

    isPlaying.value = value;
  };
  var bindEventsForUtterance = function bindEventsForUtterance(utterance2) {
    utterance2.lang = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(lang);
    utterance2.voice = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(options.voice) || null;
    utterance2.pitch = pitch;
    utterance2.rate = rate;
    utterance2.volume = volume;
    utterance2.onstart = function () {
      isPlaying.value = true;
      status.value = "play";
    };
    utterance2.onpause = function () {
      isPlaying.value = false;
      status.value = "pause";
    };
    utterance2.onresume = function () {
      isPlaying.value = true;
      status.value = "play";
    };
    utterance2.onend = function () {
      isPlaying.value = false;
      status.value = "end";
    };
    utterance2.onerror = function (event) {
      error.value = event;
    };
  };
  var utterance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    isPlaying.value = false;
    status.value = "init";
    var newUtterance = new SpeechSynthesisUtterance(spokenText.value);
    bindEventsForUtterance(newUtterance);
    return newUtterance;
  });
  var speak = function speak() {
    synth.cancel();
    utterance && synth.speak(utterance.value);
  };
  var stop = function stop() {
    synth.cancel();
    isPlaying.value = false;
  };
  if (isSupported.value) {
    bindEventsForUtterance(utterance.value);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(lang, function (lang2) {
      if (utterance.value && !isPlaying.value) utterance.value.lang = lang2;
    });
    if (options.voice) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(options.voice, function () {
        synth.cancel();
      });
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(isPlaying, function () {
      if (isPlaying.value) synth.resume();else synth.pause();
    });
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(function () {
    isPlaying.value = false;
  });
  return {
    isSupported: isSupported,
    isPlaying: isPlaying,
    status: status,
    utterance: utterance,
    error: error,
    stop: stop,
    toggle: toggle,
    speak: speak
  };
}

function useStepper(steps, initialStep) {
  var stepsRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(steps);
  var stepNames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return Array.isArray(stepsRef.value) ? stepsRef.value : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(stepsRef.value);
  });
  var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(stepNames.value.indexOf(initialStep != null ? initialStep : stepNames.value[0]));
  var current = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return at(index.value);
  });
  var isFirst = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return index.value === 0;
  });
  var isLast = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return index.value === stepNames.value.length - 1;
  });
  var next = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return stepNames.value[index.value + 1];
  });
  var previous = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return stepNames.value[index.value - 1];
  });
  function at(index2) {
    if (Array.isArray(stepsRef.value)) return stepsRef.value[index2];
    return stepsRef.value[stepNames.value[index2]];
  }
  function get(step) {
    if (!stepNames.value.includes(step)) return;
    return at(stepNames.value.indexOf(step));
  }
  function goTo(step) {
    if (stepNames.value.includes(step)) index.value = stepNames.value.indexOf(step);
  }
  function goToNext() {
    if (isLast.value) return;
    index.value++;
  }
  function goToPrevious() {
    if (isFirst.value) return;
    index.value--;
  }
  function goBackTo(step) {
    if (isAfter(step)) goTo(step);
  }
  function isNext(step) {
    return stepNames.value.indexOf(step) === index.value + 1;
  }
  function isPrevious(step) {
    return stepNames.value.indexOf(step) === index.value - 1;
  }
  function isCurrent(step) {
    return stepNames.value.indexOf(step) === index.value;
  }
  function isBefore(step) {
    return index.value < stepNames.value.indexOf(step);
  }
  function isAfter(step) {
    return index.value > stepNames.value.indexOf(step);
  }
  return {
    steps: stepsRef,
    stepNames: stepNames,
    index: index,
    current: current,
    next: next,
    previous: previous,
    isFirst: isFirst,
    isLast: isLast,
    at: at,
    get: get,
    goTo: goTo,
    goToNext: goToNext,
    goToPrevious: goToPrevious,
    goBackTo: goBackTo,
    isNext: isNext,
    isPrevious: isPrevious,
    isCurrent: isCurrent,
    isBefore: isBefore,
    isAfter: isAfter
  };
}

var __defProp$4 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __getOwnPropSymbols$4 = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = function __defNormalProp$4(obj, key, value) {
  return key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$4 = function __spreadValues$4(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
  }if (__getOwnPropSymbols$4) {
    var _iteratorNormalCompletion36 = true;
    var _didIteratorError36 = false;
    var _iteratorError36 = undefined;

    try {
      for (var _iterator36 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$4(b)), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
        var prop = _step36.value;

        if (__propIsEnum$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError36 = true;
      _iteratorError36 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion36 && _iterator36.return) {
          _iterator36.return();
        }
      } finally {
        if (_didIteratorError36) {
          throw _iteratorError36;
        }
      }
    }
  }return a;
};
function useStorageAsync(key, initialValue, storage) {
  var _this7 = this;

  var read = function () {
    var _ref77 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee32(event) {
      var rawValue, value;
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              if (!(!storage || event && event.key !== key)) {
                _context32.next = 2;
                break;
              }

              return _context32.abrupt('return');

            case 2:
              _context32.prev = 2;

              if (!event) {
                _context32.next = 7;
                break;
              }

              _context32.t0 = event.newValue;
              _context32.next = 10;
              break;

            case 7:
              _context32.next = 9;
              return storage.getItem(key);

            case 9:
              _context32.t0 = _context32.sent;

            case 10:
              rawValue = _context32.t0;

              if (!(rawValue == null)) {
                _context32.next = 23;
                break;
              }

              data.value = rawInit;

              if (!(writeDefaults && rawInit !== null)) {
                _context32.next = 21;
                break;
              }

              _context32.t1 = storage;
              _context32.t2 = key;
              _context32.next = 18;
              return serializer.write(rawInit);

            case 18:
              _context32.t3 = _context32.sent;
              _context32.next = 21;
              return _context32.t1.setItem.call(_context32.t1, _context32.t2, _context32.t3);

            case 21:
              _context32.next = 33;
              break;

            case 23:
              if (!mergeDefaults) {
                _context32.next = 30;
                break;
              }

              _context32.next = 26;
              return serializer.read(rawValue);

            case 26:
              value = _context32.sent;

              if (typeof mergeDefaults === "function") data.value = mergeDefaults(value, rawInit);else if (type === "object" && !Array.isArray(value)) data.value = __spreadValues$4(__spreadValues$4({}, rawInit), value);else data.value = value;
              _context32.next = 33;
              break;

            case 30:
              _context32.next = 32;
              return serializer.read(rawValue);

            case 32:
              data.value = _context32.sent;

            case 33:
              _context32.next = 38;
              break;

            case 35:
              _context32.prev = 35;
              _context32.t4 = _context32['catch'](2);

              onError(_context32.t4);

            case 38:
            case 'end':
              return _context32.stop();
          }
        }
      }, _callee32, this, [[2, 35]]);
    }));

    return function read(_x115) {
      return _ref77.apply(this, arguments);
    };
  }();

  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var _a;
  var _options$flush3 = options.flush,
      flush = _options$flush3 === undefined ? "pre" : _options$flush3,
      _options$deep4 = options.deep,
      deep = _options$deep4 === undefined ? true : _options$deep4,
      _options$listenToStor3 = options.listenToStorageChanges,
      listenToStorageChanges = _options$listenToStor3 === undefined ? true : _options$listenToStor3,
      _options$writeDefault2 = options.writeDefaults,
      writeDefaults = _options$writeDefault2 === undefined ? true : _options$writeDefault2,
      _options$mergeDefault2 = options.mergeDefaults,
      mergeDefaults = _options$mergeDefault2 === undefined ? false : _options$mergeDefault2,
      shallow = options.shallow,
      _options$window30 = options.window,
      window = _options$window30 === undefined ? defaultWindow : _options$window30,
      eventFilter = options.eventFilter,
      _options$onError3 = options.onError,
      onError = _options$onError3 === undefined ? function (e) {
    console.error(e);
  } : _options$onError3;

  var rawInit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(initialValue);
  var type = guessSerializerType(rawInit);
  var data = (shallow ? __WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */] : __WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(initialValue);
  var serializer = (_a = options.serializer) != null ? _a : StorageSerializers[type];
  if (!storage) {
    try {
      storage = getSSRHandler("getDefaultStorage", function () {
        var _a2;
        return (_a2 = defaultWindow) == null ? void 0 : _a2.localStorage;
      })();
    } catch (e) {
      onError(e);
    }
  }

  read();
  if (window && listenToStorageChanges) useEventListener(window, "storage", function (e) {
    return __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      return read(e);
    });
  });
  if (storage) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["L" /* watchWithFilter */])(data, __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee33() {
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              _context33.prev = 0;

              if (!(data.value == null)) {
                _context33.next = 6;
                break;
              }

              _context33.next = 4;
              return storage.removeItem(key);

            case 4:
              _context33.next = 13;
              break;

            case 6:
              _context33.t0 = storage;
              _context33.t1 = key;
              _context33.next = 10;
              return serializer.write(data.value);

            case 10:
              _context33.t2 = _context33.sent;
              _context33.next = 13;
              return _context33.t0.setItem.call(_context33.t0, _context33.t1, _context33.t2);

            case 13:
              _context33.next = 18;
              break;

            case 15:
              _context33.prev = 15;
              _context33.t3 = _context33['catch'](0);

              onError(_context33.t3);

            case 18:
            case 'end':
              return _context33.stop();
          }
        }
      }, _callee33, _this7, [[0, 15]]);
    })), {
      flush: flush,
      deep: deep,
      eventFilter: eventFilter
    });
  }
  return data;
}

var _id = 0;
function useStyleTag(css) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var isLoaded = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var _options$document9 = options.document,
      document = _options$document9 === undefined ? defaultDocument : _options$document9,
      _options$immediate8 = options.immediate,
      immediate = _options$immediate8 === undefined ? true : _options$immediate8,
      _options$manual2 = options.manual,
      manual = _options$manual2 === undefined ? false : _options$manual2,
      _options$id = options.id,
      id = _options$id === undefined ? 'vueuse_styletag_' + ++_id : _options$id;

  var cssRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(css);
  var stop = function stop() {};
  var load = function load() {
    if (!document) return;
    var el = document.getElementById(id) || document.createElement("style");
    if (!el.isConnected) {
      el.type = "text/css";
      el.id = id;
      if (options.media) el.media = options.media;
      document.head.appendChild(el);
    }
    if (isLoaded.value) return;
    stop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(cssRef, function (value) {
      el.textContent = value;
    }, { immediate: true });
    isLoaded.value = true;
  };
  var unload = function unload() {
    if (!document || !isLoaded.value) return;
    stop();
    document.head.removeChild(document.getElementById(id));
    isLoaded.value = false;
  };
  if (immediate && !manual) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["g" /* tryOnMounted */])(load);
  if (!manual) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(unload);
  return {
    id: id,
    css: cssRef,
    unload: unload,
    load: load,
    isLoaded: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["s" /* readonly */])(isLoaded)
  };
}

function useSwipe(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$threshold3 = options.threshold,
      threshold = _options$threshold3 === undefined ? 50 : _options$threshold3,
      onSwipe = options.onSwipe,
      onSwipeEnd = options.onSwipeEnd,
      onSwipeStart = options.onSwipeStart,
      _options$passive2 = options.passive,
      passive = _options$passive2 === undefined ? true : _options$passive2,
      _options$window31 = options.window,
      window = _options$window31 === undefined ? defaultWindow : _options$window31;

  var coordsStart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])({ x: 0, y: 0 });
  var coordsEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])({ x: 0, y: 0 });
  var diffX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return coordsStart.x - coordsEnd.x;
  });
  var diffY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return coordsStart.y - coordsEnd.y;
  });
  var max = Math.max,
      abs = Math.abs;

  var isThresholdExceeded = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return max(abs(diffX.value), abs(diffY.value)) >= threshold;
  });
  var isSwiping = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var direction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    if (!isThresholdExceeded.value) return "none";
    if (abs(diffX.value) > abs(diffY.value)) {
      return diffX.value > 0 ? "left" : "right";
    } else {
      return diffY.value > 0 ? "up" : "down";
    }
  });
  var getTouchEventCoords = function getTouchEventCoords(e) {
    return [e.touches[0].clientX, e.touches[0].clientY];
  };
  var updateCoordsStart = function updateCoordsStart(x, y) {
    coordsStart.x = x;
    coordsStart.y = y;
  };
  var updateCoordsEnd = function updateCoordsEnd(x, y) {
    coordsEnd.x = x;
    coordsEnd.y = y;
  };
  var listenerOptions = void 0;
  var isPassiveEventSupported = checkPassiveEventSupport(window == null ? void 0 : window.document);
  if (!passive) listenerOptions = isPassiveEventSupported ? { passive: false, capture: true } : { capture: true };else listenerOptions = isPassiveEventSupported ? { passive: true } : { capture: false };
  var onTouchEnd = function onTouchEnd(e) {
    if (isSwiping.value) onSwipeEnd == null ? void 0 : onSwipeEnd(e, direction.value);
    isSwiping.value = false;
  };
  var stops = [useEventListener(target, "touchstart", function (e) {
    if (e.touches.length !== 1) return;
    if (listenerOptions.capture && !listenerOptions.passive) e.preventDefault();

    var _getTouchEventCoords = getTouchEventCoords(e),
        _getTouchEventCoords2 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_getTouchEventCoords, 2),
        x = _getTouchEventCoords2[0],
        y = _getTouchEventCoords2[1];

    updateCoordsStart(x, y);
    updateCoordsEnd(x, y);
    onSwipeStart == null ? void 0 : onSwipeStart(e);
  }, listenerOptions), useEventListener(target, "touchmove", function (e) {
    if (e.touches.length !== 1) return;

    var _getTouchEventCoords3 = getTouchEventCoords(e),
        _getTouchEventCoords4 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_getTouchEventCoords3, 2),
        x = _getTouchEventCoords4[0],
        y = _getTouchEventCoords4[1];

    updateCoordsEnd(x, y);
    if (!isSwiping.value && isThresholdExceeded.value) isSwiping.value = true;
    if (isSwiping.value) onSwipe == null ? void 0 : onSwipe(e);
  }, listenerOptions), useEventListener(target, "touchend", onTouchEnd, listenerOptions), useEventListener(target, "touchcancel", onTouchEnd, listenerOptions)];
  var stop = function stop() {
    return stops.forEach(function (s) {
      return s();
    });
  };
  return {
    isPassiveEventSupported: isPassiveEventSupported,
    isSwiping: isSwiping,
    direction: direction,
    coordsStart: coordsStart,
    coordsEnd: coordsEnd,
    lengthX: diffX,
    lengthY: diffY,
    stop: stop
  };
}
function checkPassiveEventSupport(document) {
  if (!document) return false;
  var supportsPassive = false;
  var optionsBlock = {
    get passive() {
      supportsPassive = true;
      return false;
    }
  };
  document.addEventListener("x", __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */], optionsBlock);
  document.removeEventListener("x", __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["a" /* noop */]);
  return supportsPassive;
}

function useTemplateRefsList() {
  var refs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])([]);
  refs.value.set = function (el) {
    if (el) refs.value.push(el);
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["B" /* onBeforeUpdate */])(function () {
    refs.value.length = 0;
  });
  return refs;
}

function useTextDirection() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$document10 = options.document,
      document = _options$document10 === undefined ? defaultDocument : _options$document10,
      _options$selector2 = options.selector,
      selector = _options$selector2 === undefined ? "html" : _options$selector2,
      _options$observe2 = options.observe,
      observe = _options$observe2 === undefined ? false : _options$observe2,
      _options$initialValue7 = options.initialValue,
      initialValue = _options$initialValue7 === undefined ? "ltr" : _options$initialValue7;

  function getValue() {
    var _a, _b;
    return (_b = (_a = document == null ? void 0 : document.querySelector(selector)) == null ? void 0 : _a.getAttribute("dir")) != null ? _b : initialValue;
  }
  var dir = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(getValue());
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["g" /* tryOnMounted */])(function () {
    return dir.value = getValue();
  });
  if (observe && document) {
    useMutationObserver(document.querySelector(selector), function () {
      return dir.value = getValue();
    }, { attributes: true });
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])({
    get: function get() {
      return dir.value;
    },
    set: function set(v) {
      var _a, _b;
      dir.value = v;
      if (!document) return;
      if (dir.value) (_a = document.querySelector(selector)) == null ? void 0 : _a.setAttribute("dir", dir.value);else (_b = document.querySelector(selector)) == null ? void 0 : _b.removeAttribute("dir");
    }
  });
}

function getRangesFromSelection(selection) {
  var _a;
  var rangeCount = (_a = selection.rangeCount) != null ? _a : 0;
  var ranges = new Array(rangeCount);
  for (var i = 0; i < rangeCount; i++) {
    var range = selection.getRangeAt(i);
    ranges[i] = range;
  }
  return ranges;
}
function useTextSelection() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window32 = options.window,
      window = _options$window32 === undefined ? defaultWindow : _options$window32;

  var selection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  var text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    var _a, _b;
    return (_b = (_a = selection.value) == null ? void 0 : _a.toString()) != null ? _b : "";
  });
  var ranges = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return selection.value ? getRangesFromSelection(selection.value) : [];
  });
  var rects = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return ranges.value.map(function (range) {
      return range.getBoundingClientRect();
    });
  });
  function onSelectionChange() {
    selection.value = null;
    if (window) selection.value = window.getSelection();
  }
  if (window) useEventListener(window.document, "selectionchange", onSelectionChange);
  return {
    text: text,
    rects: rects,
    ranges: ranges,
    selection: selection
  };
}

function useTextareaAutosize(options) {
  var textarea = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(options == null ? void 0 : options.element);
  var input = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(options == null ? void 0 : options.input);
  var textareaScrollHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(1);
  function triggerResize() {
    var _a, _b;
    if (!textarea.value) return;
    var height = "";
    textarea.value.style.height = "1px";
    textareaScrollHeight.value = (_a = textarea.value) == null ? void 0 : _a.scrollHeight;
    if (options == null ? void 0 : options.styleTarget) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(options.styleTarget).style.height = textareaScrollHeight.value + 'px';else height = textareaScrollHeight.value + 'px';
    textarea.value.style.height = height;
    (_b = options == null ? void 0 : options.onResize) == null ? void 0 : _b.call(options);
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])([input, textarea], function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["t" /* nextTick */])(triggerResize);
  }, { immediate: true });
  useResizeObserver(textarea, function () {
    return triggerResize();
  });
  if (options == null ? void 0 : options.watch) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(options.watch, triggerResize, { immediate: true, deep: true });
  return {
    textarea: textarea,
    input: input,
    triggerResize: triggerResize
  };
}

var __defProp$3 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __defProps$1 = __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$1 = __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$3 = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = function __defNormalProp$3(obj, key, value) {
  return key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$3 = function __spreadValues$3(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
  }if (__getOwnPropSymbols$3) {
    var _iteratorNormalCompletion37 = true;
    var _didIteratorError37 = false;
    var _iteratorError37 = undefined;

    try {
      for (var _iterator37 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$3(b)), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
        var prop = _step37.value;

        if (__propIsEnum$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError37 = true;
      _iteratorError37 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion37 && _iterator37.return) {
          _iterator37.return();
        }
      } finally {
        if (_didIteratorError37) {
          throw _iteratorError37;
        }
      }
    }
  }return a;
};
var __spreadProps$1 = function __spreadProps$1(a, b) {
  return __defProps$1(a, __getOwnPropDescs$1(b));
};
function useThrottledRefHistory(source) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$throttle2 = options.throttle,
      throttle = _options$throttle2 === undefined ? 200 : _options$throttle2,
      _options$trailing = options.trailing,
      trailing = _options$trailing === undefined ? true : _options$trailing;

  var filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["E" /* throttleFilter */])(throttle, trailing);
  var history = useRefHistory(source, __spreadProps$1(__spreadValues$3({}, options), { eventFilter: filter }));
  return __spreadValues$3({}, history);
}

var __defProp$2 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __getOwnPropSymbols$2 = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = function __defNormalProp$2(obj, key, value) {
  return key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$2 = function __spreadValues$2(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  }if (__getOwnPropSymbols$2) {
    var _iteratorNormalCompletion38 = true;
    var _didIteratorError38 = false;
    var _iteratorError38 = undefined;

    try {
      for (var _iterator38 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$2(b)), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
        var prop = _step38.value;

        if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError38 = true;
      _iteratorError38 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion38 && _iterator38.return) {
          _iterator38.return();
        }
      } finally {
        if (_didIteratorError38) {
          throw _iteratorError38;
        }
      }
    }
  }return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }if (source != null && __getOwnPropSymbols$2) {
    var _iteratorNormalCompletion39 = true;
    var _didIteratorError39 = false;
    var _iteratorError39 = undefined;

    try {
      for (var _iterator39 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$2(source)), _step39; !(_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done); _iteratorNormalCompletion39 = true) {
        var prop = _step39.value;

        if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _didIteratorError39 = true;
      _iteratorError39 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion39 && _iterator39.return) {
          _iterator39.return();
        }
      } finally {
        if (_didIteratorError39) {
          throw _iteratorError39;
        }
      }
    }
  }return target;
};
var DEFAULT_UNITS = [{ max: 6e4, value: 1e3, name: "second" }, { max: 276e4, value: 6e4, name: "minute" }, { max: 72e6, value: 36e5, name: "hour" }, { max: 5184e5, value: 864e5, name: "day" }, { max: 24192e5, value: 6048e5, name: "week" }, { max: 28512e6, value: 2592e6, name: "month" }, { max: Infinity, value: 31536e6, name: "year" }];
var DEFAULT_MESSAGES = {
  justNow: "just now",
  past: function past(n) {
    return n.match(/\d/) ? n + ' ago' : n;
  },
  future: function future(n) {
    return n.match(/\d/) ? 'in ' + n : n;
  },
  month: function month(n, past) {
    return n === 1 ? past ? "last month" : "next month" : n + ' month' + (n > 1 ? "s" : "");
  },
  year: function year(n, past) {
    return n === 1 ? past ? "last year" : "next year" : n + ' year' + (n > 1 ? "s" : "");
  },
  day: function day(n, past) {
    return n === 1 ? past ? "yesterday" : "tomorrow" : n + ' day' + (n > 1 ? "s" : "");
  },
  week: function week(n, past) {
    return n === 1 ? past ? "last week" : "next week" : n + ' week' + (n > 1 ? "s" : "");
  },
  hour: function hour(n) {
    return n + ' hour' + (n > 1 ? "s" : "");
  },
  minute: function minute(n) {
    return n + ' minute' + (n > 1 ? "s" : "");
  },
  second: function second(n) {
    return n + ' second' + (n > 1 ? "s" : "");
  },
  invalid: ""
};
function DEFAULT_FORMATTER(date) {
  return date.toISOString().slice(0, 10);
}
function useTimeAgo(time) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$controls3 = options.controls,
      exposeControls = _options$controls3 === undefined ? false : _options$controls3,
      _options$updateInterv = options.updateInterval,
      updateInterval = _options$updateInterv === undefined ? 3e4 : _options$updateInterv;
  var _a = useNow({ interval: updateInterval, controls: true }),
      now = _a.now,
      controls = __objRest(_a, ["now"]);
  var timeAgo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return formatTimeAgo(new Date(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(time)), options, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(now));
  });
  if (exposeControls) {
    return __spreadValues$2({
      timeAgo: timeAgo
    }, controls);
  } else {
    return timeAgo;
  }
}
function formatTimeAgo(from) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var now = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();

  var _a;
  var max = options.max,
      _options$messages = options.messages,
      messages = _options$messages === undefined ? DEFAULT_MESSAGES : _options$messages,
      _options$fullDateForm = options.fullDateFormatter,
      fullDateFormatter = _options$fullDateForm === undefined ? DEFAULT_FORMATTER : _options$fullDateForm,
      _options$units = options.units,
      units = _options$units === undefined ? DEFAULT_UNITS : _options$units,
      _options$showSecond = options.showSecond,
      showSecond = _options$showSecond === undefined ? false : _options$showSecond,
      _options$rounding = options.rounding,
      rounding = _options$rounding === undefined ? "round" : _options$rounding;

  var roundFn = typeof rounding === "number" ? function (n) {
    return +n.toFixed(rounding);
  } : Math[rounding];
  var diff = +now - +from;
  var absDiff = Math.abs(diff);
  function getValue(diff2, unit) {
    return roundFn(Math.abs(diff2) / unit.value);
  }
  function format(diff2, unit) {
    var val = getValue(diff2, unit);
    var past = diff2 > 0;
    var str = applyFormat(unit.name, val, past);
    return applyFormat(past ? "past" : "future", str, past);
  }
  function applyFormat(name, val, isPast) {
    var formatter = messages[name];
    if (typeof formatter === "function") return formatter(val, isPast);
    return formatter.replace("{0}", val.toString());
  }
  if (absDiff < 6e4 && !showSecond) return messages.justNow;
  if (typeof max === "number" && absDiff > max) return fullDateFormatter(new Date(from));
  if (typeof max === "string") {
    var unitMax = (_a = units.find(function (i) {
      return i.name === max;
    })) == null ? void 0 : _a.max;
    if (unitMax && absDiff > unitMax) return fullDateFormatter(new Date(from));
  }
  var _iteratorNormalCompletion40 = true;
  var _didIteratorError40 = false;
  var _iteratorError40 = undefined;

  try {
    for (var _iterator40 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(units.entries()), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
      var _ref79 = _step40.value;

      var _ref80 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref79, 2);

      var idx = _ref80[0];
      var unit = _ref80[1];

      var val = getValue(diff, unit);
      if (val <= 0 && units[idx - 1]) return format(diff, units[idx - 1]);
      if (absDiff < unit.max) return format(diff, unit);
    }
  } catch (err) {
    _didIteratorError40 = true;
    _iteratorError40 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion40 && _iterator40.return) {
        _iterator40.return();
      }
    } finally {
      if (_didIteratorError40) {
        throw _iteratorError40;
      }
    }
  }

  return messages.invalid;
}

function useTimeoutPoll(fn, interval, timeoutPollOptions) {
  var loop = function () {
    var _ref81 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee34() {
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              if (isActive.value) {
                _context34.next = 2;
                break;
              }

              return _context34.abrupt('return');

            case 2:
              _context34.next = 4;
              return fn();

            case 4:
              start();

            case 5:
            case 'end':
              return _context34.stop();
          }
        }
      }, _callee34, this);
    }));

    return function loop() {
      return _ref81.apply(this, arguments);
    };
  }();

  var _useTimeoutFn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["p" /* useTimeoutFn */])(loop, interval),
      start = _useTimeoutFn.start;

  var isActive = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);

  function resume() {
    if (!isActive.value) {
      isActive.value = true;
      loop();
    }
  }
  function pause() {
    isActive.value = false;
  }
  if (timeoutPollOptions == null ? void 0 : timeoutPollOptions.immediate) resume();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(pause);
  return {
    isActive: isActive,
    pause: pause,
    resume: resume
  };
}

var __defProp$1 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __getOwnPropSymbols$1 = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp$1(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues$1(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  }if (__getOwnPropSymbols$1) {
    var _iteratorNormalCompletion41 = true;
    var _didIteratorError41 = false;
    var _iteratorError41 = undefined;

    try {
      for (var _iterator41 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$1(b)), _step41; !(_iteratorNormalCompletion41 = (_step41 = _iterator41.next()).done); _iteratorNormalCompletion41 = true) {
        var prop = _step41.value;

        if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError41 = true;
      _iteratorError41 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion41 && _iterator41.return) {
          _iterator41.return();
        }
      } finally {
        if (_didIteratorError41) {
          throw _iteratorError41;
        }
      }
    }
  }return a;
};
function useTimestamp() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$controls4 = options.controls,
      exposeControls = _options$controls4 === undefined ? false : _options$controls4,
      _options$offset2 = options.offset,
      offset = _options$offset2 === undefined ? 0 : _options$offset2,
      _options$immediate9 = options.immediate,
      immediate = _options$immediate9 === undefined ? true : _options$immediate9,
      _options$interval5 = options.interval,
      interval = _options$interval5 === undefined ? "requestAnimationFrame" : _options$interval5,
      callback = options.callback;

  var ts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["s" /* timestamp */])() + offset);
  var update = function update() {
    return ts.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["s" /* timestamp */])() + offset;
  };
  var cb = callback ? function () {
    update();
    callback(ts.value);
  } : update;
  var controls = interval === "requestAnimationFrame" ? useRafFn(cb, { immediate: immediate }) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["A" /* useIntervalFn */])(cb, interval, { immediate: immediate });
  if (exposeControls) {
    return __spreadValues$1({
      timestamp: ts
    }, controls);
  } else {
    return ts;
  }
}

function useTitle() {
  var newTitle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _a, _b;
  var _options$document11 = options.document,
      document = _options$document11 === undefined ? defaultDocument : _options$document11;

  var title = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["m" /* toRef */])((_a = newTitle != null ? newTitle : document == null ? void 0 : document.title) != null ? _a : null);
  var isReadonly = newTitle && typeof newTitle === "function";
  function format(t) {
    if (!("titleTemplate" in options)) return t;
    var template = options.titleTemplate || "%s";
    return typeof template === "function" ? template(t) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(template).replace(/%s/g, t);
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(title, function (t, o) {
    if (t !== o && document) document.title = format(typeof t === "string" ? t : "");
  }, { immediate: true });
  if (options.observe && !options.titleTemplate && document && !isReadonly) {
    useMutationObserver((_b = document.head) == null ? void 0 : _b.querySelector("title"), function () {
      if (document && document.title !== title.value) title.value = format(document.title);
    }, { childList: true });
  }
  return title;
}

var __defProp = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_define_property___default.a;
var __defProps = __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs = __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }if (__getOwnPropSymbols) {
    var _iteratorNormalCompletion42 = true;
    var _didIteratorError42 = false;
    var _iteratorError42 = undefined;

    try {
      for (var _iterator42 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols(b)), _step42; !(_iteratorNormalCompletion42 = (_step42 = _iterator42.next()).done); _iteratorNormalCompletion42 = true) {
        var prop = _step42.value;

        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError42 = true;
      _iteratorError42 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion42 && _iterator42.return) {
          _iterator42.return();
        }
      } finally {
        if (_didIteratorError42) {
          throw _iteratorError42;
        }
      }
    }
  }return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var _TransitionPresets = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
var TransitionPresets = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, { linear: __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["M" /* identity */] }, _TransitionPresets);
function createEasingFunction(_ref82) {
  var _ref83 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref82, 4),
      p0 = _ref83[0],
      p1 = _ref83[1],
      p2 = _ref83[2],
      p3 = _ref83[3];

  var a = function a(a1, a2) {
    return 1 - 3 * a2 + 3 * a1;
  };
  var b = function b(a1, a2) {
    return 3 * a2 - 6 * a1;
  };
  var c = function c(a1) {
    return 3 * a1;
  };
  var calcBezier = function calcBezier(t, a1, a2) {
    return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
  };
  var getSlope = function getSlope(t, a1, a2) {
    return 3 * a(a1, a2) * t * t + 2 * b(a1, a2) * t + c(a1);
  };
  var getTforX = function getTforX(x) {
    var aGuessT = x;
    for (var i = 0; i < 4; ++i) {
      var currentSlope = getSlope(aGuessT, p0, p2);
      if (currentSlope === 0) return aGuessT;
      var currentX = calcBezier(aGuessT, p0, p2) - x;
      aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
  };
  return function (x) {
    return p0 === p1 && p2 === p3 ? x : calcBezier(getTforX(x), p1, p3);
  };
}
function lerp(a, b, alpha) {
  return a + alpha * (b - a);
}
function toVec(t) {
  return (typeof t === "number" ? [t] : t) || [];
}
function executeTransition(source, from, to) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var _a, _b;
  var fromVal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(from);
  var toVal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(to);
  var v1 = toVec(fromVal);
  var v2 = toVec(toVal);
  var duration = (_a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(options.duration)) != null ? _a : 1e3;
  var startedAt = Date.now();
  var endAt = Date.now() + duration;
  var trans = typeof options.transition === "function" ? options.transition : (_b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(options.transition)) != null ? _b : __WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["M" /* identity */];
  var ease = typeof trans === "function" ? trans : createEasingFunction(trans);
  return new __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a(function (resolve) {
    source.value = fromVal;
    var tick = function tick() {
      var _a2;
      if ((_a2 = options.abort) == null ? void 0 : _a2.call(options)) {
        resolve();
        return;
      }
      var now = Date.now();
      var alpha = ease((now - startedAt) / duration);
      var arr = toVec(source.value).map(function (n, i) {
        return lerp(v1[i], v2[i], alpha);
      });
      if (Array.isArray(source.value)) source.value = arr.map(function (n, i) {
        var _a3, _b2;
        return lerp((_a3 = v1[i]) != null ? _a3 : 0, (_b2 = v2[i]) != null ? _b2 : 0, alpha);
      });else if (typeof source.value === "number") source.value = arr[0];
      if (now < endAt) {
        requestAnimationFrame(tick);
      } else {
        source.value = toVal;
        resolve();
      }
    };
    tick();
  });
}
function useTransition(source) {
  var _this8 = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var currentId = 0;
  var sourceVal = function sourceVal() {
    var v = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(source);
    return typeof v === "number" ? v : v.map(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */]);
  };
  var outputRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(sourceVal());
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(sourceVal, function () {
    var _ref84 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee35(to) {
      var _a, _b, id, toVal;

      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(options.disabled)) {
                _context35.next = 2;
                break;
              }

              return _context35.abrupt('return');

            case 2:
              id = ++currentId;

              if (!options.delay) {
                _context35.next = 6;
                break;
              }

              _context35.next = 6;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["k" /* promiseTimeout */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(options.delay));

            case 6:
              if (!(id !== currentId)) {
                _context35.next = 8;
                break;
              }

              return _context35.abrupt('return');

            case 8:
              toVal = Array.isArray(to) ? to.map(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(to);

              (_a = options.onStarted) == null ? void 0 : _a.call(options);
              _context35.next = 12;
              return executeTransition(outputRef, outputRef.value, toVal, __spreadProps(__spreadValues({}, options), {
                abort: function abort() {
                  var _a2;
                  return id !== currentId || ((_a2 = options.abort) == null ? void 0 : _a2.call(options));
                }
              }));

            case 12:
              (_b = options.onFinished) == null ? void 0 : _b.call(options);

            case 13:
            case 'end':
              return _context35.stop();
          }
        }
      }, _callee35, _this8);
    }));

    return function (_x129) {
      return _ref84.apply(this, arguments);
    };
  }(), { deep: true });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(options.disabled);
  }, function (disabled) {
    if (disabled) {
      currentId++;
      outputRef.value = sourceVal();
    }
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(function () {
    currentId++;
  });
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["c" /* toValue */])(options.disabled) ? sourceVal() : outputRef.value;
  });
}

function useUrlSearchParams() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "history";
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$initialValue8 = options.initialValue,
      initialValue = _options$initialValue8 === undefined ? {} : _options$initialValue8,
      _options$removeNullis = options.removeNullishValues,
      removeNullishValues = _options$removeNullis === undefined ? true : _options$removeNullis,
      _options$removeFalsyV = options.removeFalsyValues,
      removeFalsyValues = _options$removeFalsyV === undefined ? false : _options$removeFalsyV,
      _options$write = options.write,
      enableWrite = _options$write === undefined ? true : _options$write,
      _options$window33 = options.window,
      window = _options$window33 === undefined ? defaultWindow : _options$window33;

  if (!window) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])(initialValue);
  var state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["u" /* reactive */])({});
  function getRawParams() {
    if (mode === "history") {
      return window.location.search || "";
    } else if (mode === "hash") {
      var hash = window.location.hash || "";
      var index = hash.indexOf("?");
      return index > 0 ? hash.slice(index) : "";
    } else {
      return (window.location.hash || "").replace(/^#/, "");
    }
  }
  function constructQuery(params) {
    var stringified = params.toString();
    if (mode === "history") return '' + (stringified ? '?' + stringified : "") + (window.location.hash || "");
    if (mode === "hash-params") return '' + (window.location.search || "") + (stringified ? '#' + stringified : "");
    var hash = window.location.hash || "#";
    var index = hash.indexOf("?");
    if (index > 0) return '' + hash.slice(0, index) + (stringified ? '?' + stringified : "");
    return '' + hash + (stringified ? '?' + stringified : "");
  }
  function read() {
    return new URLSearchParams(getRawParams());
  }
  function updateState(params) {
    var unusedKeys = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(state));
    var _iteratorNormalCompletion43 = true;
    var _didIteratorError43 = false;
    var _iteratorError43 = undefined;

    try {
      for (var _iterator43 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(params.keys()), _step43; !(_iteratorNormalCompletion43 = (_step43 = _iterator43.next()).done); _iteratorNormalCompletion43 = true) {
        var key = _step43.value;

        var paramsForKey = params.getAll(key);
        state[key] = paramsForKey.length > 1 ? paramsForKey : params.get(key) || "";
        unusedKeys.delete(key);
      }
    } catch (err) {
      _didIteratorError43 = true;
      _iteratorError43 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion43 && _iterator43.return) {
          _iterator43.return();
        }
      } finally {
        if (_didIteratorError43) {
          throw _iteratorError43;
        }
      }
    }

    __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from___default()(unusedKeys).forEach(function (key) {
      return delete state[key];
    });
  }

  var _pausableWatch2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["q" /* pausableWatch */])(state, function () {
    var params = new URLSearchParams("");
    __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(state).forEach(function (key) {
      var mapEntry = state[key];
      if (Array.isArray(mapEntry)) mapEntry.forEach(function (value) {
        return params.append(key, value);
      });else if (removeNullishValues && mapEntry == null) params.delete(key);else if (removeFalsyValues && !mapEntry) params.delete(key);else params.set(key, mapEntry);
    });
    write(params);
  }, { deep: true }),
      pause = _pausableWatch2.pause,
      resume = _pausableWatch2.resume;

  function write(params, shouldUpdate) {
    pause();
    if (shouldUpdate) updateState(params);
    window.history.replaceState(window.history.state, window.document.title, window.location.pathname + constructQuery(params));
    resume();
  }
  function onChanged() {
    if (!enableWrite) return;
    write(read(), true);
  }
  useEventListener(window, "popstate", onChanged, false);
  if (mode !== "history") useEventListener(window, "hashchange", onChanged, false);
  var initial = read();
  if (initial.keys().next().value) updateState(initial);else __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()(state, initialValue);
  return state;
}

function useUserMedia() {
  var _start = function () {
    var _ref85 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee36() {
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              if (!(!isSupported.value || stream.value)) {
                _context36.next = 2;
                break;
              }

              return _context36.abrupt('return');

            case 2:
              _context36.next = 4;
              return navigator.mediaDevices.getUserMedia({
                video: getDeviceOptions("video"),
                audio: getDeviceOptions("audio")
              });

            case 4:
              stream.value = _context36.sent;
              return _context36.abrupt('return', stream.value);

            case 6:
            case 'end':
              return _context36.stop();
          }
        }
      }, _callee36, this);
    }));

    return function _start() {
      return _ref85.apply(this, arguments);
    };
  }();

  var start = function () {
    var _ref86 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee37() {
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              _context37.next = 2;
              return _start();

            case 2:
              if (stream.value) enabled.value = true;
              return _context37.abrupt('return', stream.value);

            case 4:
            case 'end':
              return _context37.stop();
          }
        }
      }, _callee37, this);
    }));

    return function start() {
      return _ref86.apply(this, arguments);
    };
  }();

  var restart = function () {
    var _ref87 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee38() {
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38) {
        while (1) {
          switch (_context38.prev = _context38.next) {
            case 0:
              _stop();
              _context38.next = 3;
              return start();

            case 3:
              return _context38.abrupt('return', _context38.sent);

            case 4:
            case 'end':
              return _context38.stop();
          }
        }
      }, _callee38, this);
    }));

    return function restart() {
      return _ref87.apply(this, arguments);
    };
  }();

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _a, _b;
  var enabled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])((_a = options.enabled) != null ? _a : false);
  var autoSwitch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])((_b = options.autoSwitch) != null ? _b : true);
  var constraints = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(options.constraints);
  var _options$navigator8 = options.navigator,
      navigator = _options$navigator8 === undefined ? defaultNavigator : _options$navigator8;

  var isSupported = useSupported(function () {
    var _a2;
    return (_a2 = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : _a2.getUserMedia;
  });
  var stream = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])();
  function getDeviceOptions(type) {
    switch (type) {
      case "video":
        {
          if (constraints.value) return constraints.value.video || false;
          break;
        }
      case "audio":
        {
          if (constraints.value) return constraints.value.audio || false;
          break;
        }
    }
  }

  function _stop() {
    var _a2;
    (_a2 = stream.value) == null ? void 0 : _a2.getTracks().forEach(function (t) {
      return t.stop();
    });
    stream.value = void 0;
  }
  function stop() {
    _stop();
    enabled.value = false;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(enabled, function (v) {
    if (v) _start();else _stop();
  }, { immediate: true });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(constraints, function () {
    if (autoSwitch.value && stream.value) restart();
  }, { immediate: true });
  return {
    isSupported: isSupported,
    stream: stream,
    start: start,
    stop: stop,
    restart: restart,
    constraints: constraints,
    enabled: enabled,
    autoSwitch: autoSwitch
  };
}

function useVModel(props, key, emit) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var _a, _b, _c, _d, _e;
  var _options$clone3 = options.clone,
      clone = _options$clone3 === undefined ? false : _options$clone3,
      _options$passive3 = options.passive,
      passive = _options$passive3 === undefined ? false : _options$passive3,
      eventName = options.eventName,
      _options$deep5 = options.deep,
      deep = _options$deep5 === undefined ? false : _options$deep5,
      defaultValue = options.defaultValue,
      shouldEmit = options.shouldEmit;

  var vm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["o" /* getCurrentInstance */])();
  var _emit = emit || (vm == null ? void 0 : vm.emit) || ((_a = vm == null ? void 0 : vm.$emit) == null ? void 0 : _a.bind(vm)) || ((_c = (_b = vm == null ? void 0 : vm.proxy) == null ? void 0 : _b.$emit) == null ? void 0 : _c.bind(vm == null ? void 0 : vm.proxy));
  var event = eventName;
  if (!key) {
    if (__WEBPACK_IMPORTED_MODULE_25_vue_demi__["z" /* isVue2 */]) {
      var modelOptions = (_e = (_d = vm == null ? void 0 : vm.proxy) == null ? void 0 : _d.$options) == null ? void 0 : _e.model;
      key = (modelOptions == null ? void 0 : modelOptions.value) || "value";
      if (!eventName) event = (modelOptions == null ? void 0 : modelOptions.event) || "input";
    } else {
      key = "modelValue";
    }
  }
  event = event || 'update:' + key.toString();
  var cloneFn = function cloneFn(val) {
    return !clone ? val : typeof clone === "function" ? clone(val) : cloneFnJSON(val);
  };
  var getValue = function getValue() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["N" /* isDef */])(props[key]) ? cloneFn(props[key]) : defaultValue;
  };
  var triggerEmit = function triggerEmit(value) {
    if (shouldEmit) {
      if (shouldEmit(value)) _emit(event, value);
    } else {
      _emit(event, value);
    }
  };
  if (passive) {
    var initialValue = getValue();
    var proxy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(initialValue);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(function () {
      return props[key];
    }, function (v) {
      return proxy.value = cloneFn(v);
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(proxy, function (v) {
      if (v !== props[key] || deep) triggerEmit(v);
    }, { deep: deep });
    return proxy;
  } else {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])({
      get: function get() {
        return getValue();
      },
      set: function set(value) {
        triggerEmit(value);
      }
    });
  }
}

function useVModels(props, emit) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var ret = {};
  for (var key in props) {
    ret[key] = useVModel(props, key, emit, options);
  }return ret;
}

function useVibrate(options) {
  var _ref88 = options || {},
      _ref88$pattern = _ref88.pattern,
      pattern = _ref88$pattern === undefined ? [] : _ref88$pattern,
      _ref88$interval = _ref88.interval,
      interval = _ref88$interval === undefined ? 0 : _ref88$interval,
      _ref88$navigator = _ref88.navigator,
      navigator = _ref88$navigator === undefined ? defaultNavigator : _ref88$navigator;

  var isSupported = useSupported(function () {
    return typeof navigator !== "undefined" && "vibrate" in navigator;
  });
  var patternRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["m" /* toRef */])(pattern);
  var intervalControls = void 0;
  var vibrate = function vibrate() {
    var pattern2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : patternRef.value;

    if (isSupported.value) navigator.vibrate(pattern2);
  };
  var stop = function stop() {
    if (isSupported.value) navigator.vibrate(0);
    intervalControls == null ? void 0 : intervalControls.pause();
  };
  if (interval > 0) {
    intervalControls = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["A" /* useIntervalFn */])(vibrate, interval, {
      immediate: false,
      immediateCallback: false
    });
  }
  return {
    isSupported: isSupported,
    pattern: pattern,
    intervalControls: intervalControls,
    vibrate: vibrate,
    stop: stop
  };
}

function useVirtualList(list, options) {
  var _ref89 = "itemHeight" in options ? useVerticalVirtualList(options, list) : useHorizontalVirtualList(options, list),
      containerStyle = _ref89.containerStyle,
      wrapperProps = _ref89.wrapperProps,
      scrollTo = _ref89.scrollTo,
      calculateRange = _ref89.calculateRange,
      currentList = _ref89.currentList,
      containerRef = _ref89.containerRef;

  return {
    list: currentList,
    scrollTo: scrollTo,
    containerProps: {
      ref: containerRef,
      onScroll: function onScroll() {
        calculateRange();
      },
      style: containerStyle
    },
    wrapperProps: wrapperProps
  };
}
function useVirtualListResources(list) {
  var containerRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  var size = useElementSize(containerRef);
  var currentList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])([]);
  var source = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])(list);
  var state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])({ start: 0, end: 10 });
  return { state: state, source: source, currentList: currentList, size: size, containerRef: containerRef };
}
function createGetViewCapacity(state, source, itemSize) {
  return function (containerSize) {
    if (typeof itemSize === "number") return Math.ceil(containerSize / itemSize);
    var _state$value$start = state.value.start,
        start = _state$value$start === undefined ? 0 : _state$value$start;

    var sum = 0;
    var capacity = 0;
    for (var i = start; i < source.value.length; i++) {
      var size = itemSize(i);
      sum += size;
      capacity = i;
      if (sum > containerSize) break;
    }
    return capacity - start;
  };
}
function createGetOffset(source, itemSize) {
  return function (scrollDirection) {
    if (typeof itemSize === "number") return Math.floor(scrollDirection / itemSize) + 1;
    var sum = 0;
    var offset = 0;
    for (var i = 0; i < source.value.length; i++) {
      var size = itemSize(i);
      sum += size;
      if (sum >= scrollDirection) {
        offset = i;
        break;
      }
    }
    return offset + 1;
  };
}
function createCalculateRange(type, overscan, getOffset, getViewCapacity, _ref90) {
  var containerRef = _ref90.containerRef,
      state = _ref90.state,
      currentList = _ref90.currentList,
      source = _ref90.source;

  return function () {
    var element = containerRef.value;
    if (element) {
      var offset = getOffset(type === "vertical" ? element.scrollTop : element.scrollLeft);
      var viewCapacity = getViewCapacity(type === "vertical" ? element.clientHeight : element.clientWidth);
      var from = offset - overscan;
      var to = offset + viewCapacity + overscan;
      state.value = {
        start: from < 0 ? 0 : from,
        end: to > source.value.length ? source.value.length : to
      };
      currentList.value = source.value.slice(state.value.start, state.value.end).map(function (ele, index) {
        return {
          data: ele,
          index: index + state.value.start
        };
      });
    }
  };
}
function createGetDistance(itemSize, source) {
  return function (index) {
    if (typeof itemSize === "number") {
      var size2 = index * itemSize;
      return size2;
    }
    var size = source.value.slice(0, index).reduce(function (sum, _, i) {
      return sum + itemSize(i);
    }, 0);
    return size;
  };
}
function useWatchForSizes(size, list, calculateRange) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])([size.width, size.height, list], function () {
    calculateRange();
  });
}
function createComputedTotalSize(itemSize, source) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    if (typeof itemSize === "number") return source.value.length * itemSize;
    return source.value.reduce(function (sum, _, index) {
      return sum + itemSize(index);
    }, 0);
  });
}
var scrollToDictionaryForElementScrollKey = {
  horizontal: "scrollLeft",
  vertical: "scrollTop"
};
function createScrollTo(type, calculateRange, getDistance, containerRef) {
  return function (index) {
    if (containerRef.value) {
      containerRef.value[scrollToDictionaryForElementScrollKey[type]] = getDistance(index);
      calculateRange();
    }
  };
}
function useHorizontalVirtualList(options, list) {
  var resources = useVirtualListResources(list);
  var state = resources.state,
      source = resources.source,
      currentList = resources.currentList,
      size = resources.size,
      containerRef = resources.containerRef;

  var containerStyle = { overflowX: "auto" };
  var itemWidth = options.itemWidth,
      _options$overscan = options.overscan,
      overscan = _options$overscan === undefined ? 5 : _options$overscan;

  var getViewCapacity = createGetViewCapacity(state, source, itemWidth);
  var getOffset = createGetOffset(source, itemWidth);
  var calculateRange = createCalculateRange("horizontal", overscan, getOffset, getViewCapacity, resources);
  var getDistanceLeft = createGetDistance(itemWidth, source);
  var offsetLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return getDistanceLeft(state.value.start);
  });
  var totalWidth = createComputedTotalSize(itemWidth, source);
  useWatchForSizes(size, list, calculateRange);
  var scrollTo = createScrollTo("horizontal", calculateRange, getDistanceLeft, containerRef);
  var wrapperProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return {
      style: {
        height: "100%",
        width: totalWidth.value - offsetLeft.value + 'px',
        marginLeft: offsetLeft.value + 'px',
        display: "flex"
      }
    };
  });
  return {
    scrollTo: scrollTo,
    calculateRange: calculateRange,
    wrapperProps: wrapperProps,
    containerStyle: containerStyle,
    currentList: currentList,
    containerRef: containerRef
  };
}
function useVerticalVirtualList(options, list) {
  var resources = useVirtualListResources(list);
  var state = resources.state,
      source = resources.source,
      currentList = resources.currentList,
      size = resources.size,
      containerRef = resources.containerRef;

  var containerStyle = { overflowY: "auto" };
  var itemHeight = options.itemHeight,
      _options$overscan2 = options.overscan,
      overscan = _options$overscan2 === undefined ? 5 : _options$overscan2;

  var getViewCapacity = createGetViewCapacity(state, source, itemHeight);
  var getOffset = createGetOffset(source, itemHeight);
  var calculateRange = createCalculateRange("vertical", overscan, getOffset, getViewCapacity, resources);
  var getDistanceTop = createGetDistance(itemHeight, source);
  var offsetTop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return getDistanceTop(state.value.start);
  });
  var totalHeight = createComputedTotalSize(itemHeight, source);
  useWatchForSizes(size, list, calculateRange);
  var scrollTo = createScrollTo("vertical", calculateRange, getDistanceTop, containerRef);
  var wrapperProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["e" /* computed */])(function () {
    return {
      style: {
        width: "100%",
        height: totalHeight.value - offsetTop.value + 'px',
        marginTop: offsetTop.value + 'px'
      }
    };
  });
  return {
    calculateRange: calculateRange,
    scrollTo: scrollTo,
    containerStyle: containerStyle,
    wrapperProps: wrapperProps,
    currentList: currentList,
    containerRef: containerRef
  };
}

function useWakeLock() {
  var onVisibilityChange = function () {
    var _ref91 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee39() {
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee39$(_context39) {
        while (1) {
          switch (_context39.prev = _context39.next) {
            case 0:
              if (!(!isSupported.value || !wakeLock)) {
                _context39.next = 2;
                break;
              }

              return _context39.abrupt('return');

            case 2:
              if (!(document && document.visibilityState === "visible")) {
                _context39.next = 6;
                break;
              }

              _context39.next = 5;
              return navigator.wakeLock.request("screen");

            case 5:
              wakeLock = _context39.sent;

            case 6:
              isActive.value = !wakeLock.released;

            case 7:
            case 'end':
              return _context39.stop();
          }
        }
      }, _callee39, this);
    }));

    return function onVisibilityChange() {
      return _ref91.apply(this, arguments);
    };
  }();

  var request = function () {
    var _ref92 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee40(type) {
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee40$(_context40) {
        while (1) {
          switch (_context40.prev = _context40.next) {
            case 0:
              if (isSupported.value) {
                _context40.next = 2;
                break;
              }

              return _context40.abrupt('return');

            case 2:
              _context40.next = 4;
              return navigator.wakeLock.request(type);

            case 4:
              wakeLock = _context40.sent;

              isActive.value = !wakeLock.released;

            case 6:
            case 'end':
              return _context40.stop();
          }
        }
      }, _callee40, this);
    }));

    return function request(_x137) {
      return _ref92.apply(this, arguments);
    };
  }();

  var release = function () {
    var _ref93 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee41() {
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee41$(_context41) {
        while (1) {
          switch (_context41.prev = _context41.next) {
            case 0:
              if (!(!isSupported.value || !wakeLock)) {
                _context41.next = 2;
                break;
              }

              return _context41.abrupt('return');

            case 2:
              _context41.next = 4;
              return wakeLock.release();

            case 4:
              isActive.value = !wakeLock.released;
              wakeLock = null;

            case 6:
            case 'end':
              return _context41.stop();
          }
        }
      }, _callee41, this);
    }));

    return function release() {
      return _ref93.apply(this, arguments);
    };
  }();

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$navigator9 = options.navigator,
      navigator = _options$navigator9 === undefined ? defaultNavigator : _options$navigator9,
      _options$document12 = options.document,
      document = _options$document12 === undefined ? defaultDocument : _options$document12;

  var wakeLock = void 0;
  var isSupported = useSupported(function () {
    return navigator && "wakeLock" in navigator;
  });
  var isActive = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);

  if (document) useEventListener(document, "visibilitychange", onVisibilityChange, { passive: true });

  return {
    isSupported: isSupported,
    isActive: isActive,
    request: request,
    release: release
  };
}

function useWebNotification() {
  var _this9 = this;

  var defaultOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _defaultOptions$windo = defaultOptions.window,
      window = _defaultOptions$windo === undefined ? defaultWindow : _defaultOptions$windo;

  var isSupported = useSupported(function () {
    return !!window && "Notification" in window;
  });
  var notification = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  var requestPermission = function () {
    var _ref94 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee42() {
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee42$(_context42) {
        while (1) {
          switch (_context42.prev = _context42.next) {
            case 0:
              if (isSupported.value) {
                _context42.next = 2;
                break;
              }

              return _context42.abrupt('return');

            case 2:
              if (!("permission" in Notification && Notification.permission !== "denied")) {
                _context42.next = 5;
                break;
              }

              _context42.next = 5;
              return Notification.requestPermission();

            case 5:
            case 'end':
              return _context42.stop();
          }
        }
      }, _callee42, _this9);
    }));

    return function requestPermission() {
      return _ref94.apply(this, arguments);
    };
  }();

  var _createEventHook2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["r" /* createEventHook */])(),
      onClick = _createEventHook2.on,
      clickTrigger = _createEventHook2.trigger;

  var _createEventHook3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["r" /* createEventHook */])(),
      onShow = _createEventHook3.on,
      showTrigger = _createEventHook3.trigger;

  var _createEventHook4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["r" /* createEventHook */])(),
      onError = _createEventHook4.on,
      errorTrigger = _createEventHook4.trigger;

  var _createEventHook5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["r" /* createEventHook */])(),
      onClose = _createEventHook5.on,
      closeTrigger = _createEventHook5.trigger;

  var show = function () {
    var _ref95 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee43(overrides) {
      var options;
      return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee43$(_context43) {
        while (1) {
          switch (_context43.prev = _context43.next) {
            case 0:
              if (isSupported.value) {
                _context43.next = 2;
                break;
              }

              return _context43.abrupt('return');

            case 2:
              _context43.next = 4;
              return requestPermission();

            case 4:
              options = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, defaultOptions, overrides);

              notification.value = new Notification(options.title || "", options);
              notification.value.onclick = clickTrigger;
              notification.value.onshow = showTrigger;
              notification.value.onerror = errorTrigger;
              notification.value.onclose = closeTrigger;
              return _context43.abrupt('return', notification.value);

            case 11:
            case 'end':
              return _context43.stop();
          }
        }
      }, _callee43, _this9);
    }));

    return function show(_x139) {
      return _ref95.apply(this, arguments);
    };
  }();
  var close = function close() {
    if (notification.value) notification.value.close();
    notification.value = null;
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["g" /* tryOnMounted */])(__WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.mark(function _callee44() {
    return __WEBPACK_IMPORTED_MODULE_21_babel_runtime_regenerator___default.a.wrap(function _callee44$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            if (!isSupported.value) {
              _context44.next = 3;
              break;
            }

            _context44.next = 3;
            return requestPermission();

          case 3:
          case 'end':
            return _context44.stop();
        }
      }
    }, _callee44, _this9);
  })));
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(close);
  if (isSupported.value && window) {
    var _document3 = window.document;
    useEventListener(_document3, "visibilitychange", function (e) {
      e.preventDefault();
      if (_document3.visibilityState === "visible") {
        close();
      }
    });
  }
  return {
    isSupported: isSupported,
    notification: notification,
    show: show,
    close: close,
    onClick: onClick,
    onShow: onShow,
    onError: onError,
    onClose: onClose
  };
}

var DEFAULT_PING_MESSAGE = "ping";
function resolveNestedOptions(options) {
  if (options === true) return {};
  return options;
}
function useWebSocket(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var onConnected = options.onConnected,
      onDisconnected = options.onDisconnected,
      onError = options.onError,
      onMessage = options.onMessage,
      _options$immediate10 = options.immediate,
      immediate = _options$immediate10 === undefined ? true : _options$immediate10,
      _options$autoClose = options.autoClose,
      autoClose = _options$autoClose === undefined ? true : _options$autoClose,
      _options$protocols = options.protocols,
      protocols = _options$protocols === undefined ? [] : _options$protocols;

  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  var status = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])("CLOSED");
  var wsRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  var urlRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["m" /* toRef */])(url);
  var heartbeatPause = void 0;
  var heartbeatResume = void 0;
  var explicitlyClosed = false;
  var retried = 0;
  var bufferedData = [];
  var pongTimeoutWait = void 0;
  var close = function close() {
    var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1e3;
    var reason = arguments[1];

    if (!wsRef.value) return;
    explicitlyClosed = true;
    heartbeatPause == null ? void 0 : heartbeatPause();
    wsRef.value.close(code, reason);
  };
  var _sendBuffer = function _sendBuffer() {
    if (bufferedData.length && wsRef.value && status.value === "OPEN") {
      var _iteratorNormalCompletion44 = true;
      var _didIteratorError44 = false;
      var _iteratorError44 = undefined;

      try {
        for (var _iterator44 = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_get_iterator___default()(bufferedData), _step44; !(_iteratorNormalCompletion44 = (_step44 = _iterator44.next()).done); _iteratorNormalCompletion44 = true) {
          var buffer = _step44.value;

          wsRef.value.send(buffer);
        }
      } catch (err) {
        _didIteratorError44 = true;
        _iteratorError44 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion44 && _iterator44.return) {
            _iterator44.return();
          }
        } finally {
          if (_didIteratorError44) {
            throw _iteratorError44;
          }
        }
      }

      bufferedData = [];
    }
  };
  var resetHeartbeat = function resetHeartbeat() {
    clearTimeout(pongTimeoutWait);
    pongTimeoutWait = void 0;
  };
  var send = function send(data2) {
    var useBuffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (!wsRef.value || status.value !== "OPEN") {
      if (useBuffer) bufferedData.push(data2);
      return false;
    }
    _sendBuffer();
    wsRef.value.send(data2);
    return true;
  };
  var _init = function _init() {
    if (explicitlyClosed || typeof urlRef.value === "undefined") return;
    var ws = new WebSocket(urlRef.value, protocols);
    wsRef.value = ws;
    status.value = "CONNECTING";
    ws.onopen = function () {
      status.value = "OPEN";
      onConnected == null ? void 0 : onConnected(ws);
      heartbeatResume == null ? void 0 : heartbeatResume();
      _sendBuffer();
    };
    ws.onclose = function (ev) {
      status.value = "CLOSED";
      wsRef.value = void 0;
      onDisconnected == null ? void 0 : onDisconnected(ws, ev);
      if (!explicitlyClosed && options.autoReconnect) {
        var _resolveNestedOptions = resolveNestedOptions(options.autoReconnect),
            _resolveNestedOptions2 = _resolveNestedOptions.retries,
            retries = _resolveNestedOptions2 === undefined ? -1 : _resolveNestedOptions2,
            _resolveNestedOptions3 = _resolveNestedOptions.delay,
            delay = _resolveNestedOptions3 === undefined ? 1e3 : _resolveNestedOptions3,
            onFailed = _resolveNestedOptions.onFailed;

        retried += 1;
        if (typeof retries === "number" && (retries < 0 || retried < retries)) setTimeout(_init, delay);else if (typeof retries === "function" && retries()) setTimeout(_init, delay);else onFailed == null ? void 0 : onFailed();
      }
    };
    ws.onerror = function (e) {
      onError == null ? void 0 : onError(ws, e);
    };
    ws.onmessage = function (e) {
      if (options.heartbeat) {
        resetHeartbeat();

        var _resolveNestedOptions4 = resolveNestedOptions(options.heartbeat),
            _resolveNestedOptions5 = _resolveNestedOptions4.message,
            message = _resolveNestedOptions5 === undefined ? DEFAULT_PING_MESSAGE : _resolveNestedOptions5;

        if (e.data === message) return;
      }
      data.value = e.data;
      onMessage == null ? void 0 : onMessage(ws, e);
    };
  };
  if (options.heartbeat) {
    var _resolveNestedOptions6 = resolveNestedOptions(options.heartbeat),
        _resolveNestedOptions7 = _resolveNestedOptions6.message,
        message = _resolveNestedOptions7 === undefined ? DEFAULT_PING_MESSAGE : _resolveNestedOptions7,
        _resolveNestedOptions8 = _resolveNestedOptions6.interval,
        interval = _resolveNestedOptions8 === undefined ? 1e3 : _resolveNestedOptions8,
        _resolveNestedOptions9 = _resolveNestedOptions6.pongTimeout,
        pongTimeout = _resolveNestedOptions9 === undefined ? 1e3 : _resolveNestedOptions9;

    var _useIntervalFn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["A" /* useIntervalFn */])(function () {
      send(message, false);
      if (pongTimeoutWait != null) return;
      pongTimeoutWait = setTimeout(function () {
        close();
      }, pongTimeout);
    }, interval, { immediate: false }),
        pause = _useIntervalFn.pause,
        resume = _useIntervalFn.resume;

    heartbeatPause = pause;
    heartbeatResume = resume;
  }
  if (autoClose) {
    useEventListener(window, "beforeunload", function () {
      return close();
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(close);
  }
  var open = function open() {
    close();
    explicitlyClosed = false;
    retried = 0;
    _init();
  };
  if (immediate) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(urlRef, open, { immediate: true });
  return {
    data: data,
    status: status,
    close: close,
    send: send,
    open: open,
    ws: wsRef
  };
}

function useWebWorker(arg0, workerOptions, options) {
  var _ref97 = options != null ? options : {},
      _ref97$window = _ref97.window,
      window = _ref97$window === undefined ? defaultWindow : _ref97$window;

  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(null);
  var worker = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["c" /* shallowRef */])();
  var post = function post() {
    var _worker$value;

    if (!worker.value) return;
    (_worker$value = worker.value).postMessage.apply(_worker$value, arguments);
  };
  var terminate = function terminate2() {
    if (!worker.value) return;
    worker.value.terminate();
  };
  if (window) {
    if (typeof arg0 === "string") worker.value = new Worker(arg0, workerOptions);else if (typeof arg0 === "function") worker.value = arg0();else worker.value = arg0;
    worker.value.onmessage = function (e) {
      data.value = e.data;
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(function () {
      if (worker.value) worker.value.terminate();
    });
  }
  return {
    data: data,
    post: post,
    terminate: terminate,
    worker: worker
  };
}

function jobRunner(userFunc) {
  return function (e) {
    var userFuncArgs = e.data[0];
    return __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a.resolve(userFunc.apply(void 0, userFuncArgs)).then(function (result) {
      postMessage(["SUCCESS", result]);
    }).catch(function (error) {
      postMessage(["ERROR", error]);
    });
  };
}

function depsParser(deps) {
  if (deps.length === 0) return "";
  var depsString = deps.map(function (dep) {
    return '\'' + dep + '\'';
  }).toString();
  return 'importScripts(' + depsString + ')';
}

function createWorkerBlobUrl(fn, deps) {
  var blobCode = depsParser(deps) + '; onmessage=(' + jobRunner + ')(' + fn + ')';
  var blob = new Blob([blobCode], { type: "text/javascript" });
  var url = URL.createObjectURL(blob);
  return url;
}

function useWebWorkerFn(fn) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$dependencies = options.dependencies,
      dependencies = _options$dependencies === undefined ? [] : _options$dependencies,
      timeout = options.timeout,
      _options$window34 = options.window,
      window = _options$window34 === undefined ? defaultWindow : _options$window34;

  var worker = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  var workerStatus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])("PENDING");
  var promise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])({});
  var timeoutId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])();
  var workerTerminate = function workerTerminate() {
    var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "PENDING";

    if (worker.value && worker.value._url && window) {
      worker.value.terminate();
      URL.revokeObjectURL(worker.value._url);
      promise.value = {};
      worker.value = void 0;
      window.clearTimeout(timeoutId.value);
      workerStatus.value = status;
    }
  };
  workerTerminate();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["e" /* tryOnScopeDispose */])(workerTerminate);
  var generateWorker = function generateWorker() {
    var blobUrl = createWorkerBlobUrl(fn, dependencies);
    var newWorker = new Worker(blobUrl);
    newWorker._url = blobUrl;
    newWorker.onmessage = function (e) {
      var _promise$value = promise.value,
          _promise$value$resolv = _promise$value.resolve,
          resolve = _promise$value$resolv === undefined ? function () {} : _promise$value$resolv,
          _promise$value$reject = _promise$value.reject,
          reject = _promise$value$reject === undefined ? function () {} : _promise$value$reject;

      var _e$data = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(e.data, 2),
          status = _e$data[0],
          result = _e$data[1];

      switch (status) {
        case "SUCCESS":
          resolve(result);
          workerTerminate(status);
          break;
        default:
          reject(result);
          workerTerminate("ERROR");
          break;
      }
    };
    newWorker.onerror = function (e) {
      var _promise$value$reject2 = promise.value.reject,
          reject = _promise$value$reject2 === undefined ? function () {} : _promise$value$reject2;

      reject(e);
      workerTerminate("ERROR");
    };
    if (timeout) {
      timeoutId.value = setTimeout(function () {
        return workerTerminate("TIMEOUT_EXPIRED");
      }, timeout);
    }
    return newWorker;
  };
  var callWorker = function callWorker() {
    for (var _len12 = arguments.length, fnArgs = Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      fnArgs[_key12] = arguments[_key12];
    }

    return new __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      promise.value = {
        resolve: resolve,
        reject: reject
      };
      worker.value && worker.value.postMessage([[].concat(fnArgs)]);
      workerStatus.value = "RUNNING";
    });
  };
  var workerFn = function workerFn() {
    if (workerStatus.value === "RUNNING") {
      console.error("[useWebWorkerFn] You can only run one instance of the worker at a time.");
      return __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_promise___default.a.reject();
    }
    worker.value = generateWorker();
    return callWorker.apply(undefined, arguments);
  };
  return {
    workerFn: workerFn,
    workerStatus: workerStatus,
    workerTerminate: workerTerminate
  };
}

function useWindowFocus() {
  var _ref98 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref98$window = _ref98.window,
      window = _ref98$window === undefined ? defaultWindow : _ref98$window;

  if (!window) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(false);
  var focused = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(window.document.hasFocus());
  useEventListener(window, "blur", function () {
    focused.value = false;
  });
  useEventListener(window, "focus", function () {
    focused.value = true;
  });
  return focused;
}

function useWindowScroll() {
  var _ref99 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref99$window = _ref99.window,
      window = _ref99$window === undefined ? defaultWindow : _ref99$window;

  if (!window) {
    return {
      x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0),
      y: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(0)
    };
  }
  var x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(window.scrollX);
  var y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(window.scrollY);
  useEventListener(window, "scroll", function () {
    x.value = window.scrollX;
    y.value = window.scrollY;
  }, {
    capture: false,
    passive: true
  });
  return { x: x, y: y };
}

function useWindowSize() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window35 = options.window,
      window = _options$window35 === undefined ? defaultWindow : _options$window35,
      _options$initialWidth = options.initialWidth,
      initialWidth = _options$initialWidth === undefined ? Infinity : _options$initialWidth,
      _options$initialHeigh = options.initialHeight,
      initialHeight = _options$initialHeigh === undefined ? Infinity : _options$initialHeigh,
      _options$listenOrient = options.listenOrientation,
      listenOrientation = _options$listenOrient === undefined ? true : _options$listenOrient,
      _options$includeScrol = options.includeScrollbar,
      includeScrollbar = _options$includeScrol === undefined ? true : _options$includeScrol;

  var width = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(initialWidth);
  var height = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["b" /* ref */])(initialHeight);
  var update = function update() {
    if (window) {
      if (includeScrollbar) {
        width.value = window.innerWidth;
        height.value = window.innerHeight;
      } else {
        width.value = window.document.documentElement.clientWidth;
        height.value = window.document.documentElement.clientHeight;
      }
    }
  };
  update();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__vueuse_shared__["g" /* tryOnMounted */])(update);
  useEventListener("resize", update, { passive: true });
  if (listenOrientation) {
    var matches = useMediaQuery("(orientation: portrait)");
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vue_demi__["n" /* watch */])(matches, function () {
      return update();
    });
  }
  return { width: width, height: height };
}


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(26)))

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createApp */
/* unused harmony export Vue2 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return isVue2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isVue3; });
/* unused harmony export install */
/* unused harmony export warn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Fragment; });
/* unused harmony export Transition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TransitionGroup; });
/* unused harmony export Teleport */
/* unused harmony export Suspense */
/* unused harmony export KeepAlive */
/* unused harmony export hasInjectionContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* unused harmony reexport Vue */
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["B"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["C"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["D"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["E"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["F"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["G"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["H"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["I"]; });




var isVue2 = true;
var isVue3 = false;
var Vue2 = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */];
var warn = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].util.warn;

function install() {}

function createApp(rootComponent, rootProps) {
  var vm;
  var _provide = {};
  var app = {
    config: __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config,
    use: __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use.bind(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]),
    mixin: __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].mixin.bind(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]),
    component: __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component.bind(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]),
    provide: function provide(key, value) {
      _provide[key] = value;
      return this;
    },
    directive: function directive(name, dir) {
      if (dir) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].directive(name, dir);
        return app;
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].directive(name);
      }
    },
    mount: function mount(el, hydrating) {
      if (!vm) {
        vm = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ propsData: rootProps }, rootComponent, { provide: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_provide, rootComponent.provide) }));
        vm.$mount(el, hydrating);
        return vm;
      } else {
        return vm;
      }
    },
    unmount: function unmount() {
      if (vm) {
        vm.$destroy();
        vm = undefined;
      }
    }
  };
  return app;
}



function createMockComponent(name) {
  return {
    setup: function setup() {
      throw new Error('[vue-demi] ' + name + ' is not supported in Vue 2. It\'s provided to avoid compiler errors.');
    }
  };
}
var Fragment = createMockComponent('Fragment');
var Transition = createMockComponent('Transition');
var TransitionGroup = createMockComponent('TransitionGroup');
var Teleport = createMockComponent('Teleport');
var Suspense = createMockComponent('Suspense');
var KeepAlive = createMockComponent('KeepAlive');



function hasInjectionContext() {
  return !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue__["u" /* getCurrentInstance */])();
}

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createApp */
/* unused harmony export Vue2 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return isVue2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isVue3; });
/* unused harmony export install */
/* unused harmony export warn */
/* unused harmony export Fragment */
/* unused harmony export Transition */
/* unused harmony export TransitionGroup */
/* unused harmony export Teleport */
/* unused harmony export Suspense */
/* unused harmony export KeepAlive */
/* unused harmony export hasInjectionContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* unused harmony reexport Vue */
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_1_vue__["A"]; });




var isVue2 = true;
var isVue3 = false;
var Vue2 = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */];
var warn = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].util.warn;

function install() {}

function createApp(rootComponent, rootProps) {
  var vm;
  var _provide = {};
  var app = {
    config: __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config,
    use: __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use.bind(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]),
    mixin: __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].mixin.bind(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]),
    component: __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component.bind(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]),
    provide: function provide(key, value) {
      _provide[key] = value;
      return this;
    },
    directive: function directive(name, dir) {
      if (dir) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].directive(name, dir);
        return app;
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].directive(name);
      }
    },
    mount: function mount(el, hydrating) {
      if (!vm) {
        vm = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ propsData: rootProps }, rootComponent, { provide: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_provide, rootComponent.provide) }));
        vm.$mount(el, hydrating);
        return vm;
      } else {
        return vm;
      }
    },
    unmount: function unmount() {
      if (vm) {
        vm.$destroy();
        vm = undefined;
      }
    }
  };
  return app;
}



function createMockComponent(name) {
  return {
    setup: function setup() {
      throw new Error('[vue-demi] ' + name + ' is not supported in Vue 2. It\'s provided to avoid compiler errors.');
    }
  };
}
var Fragment = createMockComponent('Fragment');
var Transition = createMockComponent('Transition');
var TransitionGroup = createMockComponent('TransitionGroup');
var Teleport = createMockComponent('Teleport');
var Suspense = createMockComponent('Suspense');
var KeepAlive = createMockComponent('KeepAlive');



function hasInjectionContext() {
  return !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue__["u" /* getCurrentInstance */])();
}

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      pageLists: [{
        title: '首页',
        link: '/'
      }, {
        title: '公司简介',
        link: 'introduction'
      }, {
        title: '产品展示',
        link: 'news'
      }],

      navLists: [],
      text: this.$route.query.text,
      total: 0
    };
  },

  watch: {
    '$route': function $route(to, from) {
      console.log("random:" + to.query.s);
      console.log("parentId:" + to.params.parentId);
      console.log("from.path:" + from.path);
      to.query.s = Math.random;
      if (to.path === from.path && to.hash === '') {

        this.$router.go(0);
      }
    }
  },
  methods: {
    route: function route() {
      this.$_storage.removeLocalStore("index");
      this.$router.push({ name: 'news' });
    },
    search: function search() {
      if (this.text == '' || this.text == undefined || this.text == null) {
        this.$alert("未查询到产品信息");
        return;
      }
      this.getSearch();
    },
    returntop: function returntop() {
      window.scrollTo(0, 0);
    },
    toQQ: function toQQ() {
      window.open("https://wpa.qq.com/msgrd?v=3&uin=1466551568&site=qq&menu=yes&jumpflag=1");
    },
    getSearch: function getSearch() {
      var _this = this;

      var vm = this;
      vm.$_axios({
        method: 'post',
        url: '/mapis/search/searchDocs',
        data: {
          text: vm.text,
          pageNo: vm.pageNo,
          pageSize: vm.pageSize
        },
        needLogin: false
      }).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data.data;
          vm.total = responseData.total;
          if (vm.total == 0) {
            _this.$alert("未查询到产品信息");
            return;
          }
          _this.$router.push({ name: 'search', query: { text: _this.text, s: Math.random() } });
        }
      });
    },
    toProducts: function toProducts() {
      var vm = this;
      vm.$router.push({ name: 'products' });
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var vm = this;
  }
});

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Pagination",
  props: ["pageNo", "pageSize", "total", "continues"],

  computed: {
    totalPage: function totalPage() {
      return Math.ceil(this.total / this.pageSize);
    },
    startNumAndEndNum: function startNumAndEndNum() {
      var continues = this.continues,
          pageNo = this.pageNo,
          totalPage = this.totalPage;

      var start = 0,
          end = 0;

      if (continues > totalPage) {
        start = 1;
        end = totalPage;
      } else {
        start = pageNo - parseInt(continues / 2);
        end = pageNo + parseInt(continues / 2);

        if (start < 1) {
          start = 1;
          end = continues;
        }

        if (end > totalPage) {
          start = totalPage - continues + 1;
          end = totalPage;
        }
      }
      return { start: start, end: end };
    }
  }
});

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      menuList: [],
      aboutInfo: {}
    };
  },

  methods: {
    getMenu: function getMenu() {
      var vm = this;

      vm.$_axios({
        method: 'post',
        url: '/mapis/menu/getMenu',
        needLogin: false,
        params: {
          type: 2
        }
      }).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data.data;
          console.log(responseData);
          vm.menuList = responseData;
          if (vm.menuList[0].id != undefined && vm.menuList[0].id != null && vm.menuList[0].id != '') {
            vm.getInfo(vm.menuList[0].id);
          }
        }
      });
    },
    getInfo: function getInfo(id) {
      var vm = this;

      vm.$_axios({
        method: 'post',
        url: '/mapis/about/getInfo',
        needLogin: false,
        params: {
          id: id
        }
      }).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data.data;
          console.log(responseData);
          vm.aboutInfo = responseData;
        }
      });
    }
  },
  created: function created() {
    var vm = this;
    console.log('created');
    vm.getMenu();
  },
  mounted: function mounted() {
    var vm = this;
  }
});

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map_js__ = __webpack_require__(182);


/* harmony default export */ __webpack_exports__["default"] = ({
          data: function data() {
                    return {
                              center: { lng: 0, lat: 0 },
                              zoom: 3
                    };
          },
          beforeCreate: function beforeCreate() {
                    window._bd_share_main = "";
          },
          mounted: function mounted() {

                    this.$nextTick(function () {

                              var _this = this;
                              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map_js__["a" /* map */])('k8MGyUzxbzCSSGkTBm6iHiBEaV3MD8Nt').then(function (BMap) {
                                        var map = new BMap.Map('map', { enableMapClick: true });
                                        var point = new BMap.Point(116.119752, 39.941025);
                                        var marker = new BMap.Marker(point);

                                        var top_left_control = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_TOP_LEFT });
                                        var top_left_navigation = new BMap.NavigationControl();

                                        marker.setAnimation(BMAP_ANIMATION_BOUNCE);
                                        map.centerAndZoom(point, 16);
                                        map.addOverlay(marker);
                                        map.enableScrollWheelZoom(true);
                                        map.addControl(new BMap.MapTypeControl());
                                        map.setCurrentCity("北京");

                                        window.onresize = function () {

                                                  map.centerAndZoom(point, 17);
                                        };

                                        map.addControl(top_left_control);
                                        map.addControl(top_left_navigation);
                              });
                    });
          },

          methods: {}
});

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hotProductList: [],
      brandList: []
    };
  },

  methods: {
    getHotProducts: function getHotProducts() {
      var vm = this;

      vm.$_axios({
        method: 'post',
        url: '/mapis/product/getHotProducts',
        needLogin: false
      }).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data.data;
          console.log(responseData);
          vm.hotProductList = responseData;
        }
      });
    },
    getProducts2: function getProducts2(id) {
      var vm = this;
      console.log(id);
      vm.$_axios({
        method: 'post',
        url: '/mapis/product/getProducts',
        params: {
          parentId: id
        },
        needLogin: false
      }).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data.data;
          console.log(responseData);
          vm.productList = responseData;
          vm.$router.push({ name: 'products', query: { parentId: id, s: Math.random() } });
        }
      });
    },
    toProductDetails: function toProductDetails(product) {
      var vm = this;
      vm.$_storage.setLocalStore('product', product);
      vm.$router.push({ name: 'productDetails' });
    },
    toNews: function toNews() {
      var vm = this;
      vm.$router.push({ name: 'news' });
    },
    toProducts: function toProducts() {
      var vm = this;
      vm.$router.push({ name: 'products' });
    },
    toAbout: function toAbout(product) {
      var vm = this;
      vm.$router.push({ name: 'about' });
    },
    getBrands: function getBrands() {
      var vm = this;

      vm.$_axios({
        method: 'post',
        url: '/mapis/brand/getBrands',
        needLogin: false
      }).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data.data;
          console.log(responseData);
          vm.brandList = responseData;
        }
      });
    }
  },
  created: function created() {
    var vm = this;
  },
  mounted: function mounted() {
    var vm = this;

    vm.getBrands();
  }
});

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      recruit_info_list: [],
      total: ''
    };
  },

  methods: {
    getRecruitInfos: function getRecruitInfos() {
      var vm = this;
      vm.$_axios({
        method: 'post',
        url: '/mapis/recruit/getRecruitInfos',
        data: {},
        needLogin: false
      }).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data.data;
          vm.recruit_info_list = responseData.recruitDtoList;
          vm.total = responseData.total;
        }
      });
    }
  },
  created: function created() {
    var vm = this;
  },
  mounted: function mounted() {
    var vm = this;
    vm.getRecruitInfos();
  }
});

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Pagination__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Pagination__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      nav_status_1: JSON.parse(this.$_storage.getLocalStore("index")) == null ? true : JSON.parse(this.$_storage.getLocalStore("index")) == 0,
      nav_status_2: JSON.parse(this.$_storage.getLocalStore("index")) == null ? false : JSON.parse(this.$_storage.getLocalStore("index")) == 1,
      nav_status_3: JSON.parse(this.$_storage.getLocalStore("index")) == null ? false : JSON.parse(this.$_storage.getLocalStore("index")) == 2,
      news_list: [],
      pageSize: 5,
      pageNo: 1,
      total: 0,
      category: "",
      index: JSON.parse(this.$_storage.getLocalStore("index")) == null ? 0 : JSON.parse(this.$_storage.getLocalStore("index"))
    };
  },

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_0__components_Pagination___default.a
  },
  methods: {
    changeTab: function changeTab(index) {
      var vm = this;
      if (0 == index) {
        vm.nav_status_1 = true;
        vm.nav_status_2 = false;
        vm.nav_status_3 = false;
        vm.$_storage.setLocalStore('index', 0);
      } else if (1 == index) {
        vm.nav_status_1 = false;
        vm.nav_status_2 = true;
        vm.nav_status_3 = false;
        vm.$_storage.setLocalStore('index', 1);
      } else if (2 == index) {
        vm.nav_status_1 = false;
        vm.nav_status_2 = false;
        vm.nav_status_3 = true;
        vm.$_storage.setLocalStore('index', 2);
      }
      vm.getNews(index, 1);
    },
    getNews: function getNews(category, pageNo) {
      var vm = this;
      vm.category = category;
      vm.pageNo = pageNo;
      vm.$_axios({
        method: 'post',
        url: '/mapis/news/getNews',
        data: {
          category: vm.category,
          pageNo: vm.pageNo,
          pageSize: vm.pageSize
        },
        needLogin: false
      }).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data.data;
          vm.news_list = responseData.newsDtoList;
          vm.total = responseData.total;
        }
      });
    },
    getPageNo: function getPageNo(pageNo) {
      var vm = this;
      vm.pageNo = pageNo;
      vm.getNews(vm.category, vm.pageNo);
    },
    toNewsDetails: function toNewsDetails(news) {
      var vm = this;
      vm.$_storage.setLocalStore('news', news);
      vm.$router.push({ name: 'newsDetails' });
    }
  },
  mounted: function mounted() {
    var vm = this;
    vm.getNews(vm.index, 1);
  }
});

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      news: JSON.parse(this.$_storage.getLocalStore("news")),
      nav_status_1: JSON.parse(this.$_storage.getLocalStore("index")) == null ? true : JSON.parse(this.$_storage.getLocalStore("index")) == 0,
      nav_status_2: JSON.parse(this.$_storage.getLocalStore("index")) == null ? false : JSON.parse(this.$_storage.getLocalStore("index")) == 1,
      nav_status_3: JSON.parse(this.$_storage.getLocalStore("index")) == null ? false : JSON.parse(this.$_storage.getLocalStore("index")) == 2,
      breadCrumbName: '',
      news_details: '',
      news_pre: '',
      news_next: '',
      news_related_list: [],
      index: JSON.parse(this.$_storage.getLocalStore("index")) == null ? 0 : JSON.parse(this.$_storage.getLocalStore("index"))
    };
  },

  methods: {
    getNewsDetails: function getNewsDetails(id) {
      var vm = this;
      vm.$_axios({
        method: 'post',
        url: '/mapis/news/getNewsDetails',
        params: {
          newsId: id
        },
        needLogin: false
      }).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data.data;
          vm.news_details = responseData;
          vm.getNewsPreAndNext(vm.news_details.newsId);
        }
      });
    },
    getNewsPreAndNext: function getNewsPreAndNext(id) {
      var vm = this;
      vm.$_axios({
        method: 'post',
        url: '/mapis/news/getNewsPreAndNext',
        params: {
          newsId: id
        },
        needLogin: false
      }).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data.data;
          vm.news_pre = responseData.newsPre;
          vm.news_next = responseData.newsNext;
        }
      });
    },
    getNewsDetailsPreOrNext: function getNewsDetailsPreOrNext(news) {
      var vm = this;
      if (news.title == '无') {
        console.log('无:' + news);
        return;
      }
      this.$_storage.setLocalStore("news", news);
      vm.$router.push({ name: 'newsDetails' });
      vm.$router.replace('/refresh');
    },
    getRelatedNews: function getRelatedNews() {
      var vm = this;
      vm.$_axios({
        method: 'post',
        url: '/mapis/news/getRelatedNews',
        data: {
          category: vm.news.category,
          id: vm.news.id
        },
        needLogin: false
      }).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data.data;
          vm.news_related_list = responseData;
        }
      });
    },
    changeTab: function changeTab(index) {
      var vm = this;
      if (0 == index) {
        vm.$_storage.setLocalStore('index', 0);
      } else if (1 == index) {
        vm.$_storage.setLocalStore('index', 1);
      } else if (2 == index) {
        vm.$_storage.setLocalStore('index', 2);
      }
      vm.$router.push({ name: 'news' });
    }
  },
  created: function created() {
    var vm = this;
    console.log(vm.news);
    if (0 == vm.news.category) {
      vm.nav_status_1 = true;
      vm.nav_status_2 = false;
      vm.nav_status_3 = false;
      vm.breadCrumbName = '企业动态';
    } else if (1 == vm.news.category) {
      vm.nav_status_1 = false;
      vm.nav_status_2 = true;
      vm.nav_status_3 = false;
      vm.breadCrumbName = '代理品牌动态';
    } else if (2 == vm.news.category) {
      vm.nav_status_1 = false;
      vm.nav_status_2 = false;
      vm.nav_status_3 = true;
      vm.breadCrumbName = '行业资讯';
    }
  },
  mounted: function mounted() {
    var vm = this;
    vm.getNewsDetails(vm.news.id);
    vm.getRelatedNews();
    console.log(vm.index == null);
  }
});

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vueuse_core__ = __webpack_require__(141);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    images: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var currIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue__["b" /* ref */])(0);

    var show = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue__["b" /* ref */])(false);

    var layerPosition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue__["c" /* reactive */])({
      top: 0,
      left: 0
    });

    var largePosition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue__["c" /* reactive */])({
      backgroundPositionX: 0,
      backgroundPositionY: 0
    });

    var target = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue__["b" /* ref */])(null);

    var _useMouseInElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__vueuse_core__["a" /* useMouseInElement */])(target),
        elementX = _useMouseInElement.elementX,
        elementY = _useMouseInElement.elementY,
        isOutside = _useMouseInElement.isOutside;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue__["d" /* watch */])([elementX, elementY, isOutside], function () {
      show.value = !isOutside.value;
      var position = { X: 0, Y: 0 };

      if (elementX.value < 100) position.X = 0;else if (elementX.value > 300) position.X = 200;else position.X = elementX.value - 100;

      if (elementY.value < 100) position.Y = 0;else if (elementY.value > 220) position.Y = 120;else position.Y = elementY.value - 100;

      layerPosition.left = position.X + 'px';
      layerPosition.top = position.Y + 'px';
      largePosition.backgroundPositionX = -2 * position.X + 'px';
      largePosition.backgroundPositionY = -4 * position.Y + 'px';
    });

    return { currIndex: currIndex, show: show, layerPosition: layerPosition, largePosition: largePosition, target: target };
  },
  data: function data() {
    return {
      navLists: JSON.parse(this.$_storage.getLocalStore("navLists")),
      productList: [],
      productDetails: Object,
      product: JSON.parse(this.$_storage.getLocalStore("product")),
      param: [],
      param_list: [],
      param_list_2: [],
      param_list_3: [],
      feture_list: [],
      colsize: 0

    };
  },

  methods: {
    getProductDetails: function getProductDetails() {
      var vm = this;
      console.log(this.$route.query.parentId);
      console.log(222);
      vm.$_axios({
        method: 'post',
        url: '/mapis/product/getProductDetails',
        params: {
          productId: vm.product.id
        },
        needLogin: false
      }).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data.data;

          vm.productDetails = responseData;
          console.log(vm.productDetails.images);
          vm.param_list = responseData.paramList;
          vm.param_list_2 = responseData.paramList2;
          vm.param_list_3 = responseData.paramList3;
          vm.feture_list = responseData.fetureList;
        }
      });
    }
  },
  created: function created() {
    var vm = this;
  },
  mounted: function mounted() {
    var vm = this;
    vm.getProductDetails();
  }
});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Pagination__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Pagination__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      pageLists: [{
        title: '首页',
        link: '/'
      }, {
        title: '公司简介',
        link: 'introduction'
      }, {
        title: '产品展示',
        link: 'news'
      }],

      navLists: JSON.parse(this.$_storage.getLocalStore("navLists")),
      productList: [],
      menuList: [],
      titleName: "产品展示",
      pageSize: 9,
      pageNo: 1,
      total: 0,
      parentId: "",
      menuIndex: -1,
      menuSubIndex: -1
    };
  },

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_0__components_Pagination___default.a
  },
  methods: {
    getMenu: function getMenu() {
      var vm = this;

      vm.$_axios({
        method: 'post',
        url: '/mapis/menu/getMenu',
        needLogin: false,
        params: {
          type: 1
        }
      }).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data.data;
          vm.menuList = responseData;
          console.log("vm.menuList[0]" + vm.menuList[0]);
          if (vm.menuList[0] != undefined && vm.menuList[0] != null && vm.menuList[0] != '') {
            vm.getFirstTypeProduct(vm.menuList[0]);
          }
        }
      });
    },
    getProducts: function getProducts(id, name, pageNo) {
      var vm = this;
      vm.titleName = name;
      vm.parentId = id;
      vm.pageNo = pageNo;
      vm.$_axios({
        method: 'post',
        url: '/mapis/product/getProducts',
        data: {
          parentId: vm.parentId,
          pageNo: vm.pageNo,
          pageSize: vm.pageSize
        },
        needLogin: false
      }).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data.data;
          vm.productList = responseData.productDtoList;
          vm.total = responseData.total;
        }
      });
    },
    changeIndex: function changeIndex(index) {
      var vm = this;

      if (index != this.menuIndex) {
        $(".dropdown-toggle").not(this).attr("aria-expanded", "false");

        $(".dropdown-toggle").not(this).addClass("collapsed");

        $(".list-unstyled").not($(this).next("ul")).removeClass("show");
        vm.menuIndex = index;
      }
    },
    changeIndex2: function changeIndex2(index) {
      var vm = this;

      if (index != this.menuSubIndex) {
        $(".leftNavCur").not(this).attr("aria-expanded", "false");

        $(".leftNavCur").not(this).addClass("collapsed");

        $(".sub").not($(this).next("ul")).removeClass("show");
        vm.menuSubIndex = index;
      }
    },
    changeIndex3: function changeIndex3(index) {
      console.log("changeIndex3");
      var vm = this;

      this.menuIndex = 0;
      $("#submenu0").addClass("aaa");
      $(".dropdown-toggle").addClass("aaa");
    },
    getFirstTypeProduct: function getFirstTypeProduct(menu) {
      if (menu.children != undefined && menu.children != null && menu.children != '') {
        this.getFirstTypeProduct(menu.children[0]);
      } else {
        this.getProducts(menu.id, menu.menuName, 1);
      }
    },
    getPageNo: function getPageNo(pageNo) {
      var vm = this;
      vm.pageNo = pageNo;
      vm.getProducts(vm.parentId, vm.titleName, vm.pageNo);
    },
    getProductDetails: function getProductDetails(id) {
      var vm = this;
      vm.$_axios({
        method: 'post',
        url: '/mapis/product/getProductDetails',
        params: {
          id: id
        },
        needLogin: false
      }).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data.data;
          vm.productList = responseData;
          vm.$router.push({ name: 'products', query: { parentId: id, s: Math.random() } });
        }
      });
    },
    toProductDetails: function toProductDetails(product) {
      var vm = this;
      if (product.decr == null) {
        this.$alert("暂无详细介绍");
        return;
      }

      vm.$_storage.setLocalStore('product', product);
      vm.$router.push({ name: 'productDetails' });
    }
  },
  created: function created() {
    var vm = this;
    vm.getMenu();

    this.$router.afterEach(function (to, from, next) {
      window.scrollTo(0, 0);
    });
  },
  mounted: function mounted() {
    var vm = this;
  }
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Pagination__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Pagination__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      search_list: [],
      pageSize: 5,
      pageNo: 1,
      total: 0,
      text: this.$route.query.text
    };
  },

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_0__components_Pagination___default.a
  },
  methods: {
    getSearch: function getSearch(text, pageNo) {
      var vm = this;
      vm.text = text;
      vm.pageNo = pageNo;
      console.log(vm.text);

      vm.$_axios({
        method: 'post',
        url: '/mapis/search/searchDocs',
        data: {
          text: vm.text,
          pageNo: vm.pageNo,
          pageSize: vm.pageSize
        },
        needLogin: false
      }).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data.data;
          vm.search_list = responseData.docDtoList;
          vm.total = responseData.total;
        }
      });
    },
    getPageNo: function getPageNo(pageNo) {
      var vm = this;
      vm.pageNo = pageNo;
      vm.getSearch(vm.text, vm.pageNo);
    },
    toProductDetails: function toProductDetails(product) {
      var vm = this;
      var list = product;
      console.log(list.name);
      if (list.desc != '') {
        list.name = list.name.replace('<font color=\'red\'>', '').replace('</font>', '');
        vm.$_storage.setLocalStore('product', list);
        vm.$router.push({ name: 'productDetails' });
      } else {
        this.$alert("未查询到产品信息");
      }
    }
  },
  mounted: function mounted() {
    var vm = this;
    vm.getSearch(vm.text, 1);
  }
});

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_storage__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_simple_alert__ = __webpack_require__(139);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_simple_alert__["a" /* default */]);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$_axios = __WEBPACK_IMPORTED_MODULE_6_axios__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$_storage = __WEBPACK_IMPORTED_MODULE_5__utils_storage__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].afterEach(function (to, from, next) {
  window.scrollTo(0, 0);
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = map;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

function map(ak) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    window.onBMapCallback = function () {
      resolve(BMap);
    };
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://api.map.baidu.com/api?v=2.0&ak=" + ak + "&callback=onBMapCallback";
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(131)();
// imports


// module
exports.push([module.i, ".goods-image[data-v-751d5116]{width:100%;height:480px;position:relative;display:-ms-flexbox;display:flex;z-index:500}.goods-image .larger[data-v-751d5116]{position:absolute;top:0;left:600px;width:480px;height:384px;box-shadow:0 0 10px rgba(0,0,0,.1);background-repeat:no-repeat;background-size:800px 800px;background-color:#f8f8f8;z-index:9999}.goods-image .middle[data-v-751d5116]{width:400px;height:320px;background:#f5f5f5;position:relative;cursor:move}.goods-image .middle .layer[data-v-751d5116]{width:200px;height:200px;background:rgba(0,0,0,.2);left:0;top:0;position:absolute}", ""]);

// exports


/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(131)();
// imports


// module
exports.push([module.i, ".pagination[data-v-c4cf4fea]{text-align:center}.pagination button[data-v-c4cf4fea]{margin:0 5px;background-color:#f4f4f5;color:#606266;outline:none;border-radius:2px;padding:0 4px;vertical-align:top;display:inline-block;font-size:13px;min-width:35.5px;height:28px;line-height:28px;cursor:pointer;box-sizing:border-box;text-align:center;border:0}.pagination button[disabled][data-v-c4cf4fea]{color:#c0c4cc;cursor:not-allowed}.pagination button.active[data-v-c4cf4fea]{cursor:not-allowed;background-color:#409eff;color:#fff}", ""]);

// exports


/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Banner01.a3cd55a.jpg";

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Banner02.e45edab.jpg";

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Banner03.9757ee5.jpg";

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about-banner.abdaa6b.jpg";

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contactbanner.920d8f3.jpg";

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/joinus.e2019e7.jpg";

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(300),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(305),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(309),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(302),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(304),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(311),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(307),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(313)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(308),
  /* scopeId */
  "data-v-751d5116",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(301),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(306),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": __webpack_require__(286),
      "alt": "aboutbanner"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "mbx"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "mbxwrap"
  }, [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('em', [_vm._v("关于我们")])], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area",
    staticStyle: {
      "padding-top": "20px",
      "padding-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 contleft"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('nav', {
    attrs: {
      "id": "sidebar"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "leftNav"
  }, [_c('ul', {
    staticClass: "list-unstyled components"
  }, _vm._l((_vm.menuList), function(list, index) {
    return _c('li', [(list.children != undefined && list.children != null && list.children != '') ? _c('div', [_c('a', {
      staticClass: "dropdown-toggle leftNavCur",
      attrs: {
        "href": '#submenu' + index,
        "data-toggle": "collapse",
        "aria-expanded": "false"
      }
    }, [_vm._v(_vm._s(list.menuName))]), _vm._v(" "), _c('ul', {
      staticClass: "collapse list-unstyled",
      attrs: {
        "id": 'submenu' + index
      }
    }, _vm._l((list.children), function(sublist, subindex) {
      return _c('li', [_c('a', {
        staticClass: "leftNavCur2",
        attrs: {
          "href": "#"
        }
      }, [_vm._v(" - " + _vm._s(sublist.menuName))])])
    }), 0)]) : _c('div', [_c('a', {
      key: index,
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.getInfo(list.id)
        }
      }
    }, [_vm._v(_vm._s(list.menuName))])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 contright"
  }, [_c('h2', {
    staticClass: "rightTitle"
  }, [_vm._v(_vm._s(_vm.aboutInfo.menuName))]), _vm._v(" "), _c('div', {
    staticClass: "Article"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.aboutInfo.dscr)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clears"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "nytit pull-left"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('menu', {
    staticClass: "menu pull-left",
    attrs: {
      "id": "menu"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-header"
  }, [_c('h2', {
    staticClass: "leftTitle"
  }, [_vm._v("关于我们")])])
}]}

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": __webpack_require__(79),
      "alt": "banner02"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "mbx"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "mbxwrap"
  }, [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('em', [_vm._v("产品展示")])], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area",
    staticStyle: {
      "padding-top": "20px",
      "padding-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 contleft"
  }, [_c('div', {
    staticClass: "wrapper",
    staticStyle: {
      "min-width": "150px"
    }
  }, [_c('nav', {
    attrs: {
      "id": "sidebar"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "leftNav"
  }, [_c('ul', {
    staticClass: "list-unstyled components",
    staticStyle: {
      "min-width": "150px"
    }
  }, _vm._l((_vm.menuList), function(list, index) {
    return _c('li', [(list.children != undefined && list.children != null && list.children != '') ? _c('div', [_c('a', {
      key: index,
      staticClass: "dropdown-toggle",
      attrs: {
        "href": '#submenu' + index,
        "data-toggle": "collapse",
        "id": 'a' + index,
        "aria-expanded": "false"
      },
      on: {
        "click": function($event) {
          return _vm.changeIndex(index)
        }
      }
    }, [_vm._v(_vm._s(list.menuName))]), _vm._v(" "), _c('ul', {
      staticClass: "collapse list-unstyled",
      attrs: {
        "id": 'submenu' + index
      }
    }, _vm._l((list.children), function(sublist, subindex) {
      return _c('li', [(sublist.children != undefined && sublist.children != null && sublist.children != '') ? _c('div', [_c('a', {
        staticClass: "dropdown-toggle leftNavCur",
        attrs: {
          "href": '#childmenu' + subindex,
          "data-toggle": "collapse",
          "aria-expanded": "false"
        },
        on: {
          "click": function($event) {
            return _vm.changeIndex2(subindex)
          }
        }
      }, [_vm._v("   " + _vm._s(sublist.menuName))]), _vm._v(" "), _c('ul', {
        staticClass: "collapse list-unstyled sub",
        attrs: {
          "id": 'childmenu' + subindex
        }
      }, _vm._l((sublist.children), function(childlist, childindex) {
        return _c('li', [_c('a', {
          key: subindex,
          staticClass: "leftNavCur2 secondmenu p2",
          attrs: {
            "href": "javascript:void(0);"
          },
          on: {
            "click": function($event) {
              return _vm.getProducts(childlist.id, childlist.menuName, 1)
            }
          }
        }, [_vm._v("      - " + _vm._s(childlist.menuName))])])
      }), 0)]) : _c('div', [_c('a', {
        key: subindex,
        staticClass: "leftNavCur2 p2",
        attrs: {
          "href": "javascript:void(0);"
        },
        on: {
          "click": function($event) {
            return _vm.getProducts(sublist.id, sublist.menuName, 1)
          }
        }
      }, [_vm._v(" - " + _vm._s(sublist.menuName))])])])
    }), 0)]) : _vm._e()])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 contright"
  }, [_c('h2', {
    staticClass: "rightTitle"
  }, [_vm._v(_vm._s(_vm.titleName))]), _vm._v(" "), _c('div', {
    staticClass: "Article"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "90%",
      "margin": "auto"
    }
  }, _vm._l((_vm.productList), function(list, index) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-6 section-padding4"
    }, [_c('div', {
      key: index,
      staticClass: "card div1 big-box",
      staticStyle: {
        "background-color": "#F5F5F5"
      },
      on: {
        "click": function($event) {
          return _vm.toProductDetails(list)
        }
      }
    }, [_c('div', [_c('img', {
      staticClass: "card-img-top aspect-ratio-16-9",
      attrs: {
        "src": list.path,
        "alt": "",
        "title": list.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-body",
      staticStyle: {
        "border-top": "1px solid lightgrey"
      }
    }, [_c('p', {
      staticClass: "card-text p2",
      attrs: {
        "title": list.name
      }
    }, [_vm._v(_vm._s(list.name))])])])])
  }), 0)]), _vm._v(" "), (_vm.total != 0) ? _c('Pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "page-no": _vm.pageNo,
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "continues": 5
    },
    on: {
      "getPageNo": _vm.getPageNo
    }
  }) : _vm._e()], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "nytit pull-left"
  }, [_vm._v("产品展示")]), _vm._v(" "), _c('menu', {
    staticClass: "menu pull-left",
    attrs: {
      "id": "menu"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-header"
  }, [_c('h2', {
    staticClass: "leftTitle"
  }, [_vm._v("产品展示")])])
}]}

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding5 section-padding4"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "rowFluid"
  }, [_c('div', {
    staticClass: "news_center_content"
  }, [_c('div', {
    staticClass: "span4 col-sm-12 wow fadeInDown",
    attrs: {
      "data-wow-delay": "1.2s"
    }
  }, [_c('div', {
    staticClass: "news_center_list",
    on: {
      "click": function($event) {
        return _vm.toNews()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "news_center_list_title"
  }, [_vm._v("新闻资讯")])])]), _vm._v(" "), _c('div', {
    staticClass: "span4 col-sm-12 wow fadeInUp",
    attrs: {
      "data-wow-delay": "0.7s"
    }
  }, [_c('div', {
    staticClass: "news_center_list",
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "news_center_list_title"
  }, [_vm._v("新品前言")])])]), _vm._v(" "), _c('div', {
    staticClass: "span4 col-sm-12 wow fadeInDown",
    attrs: {
      "data-wow-delay": "1.3s"
    }
  }, [_c('div', {
    staticClass: "news_center_list",
    on: {
      "click": function($event) {
        return _vm.toAbout()
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "news_center_list_title"
  }, [_vm._v("关于我们")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "carouselExampleIndicators",
      "data-ride": "carousel"
    }
  }, [_c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#carouselExampleIndicators",
      "data-slide-to": "0"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carouselExampleIndicators",
      "data-slide-to": "1"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carouselExampleIndicators",
      "data-slide-to": "2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner"
  }, [_c('div', {
    staticClass: "carousel-item active"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": __webpack_require__(283),
      "alt": "..."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-item"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": __webpack_require__(284),
      "alt": "..."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-item"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": __webpack_require__(285),
      "alt": "..."
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news_center_list_img"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/038.jpg",
      "alt": "公司新闻"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news_center_list_img"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/034.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news_center_list_img"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/037.jpg"
    }
  })])
}]}

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('header', {
    staticClass: "header-area single-page"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "logo-area"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(289),
      "alt": "logo"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "main-menu main-menu-light"
  }, [_c('ul', [_c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("关于我们")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("产品展示")])], 1), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "underline",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "to": "/news"
    },
    on: {
      "click": function($event) {
        return _vm.route()
      }
    }
  }, [_vm._v("新闻中心")])]), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/joinus"
    }
  }, [_vm._v("加入我们")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("联系我们")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-btn d-inline-flex"
  }, [_c('div', {
    staticClass: "input-group flex-nowrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": "查询产品",
      "aria-label": "搜索"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "btn btn-outline-secondary",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-search",
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  })])])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "qqkefu"
  }, [_c('ul', [_c('li', {
    staticClass: "top anchor",
    on: {
      "click": function($event) {
        return _vm.returntop()
      }
    }
  }, [_vm._v("TOP"), _c('span')]), _vm._v(" "), _c('li', {
    staticClass: "qq_cza",
    on: {
      "click": function($event) {
        return _vm.toQQ()
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footer', {
    staticClass: "footer-area section-padding4 section-padding5"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-2 col-lg-3"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0"
  }, [_c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("产品导航")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "mb-2"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._v("西安天隆")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._v("上海智城")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._v("上海屹谱")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._v("北京中仪宇盛")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-lg-3"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0"
  }, [_c('ul', {
    staticStyle: {
      "padding-top": "55px"
    }
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._v("上海仪硕")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._v("上海美瑞克")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._v("宁波新芝")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.toProducts()
      }
    }
  }, [_vm._v("北京大龙")])])])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_vm._v("Copyright © 北京泽浩天科技发展有限公司　备案号：京ICP备2025103103号-1")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "spinner"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-navbar"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "a"
  }), _vm._v("咨询")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "qq_cza",
    attrs: {
      "id": "zx"
    }
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "b"
  }), _vm._v("在线咨询")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "qq_czb"
  }, [_c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "erweima"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": "static/assets/images/qrcode.png"
    }
  }), _vm._v("二维码")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xl-5 offset-xl-1 col-lg-6"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0"
  }, [_c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("联系方式")]), _vm._v(" "), _c('p', {
    staticClass: "mb-3"
  }, [_vm._v("电话：010-67047381，010-61807868")]), _vm._v(" "), _c('p', {
    staticClass: "mb-3"
  }, [_vm._v("电子邮箱：zehaotian@139.com")]), _vm._v(" "), _c('p', {
    staticClass: "mb-3"
  }, [_vm._v("公司地址：北京市门头沟区熙旺中心A座1026")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100px",
      "width": "100px"
    },
    attrs: {
      "src": "/static/assets/images/qrcode.png",
      "alt": "feed"
    }
  })])
}]}

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": __webpack_require__(288),
      "alt": "joinusbanner"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "mbx"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "mbxwrap"
  }, [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('em', [_vm._v("加入我们")])], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area paddingtop30 paddingbottom30"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "scd_r"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "join"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "space_hx"
  }, [_vm._v(" ")]), _vm._v(" "), _c('table', {
    staticClass: "j_c",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.recruit_info_list), function(list, index) {
    return _c('tr', {
      class: {
        rowcolor: index % 2 == 1
      }
    }, [_c('td', [_vm._v(_vm._s(list.positionNm))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(list.recruitNum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(list.workplace))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(list.releaseDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(list.deadline))])])
  })], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "nytit pull-left"
  }, [_vm._v("加入我们")]), _vm._v(" "), _c('menu', {
    staticClass: "menu pull-left",
    attrs: {
      "id": "menu"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "r_name"
  }, [_c('span', [_vm._v("人才招聘")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "j_a"
  }, [_vm._v("人才是公司发展的重要因素，人才是公司最大的财富，本公司秉承以人为本，公平、公正、公开的经营管理原则, 为员工创造一个施展才华的舞台，通过丰裕的工作内容、优越的工作环境以及和谐的工作氛围，实现企业与个人的良性互动。公司提供具有竞争力的薪酬、福利及晋升机会, 诚邀各方英才加入北京泽浩天科技发展有限公司工作团队。"), _c('br'), _vm._v("\n              我们真诚期待你的加入！")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "j_b"
  }, [_c('b', [_vm._v("人事部门联络资料")]), _vm._v(" "), _c('p', [_vm._v("请有意者将个人简历、照片及学历证明复印件等相关资料发送至")]), _vm._v(" "), _c('p', [_vm._v("邮箱:"), _c('a', {
    attrs: {
      "href": "mailto:zehaotian@139.com"
    }
  }, [_vm._v(" zehaotian@139.com")])]), _vm._v(" "), _c('p', [_vm._v("电话: "), _c('a', {
    attrs: {
      "href": "tel:010-67047381"
    }
  }, [_vm._v("010-67047381")]), _vm._v("    联络人："), _c('span', [_vm._v("王先生")])]), _vm._v(" "), _c('b', [_vm._v("公司目前招聘岗位如下:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("职位名称")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("招聘人数")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("工作地点")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("发布日期")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("截止日期")])])
}]}

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": __webpack_require__(287),
      "alt": "contactbanner"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "mbx"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "mbxwrap"
  }, [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('em', [_vm._v("联系我们")])], 1)])])])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "nytit"
  }, [_vm._v("联系我们")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "nycon"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "contact"
  }, [_c('div', {
    staticClass: "ctactit"
  }, [_c('h1', [_vm._v("北京泽浩天科技发展有限公司")]), _vm._v(" "), _c('span', [_vm._v("BEIJING ZEHAOTIAN TECHNOLOGY CO. LTD.")])]), _vm._v(" "), _c('div', {
    staticClass: "ctactcon clearfix"
  }, [_c('div', {
    staticClass: "ditu pull-left"
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctactwrap pull-right"
  }, [_c('ul', [_c('li', [_vm._v("联系人：王经理")]), _vm._v(" "), _c('li', [_vm._v("电话：010-67047381，010-61807868")]), _vm._v(" "), _c('li', [_vm._v("邮箱：zehaotian@139.com")]), _vm._v(" "), _c('li', [_vm._v("地址：北京市门头沟区熙旺中心A座1026 ")]), _vm._v(" "), _c('li', [_vm._v("微信号： ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-top": "3px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/qrcode.png",
      "alt": "feed"
    }
  })])])])])])])])])
}]}

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": __webpack_require__(79),
      "alt": "newsbanner"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "mbx"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "mbxwrap"
  }, [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('em', [_vm._v("搜索结果")])], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area paddingtop30 paddingbottom30"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "news"
  }, [_c('ul', _vm._l((_vm.search_list), function(list, index) {
    return _c('li', [_c('div', {
      staticClass: "pic pull-left"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.toProductDetails(list)
        }
      }
    }, [_c('img', {
      staticClass: "vcenter",
      attrs: {
        "src": list.image,
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "ntxt pull-left"
    }, [_c('a', {
      staticClass: "underline",
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.toProductDetails(list)
        }
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(list.name + '(' + list.menu + ')')
      }
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(list.decr))])])])
  }), 0)])])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area paddingbottom30"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [(_vm.total != 0) ? _c('Pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "page-no": _vm.pageNo,
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "continues": 5
    },
    on: {
      "getPageNo": _vm.getPageNo
    }
  }) : _vm._e()], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "nytit pull-left"
  }, [_vm._v("搜索结果")])])
}]}

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": __webpack_require__(132),
      "alt": "newsbanner"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "mbx"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "nytit pull-left"
  }, [_vm._v("新闻中心")]), _vm._v(" "), _c('menu', {
    staticClass: "menu pull-left",
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    staticClass: "pull-left paddingleft15"
  }, [_c('a', {
    staticClass: "underline text66",
    class: {
      'cur': _vm.nav_status_1
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(0)
      }
    }
  }, [_vm._v("企业动态")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left paddingleft15"
  }, [_c('a', {
    staticClass: "underline text66",
    class: {
      'cur': _vm.nav_status_2
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(1)
      }
    }
  }, [_vm._v("代理品牌动态")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left paddingleft15"
  }, [_c('a', {
    staticClass: "underline text66",
    class: {
      'cur': _vm.nav_status_3
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(2)
      }
    }
  }, [_vm._v("行业资讯")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "mbxwrap"
  }, [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/news"
    }
  }, [_vm._v("新闻中心")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('em', [_vm._v(_vm._s(_vm.breadCrumbName))])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "nycon"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "news_show"
  }, [_c('div', {
    staticClass: "nstit"
  }, [_c('h1', [_vm._v(_vm._s(_vm.news_details.title))]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_c('span', [_vm._v("时间：" + _vm._s(_vm.news_details.updateTime))]), _vm._v(" "), _c('span', [_vm._v("来源：北京泽浩天")]), _vm._v(" "), _c('span', [_vm._v("浏览量：" + _vm._s(_vm.news_details.pageView))])])]), _vm._v(" "), _c('div', {
    staticClass: "nstxt",
    staticStyle: {
      "color": "black"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.news_details.newsContent)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "prevnext clearfix"
  }, [_c('div', {
    staticClass: "pnwrap pull-left"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.getNewsDetailsPreOrNext(_vm.news_pre)
      }
    }
  }, [_vm._v("上一篇：" + _vm._s(_vm.news_pre.title))]), _vm._v(" "), _c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.getNewsDetailsPreOrNext(_vm.news_next)
      }
    }
  }, [_vm._v("下一篇：" + _vm._s(_vm.news_next.title))])]), _vm._v(" "), _c('router-link', {
    staticClass: "return pull-right underline",
    attrs: {
      "to": "/news"
    }
  }, [_vm._v("\n              返回列表\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "xgnews clearfix"
  }, [_vm._m(0), _vm._v(" "), (_vm.news_related_list != null || _vm.news_related_list != '' || _vm.news_related_list != undefined) ? _c('div', [_c('ul', {
    staticClass: "pull-left"
  }, _vm._l((_vm.news_related_list), function(list, index) {
    return (index % 2 == 0) ? _c('li', [_c('a', {
      staticClass: "myoverflow underline",
      attrs: {
        "href": "javascript:void(0);",
        "title": list.title
      },
      on: {
        "click": function($event) {
          return _vm.getNewsDetailsPreOrNext(list)
        }
      }
    }, [_vm._v(_vm._s(list.title))]), _c('span', [_vm._v("[ " + _vm._s(list.updateTime) + " ]")])]) : _vm._e()
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "pull-right"
  }, _vm._l((_vm.news_related_list), function(list, index) {
    return (index % 2 == 1) ? _c('li', [_c('a', {
      staticClass: "myoverflow underline",
      attrs: {
        "href": "javascript:void(0);",
        "title": list.title
      },
      on: {
        "click": function($event) {
          return _vm.getNewsDetailsPreOrNext(list)
        }
      }
    }, [_vm._v(_vm._s(list.title))]), _c('span', [_vm._v("[ " + _vm._s(list.updateTime) + " ]")])]) : _vm._e()
  }), 0)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pstit"
  }, [_c('span', [_vm._v("相关新闻")])])
}]}

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": __webpack_require__(79),
      "alt": "banner02"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "mbx"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "mbxwrap"
  }, [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("产品展示")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('em', [_vm._v("产品详细")])], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding6",
    staticStyle: {
      "border-bottom": "3px solid #efefef"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 goods-image"
  }, [_c('div', {
    ref: "target",
    staticClass: "middle col-lg-5",
    staticStyle: {
      "width": "25rem",
      "height": "20rem",
      "border": "1px solid #eee"
    }
  }, [_c('img', {
    staticClass: "product-image",
    attrs: {
      "src": _vm.productDetails.images.split(';')[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "layer",
    style: (_vm.layerPosition)
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "larger",
    style: ([{
      backgroundImage: "url(" + _vm.productDetails.images + ")"
    }, _vm.largePosition])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7"
  }, [_c('h1', [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "1.3rem",
      "padding-top": "30px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.product.decr) + "\n                ")])])])])])])]), _vm._v(" "), (_vm.feture_list != undefined && _vm.feture_list != null && _vm.feture_list != '') ? _c('section', {
    staticClass: "jobs-area section-padding3 paddingtop30",
    staticStyle: {
      "border-bottom": "3px solid #efefef"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.feture_list), function(list, index) {
    return _c('div', {
      staticClass: "col-lg-12 paddingtop30"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header",
      staticStyle: {
        "background-color": "#4794da",
        "color": "white !important"
      }
    }, [_c('div', [_vm._v(_vm._s(list.name))])]), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, _vm._l((list.values), function(subList, subIndex) {
      return _c('p', {
        attrs: {
          "white-space": "pre-wrap"
        }
      }, [_vm._v(_vm._s(subList))])
    }), 0)])])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.param_list != undefined && _vm.param_list != null && _vm.param_list != '') ? _c('section', {
    staticClass: "jobs-area section-padding3 section-padding6"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "table",
    attrs: {
      "id": "tab01"
    }
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', _vm._l((_vm.param_list[0].excelColumnList), function(list, index) {
    return _c('th', {
      attrs: {
        "scope": "col",
        "colspan": list.columnSpan
      }
    }, [_vm._v(_vm._s(list.columnValue))])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.param_list), function(list, index) {
    return (index > 0) ? _c('tr', {
      class: {
        rowcolor: index % 2 == 0
      }
    }, _vm._l((list.excelColumnList), function(col, colIndex) {
      return _c('td', {
        attrs: {
          "white-space": "pre-wrap",
          "colspan": col.columnSpan
        }
      }, [_vm._v(_vm._s(col.columnValue))])
    }), 0) : _vm._e()
  }), 0)]), _vm._v(" "), (_vm.param_list_2 != undefined && _vm.param_list_2 != null && _vm.param_list_2 != '') ? _c('table', {
    staticClass: "table",
    attrs: {
      "id": "tab02"
    }
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', _vm._l((_vm.param_list_2[0].excelColumnList), function(list, index) {
    return _c('th', {
      attrs: {
        "scope": "col",
        "colspan": list.columnSpan
      }
    }, [_vm._v(_vm._s(list.columnValue))])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.param_list_2), function(list, index) {
    return (index > 0) ? _c('tr', {
      class: {
        rowcolor: index % 2 == 0
      }
    }, _vm._l((list.excelColumnList), function(col, colIndex) {
      return _c('td', {
        attrs: {
          "white-space": "pre-wrap",
          "colspan": col.columnSpan
        }
      }, [_vm._v(_vm._s(col.columnValue))])
    }), 0) : _vm._e()
  }), 0)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.param_list_3 != undefined && _vm.param_list_3 != null && _vm.param_list_3 != '') ? _c('section', {
    staticClass: "jobs-area section-padding3 section-padding6"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_vm._m(3), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', _vm._l((_vm.param_list_3[0].excelColumnList), function(list, index) {
    return _c('th', {
      attrs: {
        "scope": "col",
        "colspan": list.columnSpan
      }
    }, [_vm._v(_vm._s(list.columnValue))])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.param_list_3), function(list, index) {
    return (index > 0) ? _c('tr', {
      class: {
        rowcolor: index % 2 == 0
      }
    }, _vm._l((list.excelColumnList), function(col, colIndex) {
      return _c('td', {
        attrs: {
          "white-space": "pre-wrap",
          "colspan": col.columnSpan
        }
      }, [_vm._v(_vm._s(col.columnValue))])
    }), 0) : _vm._e()
  }), 0)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "nytit pull-left"
  }, [_vm._v("产品展示")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "jobs-title"
  }, [_c('h2', [_vm._v("产品介绍")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row paddingbottom30"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "jobs-title"
  }, [_c('h2', [_vm._v("产品技术参数")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row paddingbottom30"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "jobs-title"
  }, [_c('h2', [_vm._v("器皿配置表")])])])])
}]}

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "sample-text-area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "text-heading title_color"
  }, [_vm._v("Text Sample")]), _vm._v(" "), _c('p', {
    staticClass: "sample-text"
  }, [_vm._v("\n        Every avid independent filmmaker has "), _c('b', [_vm._v("Bold")]), _vm._v(" about making that "), _c('i', [_vm._v("Italic")]), _vm._v(" interest documentary, or short film to show off their creative prowess. Many have great ideas and want to “wow” the"), _c('sup', [_vm._v("Superscript")]), _vm._v(" scene, or video renters with their big project.  But once you have the"), _c('sub', [_vm._v("Subscript")]), _vm._v(" “in the can” (no easy feat), how do you move from a "), _c('del', [_vm._v("Strike")]), _vm._v(" through of master DVDs with the "), _c('u', [_vm._v("“Underline”")]), _vm._v(" marked hand-written title inside a secondhand CD case, to a pile of cardboard boxes full of shiny new, retail-ready DVDs, with UPC barcodes and polywrap sitting on your doorstep?  You need to create eye-popping artwork and have your project replicated. Using a reputable full service DVD Replication company like PacificDisc, Inc. to partner with is certainly a helpful option to ensure a professional end result, but to help with your DVD replication project, here are 4 easy steps to follow for good DVD replication results:\n\n      ")])])]), _vm._v(" "), _c('section', {
    staticClass: "button-area"
  }, [_c('div', {
    staticClass: "container border-top-generic"
  }, [_c('h3', {
    staticClass: "text-heading title_color"
  }, [_vm._v("Sample Buttons")]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area"
  }, [_c('a', {
    staticClass: "genric-btn default",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn default-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-40"
  }, [_c('a', {
    staticClass: "genric-btn default radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn default-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-40"
  }, [_c('a', {
    staticClass: "genric-btn default circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn default-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-40"
  }, [_c('a', {
    staticClass: "genric-btn default circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn default-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-40"
  }, [_c('a', {
    staticClass: "genric-btn primary e-large",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Extra Large")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success large",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Large")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success medium",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Medium")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary small",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Small")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn primary-border e-large",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Extra Large")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border large",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Large")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border medium",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Medium")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border small",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Small")])])])]), _vm._v(" "), _c('div', {
    staticClass: "whole-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Left Aligned")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/elements/d.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 mt-sm-20 left-align-p"
  }, [_c('p', [_vm._v("Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks such as Party Gaming and PlayTech left the United States. Overnight, online casino players found themselves being chased by the Federal government. But, after a fortnight, the online casino industry came up with a solution and new online casinos started taking root. These began to operate under a different business umbrella, and by doing that, rendered the transfer of money to and from them legal. A major part of this was enlisting electronic banking systems that would accept this new clarification and start doing business with me. Listed in this article are the electronic banking systems that accept players from the United States that wish to play in online casinos.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border text-right"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Right Aligned")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('p', {
    staticClass: "text-right"
  }, [_vm._v("Over time, even the most sophisticated, memory packed computer can begin to run slow if we don’t do something to prevent it. The reason why has less to do with how computers are made and how they age and more to do with the way we use them. You see, all of the daily tasks that we do on our PC from running programs to downloading and deleting software can make our computer sluggish. To keep this from happening, you need to understand the reasons why your PC is getting slower and do something to keep your PC running at its best. You can do this through regular maintenance and PC performance optimization programs")]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_vm._v("Before we discuss all of the things that could be affecting your PC’s performance, let’s talk a little about what symptoms")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/elements/d.jpg",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Definition")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-defination"
  }, [_c('h4', {
    staticClass: "mb-20"
  }, [_vm._v("Definition 01")]), _vm._v(" "), _c('p', [_vm._v("Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-defination"
  }, [_c('h4', {
    staticClass: "mb-20"
  }, [_vm._v("Definition 02")]), _vm._v(" "), _c('p', [_vm._v("Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-defination"
  }, [_c('h4', {
    staticClass: "mb-20"
  }, [_vm._v("Definition 03")]), _vm._v(" "), _c('p', [_vm._v("Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Block Quotes")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('blockquote', {
    staticClass: "generic-blockquote"
  }, [_vm._v("\n              “Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks such as Party Gaming and PlayTech left the United States. Overnight, online casino players found themselves being chased by the Federal government. But, after a fortnight, the online casino industry came up with a solution and new online casinos started taking root. These began to operate under a different business umbrella, and by doing that, rendered the transfer of money to and from them legal. A major part of this was enlisting electronic banking systems that would accept this new clarification and start doing business with me. Listed in this article are the electronic banking”\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Table")]), _vm._v(" "), _c('div', {
    staticClass: "progress-table-wrap"
  }, [_c('div', {
    staticClass: "progress-table"
  }, [_c('div', {
    staticClass: "table-head"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("#")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_vm._v("Countries")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("Visits")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_vm._v("Percentages")])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("01")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f1.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "80",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("02")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f2.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-2",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "30",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("03")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f3.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-3",
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "55",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("04")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f4.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-4",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("05")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f5.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-5",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "40",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("06")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f6.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-6",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "70",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("07")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f7.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-7",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "30",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("08")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f8.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-8",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "title_color"
  }, [_vm._v("Image Gallery")]), _vm._v(" "), _c('div', {
    staticClass: "row gallery-item"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g1.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g1.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g2.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g2.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g3.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g3.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g4.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g4.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g5.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g5.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g6.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g6.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g7.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g7.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g8.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g8.jpg)"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-sm-6 typo-sec"
  }, [_c('h3', {
    staticClass: "mb-20 title_color"
  }, [_vm._v("Typography")]), _vm._v(" "), _c('div', {
    staticClass: "typography"
  }, [_c('h1', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 01")]), _vm._v(" "), _c('h2', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 02")]), _vm._v(" "), _c('h3', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 03")]), _vm._v(" "), _c('h4', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 04")]), _vm._v(" "), _c('h5', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 01")]), _vm._v(" "), _c('h6', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 01")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-sm-6 mt-sm-30 typo-sec"
  }, [_c('h3', {
    staticClass: "mb-20 title_color"
  }, [_vm._v("Unordered List")]), _vm._v(" "), _c('div', {}, [_c('ul', {
    staticClass: "unordered-list"
  }, [_c('li', [_vm._v("Fta Keys")]), _vm._v(" "), _c('li', [_vm._v("For Women Only Your Computer Usage")]), _vm._v(" "), _c('li', [_vm._v("Facts Why Inkjet Printing Is Very Appealing\n                  "), _c('ul', [_c('li', [_vm._v("Addiction When Gambling Becomes\n                      "), _c('ul', [_c('li', [_vm._v("Protective Preventative Maintenance")])])])])]), _vm._v(" "), _c('li', [_vm._v("Dealing With Technical Support 10 Useful Tips")]), _vm._v(" "), _c('li', [_vm._v("Make Myspace Your Best Designed Space")]), _vm._v(" "), _c('li', [_vm._v("Cleaning And Organizing Your Computer")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-sm-6 mt-sm-30 typo-sec"
  }, [_c('h3', {
    staticClass: "mb-20 title_color"
  }, [_vm._v("Ordered List")]), _vm._v(" "), _c('div', {}, [_c('ol', {
    staticClass: "ordered-list"
  }, [_c('li', [_c('span', [_vm._v("Fta Keys")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("For Women Only Your Computer Usage")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Facts Why Inkjet Printing Is Very Appealing")]), _vm._v(" "), _c('ol', {
    staticClass: "ordered-list-alpha"
  }, [_c('li', [_c('span', [_vm._v("Addiction When Gambling Becomes")]), _vm._v(" "), _c('ol', {
    staticClass: "ordered-list-roman"
  }, [_c('li', [_c('span', [_vm._v("Protective Preventative Maintenance")])])])])])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Dealing With Technical Support 10 Useful Tips")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Make Myspace Your Best Designed Space")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Cleaning And Organizing Your Computer")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Form Element")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": "First Name",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'First Name'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "text",
      "name": "last_name",
      "placeholder": "Last Name",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Last Name'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "text",
      "name": "last_name",
      "placeholder": "Last Name",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Last Name'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "email",
      "name": "EMAIL",
      "placeholder": "Email address",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Email address'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group-icon mt-10"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-thumb-tack",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "text",
      "name": "address",
      "placeholder": "Address",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Address'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group-icon mt-10"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plane",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-select",
    attrs: {
      "id": "default-select"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Dhaka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Dilli")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Newyork")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Islamabad")])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group-icon mt-10"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-globe",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-select",
    attrs: {
      "id": "default-select2"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Bangladesh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("India")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("England")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Srilanka")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('textarea', {
    staticClass: "single-textarea",
    attrs: {
      "placeholder": "Message",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Message'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input-primary",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": "Primary color",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Primary color'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input-accent",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": "Accent color",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Accent color'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input-secondary",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": "Secondary color",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Secondary color'",
      "required": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-4 mt-sm-30 element-wrap"
  }, [_c('div', {
    staticClass: "single-element-widget"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Switches")]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("01. Sample Switch")]), _vm._v(" "), _c('div', {
    staticClass: "primary-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "default-switch"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "default-switch"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("02. Primary Color Switch")]), _vm._v(" "), _c('div', {
    staticClass: "primary-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "primary-switch",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "primary-switch"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("03. Confirm Color Switch")]), _vm._v(" "), _c('div', {
    staticClass: "confirm-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "confirm-switch",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirm-switch"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "single-element-widget"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Selectboxes")]), _vm._v(" "), _c('div', {
    staticClass: "default-select",
    attrs: {
      "id": "default-select"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Spanish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Arabic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Portuguise")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Bengali")])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-element-widget"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Checkboxes")]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("01. Sample Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "primary-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "default-checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "default-checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("02. Primary Color Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "primary-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "primary-checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "primary-checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("03. Confirm Color Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "confirm-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "confirm-checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirm-checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("04. Disabled Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "disabled-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "disabled-checkbox",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabled-checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("05. Disabled Checkbox active")]), _vm._v(" "), _c('div', {
    staticClass: "disabled-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "disabled-checkbox-active",
      "checked": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabled-checkbox-active"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "single-element-widget"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Radios")]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("01. Sample radio")]), _vm._v(" "), _c('div', {
    staticClass: "primary-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "default-radio"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "default-radio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("02. Primary Color radio")]), _vm._v(" "), _c('div', {
    staticClass: "primary-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "primary-radio",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "primary-radio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("03. Confirm Color radio")]), _vm._v(" "), _c('div', {
    staticClass: "confirm-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "confirm-radio",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirm-radio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("04. Disabled radio")]), _vm._v(" "), _c('div', {
    staticClass: "disabled-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "disabled-radio",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabled-radio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("05. Disabled radio active")]), _vm._v(" "), _c('div', {
    staticClass: "disabled-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "disabled-radio-active",
      "checked": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabled-radio-active"
    }
  })])])])])])])])])])
}]}

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagination"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.pageNo == 1
    },
    on: {
      "click": function($event) {
        return _vm.$emit('getPageNo', _vm.pageNo - 1)
      }
    }
  }, [_vm._v("\n    上一页\n  ")]), _vm._v(" "), (_vm.startNumAndEndNum.start > 1) ? _c('button', {
    class: {
      active: _vm.pageNo == 1
    },
    on: {
      "click": function($event) {
        return _vm.$emit('getPageNo', 1)
      }
    }
  }, [_vm._v("\n    1\n  ")]) : _vm._e(), _vm._v(" "), (_vm.startNumAndEndNum.start > 2) ? _c('button', [_vm._v("···")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.startNumAndEndNum.end), function(page, index) {
    return (page >= _vm.startNumAndEndNum.start) ? _c('button', {
      key: index,
      class: {
        active: _vm.pageNo == page
      },
      on: {
        "click": function($event) {
          return _vm.$emit('getPageNo', page)
        }
      }
    }, [_vm._v("\n    " + _vm._s(page) + "\n  ")]) : _vm._e()
  }), _vm._v(" "), (_vm.startNumAndEndNum.end < _vm.totalPage - 1) ? _c('button', [_vm._v("···")]) : _vm._e(), _vm._v(" "), (_vm.startNumAndEndNum.end < _vm.totalPage) ? _c('button', {
    class: {
      active: _vm.pageNo == _vm.totalPage
    },
    on: {
      "click": function($event) {
        return _vm.$emit('getPageNo', _vm.totalPage)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.totalPage) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.pageNo == _vm.totalPage
    },
    on: {
      "click": function($event) {
        return _vm.$emit('getPageNo', _vm.pageNo + 1)
      }
    }
  }, [_vm._v("\n    下一页\n  ")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("共 " + _vm._s(_vm.total) + " 条")])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": __webpack_require__(132),
      "alt": "newsbanner"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "mbx"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "nytit pull-left"
  }, [_vm._v("新闻中心")]), _vm._v(" "), _c('menu', {
    staticClass: "menu pull-left",
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    staticClass: "pull-left paddingleft15"
  }, [_c('a', {
    staticClass: "underline text66",
    class: {
      'cur': _vm.nav_status_1
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(0)
      }
    }
  }, [_vm._v("企业动态")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left paddingleft15"
  }, [_c('a', {
    staticClass: "underline text66",
    class: {
      'cur': _vm.nav_status_2
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(1)
      }
    }
  }, [_vm._v("代理品牌动态")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left paddingleft15"
  }, [_c('a', {
    staticClass: "underline text66",
    class: {
      'cur': _vm.nav_status_3
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(2)
      }
    }
  }, [_vm._v("行业资讯")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "mbxwrap"
  }, [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('em', [_vm._v("新闻中心")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "nycon"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "news"
  }, [_c('ul', _vm._l((_vm.news_list), function(list, index) {
    return _c('li', [_c('div', {
      staticClass: "pic pull-left"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.toNewsDetails(list)
        }
      }
    }, [_c('img', {
      staticClass: "vcenter",
      attrs: {
        "src": list.image,
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "ntxt pull-left"
    }, [_c('a', {
      staticClass: "underline",
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.toNewsDetails(list)
        }
      }
    }, [_vm._v(_vm._s(list.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(list.desc))])]), _vm._v(" "), _c('div', {
      staticClass: "date pull-right"
    }, [_c('span', [_vm._v(_vm._s(list.updateTime))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.toNewsDetails(list)
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area paddingbottom30"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [(_vm.total != 0) ? _c('Pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "page-no": _vm.pageNo,
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "continues": 5
    },
    on: {
      "getPageNo": _vm.getPageNo
    }
  }) : _vm._e()], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(273);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(133)("bc782374", content, true);

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(274);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(133)("07cd71e2", content, true);

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/probanner.6722fe9.jpg";

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(314)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(310),
  /* scopeId */
  "data-v-c4cf4fea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export assert */
/* unused harmony export autoResetRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return bypassFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return clamp; });
/* unused harmony export computedEager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return computedWithControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return containsProp; });
/* unused harmony export controlledComputed */
/* unused harmony export controlledRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return createEventHook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return createFilterWrapper; });
/* unused harmony export createGlobalState */
/* unused harmony export createInjectionState */
/* unused harmony export createReactiveFn */
/* unused harmony export createSharedComposable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return createSingletonPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return debounceFilter; });
/* unused harmony export debouncedRef */
/* unused harmony export debouncedWatch */
/* unused harmony export directiveHooks */
/* unused harmony export eagerComputed */
/* unused harmony export extendRef */
/* unused harmony export formatDate */
/* unused harmony export get */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return hasOwn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return identity; });
/* unused harmony export ignorableWatch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return increaseWithUnit; });
/* unused harmony export invoke */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return isDef; });
/* unused harmony export isDefined */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeDestructurable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return noop; });
/* unused harmony export normalizeDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return notNullish; });
/* unused harmony export now */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return objectEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return objectOmit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return objectPick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return pausableFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return watchPausable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return promiseTimeout; });
/* unused harmony export rand */
/* unused harmony export reactify */
/* unused harmony export reactifyObject */
/* unused harmony export reactiveComputed */
/* unused harmony export reactiveOmit */
/* unused harmony export reactivePick */
/* unused harmony export refAutoReset */
/* unused harmony export refDebounced */
/* unused harmony export refDefault */
/* unused harmony export refThrottled */
/* unused harmony export refWithControl */
/* unused harmony export resolveRef */
/* unused harmony export resolveUnref */
/* unused harmony export set */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return syncRef; });
/* unused harmony export syncRefs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return throttleFilter; });
/* unused harmony export throttledRef */
/* unused harmony export throttledWatch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return timestamp; });
/* unused harmony export toReactive */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return toRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return toRefs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toValue; });
/* unused harmony export tryOnBeforeMount */
/* unused harmony export tryOnBeforeUnmount */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return tryOnMounted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tryOnScopeDispose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return tryOnUnmounted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return until; });
/* unused harmony export useArrayDifference */
/* unused harmony export useArrayEvery */
/* unused harmony export useArrayFilter */
/* unused harmony export useArrayFind */
/* unused harmony export useArrayFindIndex */
/* unused harmony export useArrayFindLast */
/* unused harmony export useArrayIncludes */
/* unused harmony export useArrayJoin */
/* unused harmony export useArrayMap */
/* unused harmony export useArrayReduce */
/* unused harmony export useArraySome */
/* unused harmony export useArrayUnique */
/* unused harmony export useCounter */
/* unused harmony export useDateFormat */
/* unused harmony export useDebounce */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return useDebounceFn; });
/* unused harmony export useInterval */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return useIntervalFn; });
/* unused harmony export useLastChanged */
/* unused harmony export useThrottle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return useThrottleFn; });
/* unused harmony export useTimeout */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return useTimeoutFn; });
/* unused harmony export useToNumber */
/* unused harmony export useToString */
/* unused harmony export useToggle */
/* unused harmony export watchArray */
/* unused harmony export watchAtMost */
/* unused harmony export watchDebounced */
/* unused harmony export watchDeep */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return watchIgnorable; });
/* unused harmony export watchImmediate */
/* unused harmony export watchOnce */
/* unused harmony export watchPausable */
/* unused harmony export watchThrottled */
/* unused harmony export watchTriggerable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return watchWithFilter; });
/* unused harmony export whenever */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_reflect_has__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_reflect_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_reflect_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_reflect_delete_property__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_reflect_get__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_assign__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_entries__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_symbol__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_array_from__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_set__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_is_extensible__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_babel_runtime_core_js_object_get_own_property_descriptors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_babel_runtime_core_js_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_babel_runtime_core_js_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_core_js_object_define_properties__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_demi__ = __webpack_require__(143);




























var __defProp$b = __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property___default.a;
var __defProps$8 = __WEBPACK_IMPORTED_MODULE_24_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$8 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$d = __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = function __defNormalProp$b(obj, key, value) {
  return key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$b = function __spreadValues$b(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$d.call(b, prop)) __defNormalProp$b(a, prop, b[prop]);
  }if (__getOwnPropSymbols$d) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$d(b)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var prop = _step.value;

        if (__propIsEnum$d.call(b, prop)) __defNormalProp$b(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }return a;
};
var __spreadProps$8 = function __spreadProps$8(a, b) {
  return __defProps$8(a, __getOwnPropDescs$8(b));
};
function computedEager(fn, options) {
  var _a;
  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["a" /* shallowRef */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["b" /* watchEffect */])(function () {
    result.value = fn();
  }, __spreadProps$8(__spreadValues$b({}, options), {
    flush: (_a = options == null ? void 0 : options.flush) != null ? _a : "sync"
  }));
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["c" /* readonly */])(result);
}

function computedWithControl(source, fn) {
  var v = void 0;
  var track = void 0;
  var trigger = void 0;
  var dirty = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["d" /* ref */])(true);
  var update = function update() {
    dirty.value = true;
    trigger();
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(source, update, { flush: "sync" });
  var _get = typeof fn === "function" ? fn : fn.get;
  var _set = typeof fn === "function" ? void 0 : fn.set;
  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["f" /* customRef */])(function (_track, _trigger) {
    track = _track;
    trigger = _trigger;
    return {
      get: function get() {
        if (dirty.value) {
          v = _get();
          dirty.value = false;
        }
        track();
        return v;
      },
      set: function set(v2) {
        _set == null ? void 0 : _set(v2);
      }
    };
  });
  if (__WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_is_extensible___default()(result)) result.trigger = update;
  return result;
}

function tryOnScopeDispose(fn) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["g" /* getCurrentScope */])()) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["h" /* onScopeDispose */])(fn);
    return true;
  }
  return false;
}

function createEventHook() {
  var fns = new __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_set___default.a();
  var off = function off(fn) {
    fns.delete(fn);
  };
  var on = function on(fn) {
    fns.add(fn);
    var offFn = function offFn() {
      return off(fn);
    };
    tryOnScopeDispose(offFn);
    return {
      off: offFn
    };
  };
  var trigger = function trigger(param) {
    return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_promise___default.a.all(__WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_array_from___default()(fns).map(function (fn) {
      return fn(param);
    }));
  };
  return {
    on: on,
    off: off,
    trigger: trigger
  };
}

function createGlobalState(stateFactory) {
  var initialized = false;
  var state = void 0;
  var scope = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["i" /* effectScope */])(true);
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (!initialized) {
      state = scope.run(function () {
        return stateFactory.apply(undefined, args);
      });
      initialized = true;
    }
    return state;
  };
}

function createInjectionState(composable) {
  var key = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_symbol___default()("InjectionState");
  var useProvidingState = function useProvidingState() {
    var state = composable.apply(undefined, arguments);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["j" /* provide */])(key, state);
    return state;
  };
  var useInjectedState = function useInjectedState() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["k" /* inject */])(key);
  };
  return [useProvidingState, useInjectedState];
}

function createSharedComposable(composable) {
  var subscribers = 0;
  var state = void 0;
  var scope = void 0;
  var dispose = function dispose() {
    subscribers -= 1;
    if (scope && subscribers <= 0) {
      scope.stop();
      state = void 0;
      scope = void 0;
    }
  };
  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    subscribers += 1;
    if (!state) {
      scope = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["i" /* effectScope */])(true);
      state = scope.run(function () {
        return composable.apply(undefined, args);
      });
    }
    tryOnScopeDispose(dispose);
    return state;
  };
}

function extendRef(ref, extend) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$enumerable = _ref.enumerable,
      enumerable = _ref$enumerable === undefined ? false : _ref$enumerable,
      _ref$unwrap = _ref.unwrap,
      unwrap = _ref$unwrap === undefined ? true : _ref$unwrap;

  if (!__WEBPACK_IMPORTED_MODULE_26_vue_demi__["l" /* isVue3 */] && !__WEBPACK_IMPORTED_MODULE_26_vue_demi__["m" /* version */].startsWith("2.7.")) {
    if (false) throw new Error("[VueUse] extendRef only works in Vue 2.7 or above.");
    return;
  }

  var _loop = function _loop(key, value) {
    if (key === "value") return "continue";
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["n" /* isRef */])(value) && unwrap) {
      __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property___default()(ref, key, {
        get: function get() {
          return value.value;
        },
        set: function set(v) {
          value.value = v;
        },

        enumerable: enumerable
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property___default()(ref, key, { value: value, enumerable: enumerable });
    }
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_entries___default()(extend)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _ref2 = _step2.value;

      var _ref3 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);

      var key = _ref3[0];
      var value = _ref3[1];

      var _ret = _loop(key, value);

      if (_ret === "continue") continue;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return ref;
}

function get(obj, key) {
  if (key == null) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["o" /* unref */])(obj);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["o" /* unref */])(obj)[key];
}

function isDefined(v) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["o" /* unref */])(v) != null;
}

var __defProp$a = __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property___default.a;
var __getOwnPropSymbols$c = __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = function __defNormalProp$a(obj, key, value) {
  return key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$a = function __spreadValues$a(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$c.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
  }if (__getOwnPropSymbols$c) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$c(b)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var prop = _step3.value;

        if (__propIsEnum$c.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }return a;
};
function makeDestructurable(obj, arr) {
  if (typeof __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_symbol___default.a !== "undefined") {
    var clone = __spreadValues$a({}, obj);
    __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property___default()(clone, __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_symbol_iterator___default.a, {
      enumerable: false,
      value: function value() {
        var index = 0;
        return {
          next: function next() {
            return {
              value: arr[index++],
              done: index > arr.length
            };
          }
        };
      }
    });
    return clone;
  } else {
    return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_assign___default()([].concat(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray___default()(arr)), obj);
  }
}

function toValue(r) {
  return typeof r === "function" ? r() : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["o" /* unref */])(r);
}
var resolveUnref = toValue;

function reactify(fn, options) {
  var unrefFn = (options == null ? void 0 : options.computedGetter) === false ? __WEBPACK_IMPORTED_MODULE_26_vue_demi__["o" /* unref */] : toValue;
  return function () {
    var _this = this;

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
      return fn.apply(_this, args.map(function (i) {
        return unrefFn(i);
      }));
    });
  };
}

function reactifyObject(obj) {
  var optionsOrKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var keys = [];
  var options = void 0;
  if (Array.isArray(optionsOrKeys)) {
    keys = optionsOrKeys;
  } else {
    var _keys, _keys2;

    options = optionsOrKeys;
    var _optionsOrKeys$includ = optionsOrKeys.includeOwnProperties,
        includeOwnProperties = _optionsOrKeys$includ === undefined ? true : _optionsOrKeys$includ;

    (_keys = keys).push.apply(_keys, __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(obj)));
    if (includeOwnProperties) (_keys2 = keys).push.apply(_keys2, __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_own_property_names___default()(obj)));
  }
  return Object.fromEntries(keys.map(function (key) {
    var value = obj[key];
    return [key, typeof value === "function" ? reactify(value.bind(obj), options) : value];
  }));
}

function toReactive(objectRef) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["n" /* isRef */])(objectRef)) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["q" /* reactive */])(objectRef);
  var proxy = new Proxy({}, {
    get: function get(_, p, receiver) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["o" /* unref */])(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_reflect_get___default()(objectRef.value, p, receiver));
    },
    set: function set(_, p, value) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["n" /* isRef */])(objectRef.value[p]) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["n" /* isRef */])(value)) objectRef.value[p].value = value;else objectRef.value[p] = value;
      return true;
    },
    deleteProperty: function deleteProperty(_, p) {
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_reflect_delete_property___default()(objectRef.value, p);
    },
    has: function has(_, p) {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_reflect_has___default()(objectRef.value, p);
    },
    ownKeys: function ownKeys() {
      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(objectRef.value);
    },
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor() {
      return {
        enumerable: true,
        configurable: true
      };
    }
  });
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["q" /* reactive */])(proxy);
}

function reactiveComputed(fn) {
  return toReactive(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(fn));
}

function reactiveOmit(obj) {
  for (var _len4 = arguments.length, keys = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    keys[_key4 - 1] = arguments[_key4];
  }

  var flatKeys = keys.flat();
  var predicate = flatKeys[0];
  return reactiveComputed(function () {
    return typeof predicate === "function" ? Object.fromEntries(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_entries___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["r" /* toRefs */])(obj)).filter(function (_ref4) {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
          k = _ref5[0],
          v = _ref5[1];

      return !predicate(toValue(v), k);
    })) : Object.fromEntries(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_entries___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["r" /* toRefs */])(obj)).filter(function (e) {
      return !flatKeys.includes(e[0]);
    }));
  });
}

var isClient = typeof window !== "undefined";
var isDef = function isDef(val) {
  return typeof val !== "undefined";
};
var notNullish = function notNullish(val) {
  return val != null;
};
var assert = function assert(condition) {
  var _console;

  for (var _len5 = arguments.length, infos = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    infos[_key5 - 1] = arguments[_key5];
  }

  if (!condition) (_console = console).warn.apply(_console, infos);
};
var toString = Object.prototype.toString;
var isObject = function isObject(val) {
  return toString.call(val) === "[object Object]";
};
var now = function now() {
  return Date.now();
};
var timestamp = function timestamp() {
  return +Date.now();
};
var clamp = function clamp(n, min, max) {
  return Math.min(max, Math.max(min, n));
};
var noop = function noop() {};
var rand = function rand(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
var hasOwn = function hasOwn(val, key) {
  return Object.prototype.hasOwnProperty.call(val, key);
};
var isIOS = getIsIOS();
function getIsIOS() {
  var _a;
  return isClient && ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
}

function createFilterWrapper(filter, fn) {
  function wrapper() {
    var _this2 = this;

    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return new __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_promise___default.a.resolve(filter(function () {
        return fn.apply(_this2, args);
      }, { fn: fn, thisArg: _this2, args: args })).then(resolve).catch(reject);
    });
  }
  return wrapper;
}
var bypassFilter = function bypassFilter(invoke) {
  return invoke();
};
function debounceFilter(ms) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var timer = void 0;
  var maxTimer = void 0;
  var lastRejector = noop;
  var _clearTimeout = function _clearTimeout(timer2) {
    clearTimeout(timer2);
    lastRejector();
    lastRejector = noop;
  };
  var filter = function filter(invoke) {
    var duration = toValue(ms);
    var maxDuration = toValue(options.maxWait);
    if (timer) _clearTimeout(timer);
    if (duration <= 0 || maxDuration !== void 0 && maxDuration <= 0) {
      if (maxTimer) {
        _clearTimeout(maxTimer);
        maxTimer = null;
      }
      return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_promise___default.a.resolve(invoke());
    }
    return new __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      lastRejector = options.rejectOnCancel ? reject : resolve;
      if (maxDuration && !maxTimer) {
        maxTimer = setTimeout(function () {
          if (timer) _clearTimeout(timer);
          maxTimer = null;
          resolve(invoke());
        }, maxDuration);
      }
      timer = setTimeout(function () {
        if (maxTimer) _clearTimeout(maxTimer);
        maxTimer = null;
        resolve(invoke());
      }, duration);
    });
  };
  return filter;
}
function throttleFilter(ms) {
  var trailing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var leading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var rejectOnCancel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var lastExec = 0;
  var timer = void 0;
  var isLeading = true;
  var lastRejector = noop;
  var lastValue = void 0;
  var clear = function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = void 0;
      lastRejector();
      lastRejector = noop;
    }
  };
  var filter = function filter(_invoke) {
    var duration = toValue(ms);
    var elapsed = Date.now() - lastExec;
    var invoke = function invoke() {
      return lastValue = _invoke();
    };
    clear();
    if (duration <= 0) {
      lastExec = Date.now();
      return invoke();
    }
    if (elapsed > duration && (leading || !isLeading)) {
      lastExec = Date.now();
      invoke();
    } else if (trailing) {
      lastValue = new __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        lastRejector = rejectOnCancel ? reject : resolve;
        timer = setTimeout(function () {
          lastExec = Date.now();
          isLeading = true;
          resolve(invoke());
          clear();
        }, Math.max(0, duration - elapsed));
      });
    }
    if (!leading && !timer) timer = setTimeout(function () {
      return isLeading = true;
    }, duration);
    isLeading = false;
    return lastValue;
  };
  return filter;
}
function pausableFilter() {
  var extendFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bypassFilter;

  var isActive = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["d" /* ref */])(true);
  function pause() {
    isActive.value = false;
  }
  function resume() {
    isActive.value = true;
  }
  var eventFilter = function eventFilter() {
    if (isActive.value) extendFilter.apply(undefined, arguments);
  };
  return { isActive: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["c" /* readonly */])(isActive), pause: pause, resume: resume, eventFilter: eventFilter };
}

var directiveHooks = {
  mounted: __WEBPACK_IMPORTED_MODULE_26_vue_demi__["l" /* isVue3 */] ? "mounted" : "inserted",
  updated: __WEBPACK_IMPORTED_MODULE_26_vue_demi__["l" /* isVue3 */] ? "updated" : "componentUpdated",
  unmounted: __WEBPACK_IMPORTED_MODULE_26_vue_demi__["l" /* isVue3 */] ? "unmounted" : "unbind"
};

function promiseTimeout(ms) {
  var throwOnTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Timeout";

  return new __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (throwOnTimeout) setTimeout(function () {
      return reject(reason);
    }, ms);else setTimeout(resolve, ms);
  });
}
function identity(arg) {
  return arg;
}
function createSingletonPromise(fn) {
  var _this3 = this;

  var _promise = void 0;
  function wrapper() {
    if (!_promise) _promise = fn();
    return _promise;
  }
  wrapper.reset = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
    var _prev;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _prev = _promise;

            _promise = void 0;

            if (!_prev) {
              _context.next = 5;
              break;
            }

            _context.next = 5;
            return _prev;

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this3);
  }));
  return wrapper;
}
function invoke(fn) {
  return fn();
}
function containsProp(obj) {
  for (var _len7 = arguments.length, props = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    props[_key7 - 1] = arguments[_key7];
  }

  return props.some(function (k) {
    return k in obj;
  });
}
function increaseWithUnit(target, delta) {
  var _a;
  if (typeof target === "number") return target + delta;
  var value = ((_a = target.match(/^-?[0-9]+\.?[0-9]*/)) == null ? void 0 : _a[0]) || "";
  var unit = target.slice(value.length);
  var result = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(value) + delta;
  if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(result)) return target;
  return result + unit;
}
function objectPick(obj, keys) {
  var omitUndefined = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return keys.reduce(function (n, k) {
    if (k in obj) {
      if (!omitUndefined || obj[k] !== void 0) n[k] = obj[k];
    }
    return n;
  }, {});
}
function objectOmit(obj, keys) {
  var omitUndefined = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return Object.fromEntries(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_entries___default()(obj).filter(function (_ref7) {
    var _ref8 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
        key = _ref8[0],
        value = _ref8[1];

    return (!omitUndefined || value !== void 0) && !keys.includes(key);
  }));
}
function objectEntries(obj) {
  return __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_entries___default()(obj);
}

function toRef() {
  if (arguments.length !== 1) return __WEBPACK_IMPORTED_MODULE_26_vue_demi__["s" /* toRef */].apply(undefined, arguments);
  var r = arguments.length <= 0 ? undefined : arguments[0];
  return typeof r === "function" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["c" /* readonly */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["f" /* customRef */])(function () {
    return { get: r, set: noop };
  })) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["d" /* ref */])(r);
}
var resolveRef = toRef;

function reactivePick(obj) {
  for (var _len8 = arguments.length, keys = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
    keys[_key8 - 1] = arguments[_key8];
  }

  var flatKeys = keys.flat();
  var predicate = flatKeys[0];
  return reactiveComputed(function () {
    return typeof predicate === "function" ? Object.fromEntries(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_entries___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["r" /* toRefs */])(obj)).filter(function (_ref9) {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref9, 2),
          k = _ref10[0],
          v = _ref10[1];

      return predicate(toValue(v), k);
    })) : Object.fromEntries(flatKeys.map(function (k) {
      return [k, toRef(obj, k)];
    }));
  });
}

function refAutoReset(defaultValue) {
  var afterMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1e4;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["f" /* customRef */])(function (track, trigger) {
    var value = defaultValue;
    var timer = void 0;
    var resetAfter = function resetAfter() {
      return setTimeout(function () {
        value = defaultValue;
        trigger();
      }, toValue(afterMs));
    };
    tryOnScopeDispose(function () {
      clearTimeout(timer);
    });
    return {
      get: function get() {
        track();
        return value;
      },
      set: function set(newValue) {
        value = newValue;
        trigger();
        clearTimeout(timer);
        timer = resetAfter();
      }
    };
  });
}

function useDebounceFn(fn) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return createFilterWrapper(debounceFilter(ms, options), fn);
}

function refDebounced(value) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var debounced = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["d" /* ref */])(value.value);
  var updater = useDebounceFn(function () {
    debounced.value = value.value;
  }, ms, options);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(value, function () {
    return updater();
  });
  return debounced;
}

function refDefault(source, defaultValue) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])({
    get: function get() {
      var _a;
      return (_a = source.value) != null ? _a : defaultValue;
    },
    set: function set(value) {
      source.value = value;
    }
  });
}

function useThrottleFn(fn) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var trailing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var leading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var rejectOnCancel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  return createFilterWrapper(throttleFilter(ms, trailing, leading, rejectOnCancel), fn);
}

function refThrottled(value) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var trailing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var leading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (delay <= 0) return value;
  var throttled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["d" /* ref */])(value.value);
  var updater = useThrottleFn(function () {
    throttled.value = value.value;
  }, delay, trailing, leading);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(value, function () {
    return updater();
  });
  return throttled;
}

function refWithControl(initial) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var source = initial;
  var track = void 0;
  var trigger = void 0;
  var ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["f" /* customRef */])(function (_track, _trigger) {
    track = _track;
    trigger = _trigger;
    return {
      get: function get() {
        return _get2();
      },
      set: function set(v) {
        _set2(v);
      }
    };
  });
  function _get2() {
    var tracking = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (tracking) track();
    return source;
  }
  function _set2(value) {
    var triggering = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var _a, _b;
    if (value === source) return;
    var old = source;
    if (((_a = options.onBeforeChange) == null ? void 0 : _a.call(options, value, old)) === false) return;
    source = value;
    (_b = options.onChanged) == null ? void 0 : _b.call(options, value, old);
    if (triggering) trigger();
  }
  var untrackedGet = function untrackedGet() {
    return _get2(false);
  };
  var silentSet = function silentSet(v) {
    return _set2(v, false);
  };
  var peek = function peek() {
    return _get2(false);
  };
  var lay = function lay(v) {
    return _set2(v, false);
  };
  return extendRef(ref, {
    get: _get2,
    set: _set2,
    untrackedGet: untrackedGet,
    silentSet: silentSet,
    peek: peek,
    lay: lay
  }, { enumerable: true });
}
var controlledRef = refWithControl;

function set() {
  for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }

  if (args.length === 2) {
    var _ref11 = args[0],
        value = args[1];

    _ref11.value = value;
  }
  if (args.length === 3) {
    if (__WEBPACK_IMPORTED_MODULE_26_vue_demi__["t" /* isVue2 */]) {
      __WEBPACK_IMPORTED_MODULE_26_vue_demi__["u" /* set */].apply(undefined, args);
    } else {
      var target = args[0],
          key = args[1],
          _value2 = args[2];

      target[key] = _value2;
    }
  }
}

function syncRef(left, right) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _a, _b;
  var _options$flush = options.flush,
      flush = _options$flush === undefined ? "sync" : _options$flush,
      _options$deep = options.deep,
      deep = _options$deep === undefined ? false : _options$deep,
      _options$immediate = options.immediate,
      immediate = _options$immediate === undefined ? true : _options$immediate,
      _options$direction = options.direction,
      direction = _options$direction === undefined ? "both" : _options$direction,
      _options$transform = options.transform,
      transform = _options$transform === undefined ? {} : _options$transform;

  var watchLeft = void 0;
  var watchRight = void 0;
  var transformLTR = (_a = transform.ltr) != null ? _a : function (v) {
    return v;
  };
  var transformRTL = (_b = transform.rtl) != null ? _b : function (v) {
    return v;
  };
  if (direction === "both" || direction === "ltr") {
    watchLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(left, function (newValue) {
      return right.value = transformLTR(newValue);
    }, { flush: flush, deep: deep, immediate: immediate });
  }
  if (direction === "both" || direction === "rtl") {
    watchRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(right, function (newValue) {
      return left.value = transformRTL(newValue);
    }, { flush: flush, deep: deep, immediate: immediate });
  }
  return function () {
    watchLeft == null ? void 0 : watchLeft();
    watchRight == null ? void 0 : watchRight();
  };
}

function syncRefs(source, targets) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$flush2 = options.flush,
      flush = _options$flush2 === undefined ? "sync" : _options$flush2,
      _options$deep2 = options.deep,
      deep = _options$deep2 === undefined ? false : _options$deep2,
      _options$immediate2 = options.immediate,
      immediate = _options$immediate2 === undefined ? true : _options$immediate2;

  if (!Array.isArray(targets)) targets = [targets];
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(source, function (newValue) {
    return targets.forEach(function (target) {
      return target.value = newValue;
    });
  }, { flush: flush, deep: deep, immediate: immediate });
}

var __defProp$9 = __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property___default.a;
var __defProps$7 = __WEBPACK_IMPORTED_MODULE_24_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$7 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$b = __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = function __defNormalProp$9(obj, key, value) {
  return key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$9 = function __spreadValues$9(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$b.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
  }if (__getOwnPropSymbols$b) {
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$b(b)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var prop = _step4.value;

        if (__propIsEnum$b.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }
  }return a;
};
var __spreadProps$7 = function __spreadProps$7(a, b) {
  return __defProps$7(a, __getOwnPropDescs$7(b));
};
function toRefs(objectRef) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["n" /* isRef */])(objectRef)) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["r" /* toRefs */])(objectRef);
  var result = Array.isArray(objectRef.value) ? new Array(objectRef.value.length) : {};

  var _loop2 = function _loop2(key) {
    result[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["f" /* customRef */])(function () {
      return {
        get: function get() {
          return objectRef.value[key];
        },
        set: function set(v) {
          if (Array.isArray(objectRef.value)) {
            var copy = [].concat(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray___default()(objectRef.value));
            copy[key] = v;
            objectRef.value = copy;
          } else {
            var newObject = __spreadProps$7(__spreadValues$9({}, objectRef.value), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, key, v));
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(newObject, objectRef.value);
            objectRef.value = newObject;
          }
        }
      };
    });
  };

  for (var key in objectRef.value) {
    _loop2(key);
  }
  return result;
}

function tryOnBeforeMount(fn) {
  var sync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["v" /* getCurrentInstance */])()) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["w" /* onBeforeMount */])(fn);else if (sync) fn();else __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["x" /* nextTick */])(fn);
}

function tryOnBeforeUnmount(fn) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["v" /* getCurrentInstance */])()) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["y" /* onBeforeUnmount */])(fn);
}

function tryOnMounted(fn) {
  var sync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["v" /* getCurrentInstance */])()) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["z" /* onMounted */])(fn);else if (sync) fn();else __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["x" /* nextTick */])(fn);
}

function tryOnUnmounted(fn) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["v" /* getCurrentInstance */])()) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["A" /* onUnmounted */])(fn);
}

function createUntil(r) {
  var isNot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  function toMatch(condition) {
    var _ref12 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref12$flush = _ref12.flush,
        flush = _ref12$flush === undefined ? "sync" : _ref12$flush,
        _ref12$deep = _ref12.deep,
        deep = _ref12$deep === undefined ? false : _ref12$deep,
        timeout = _ref12.timeout,
        throwOnTimeout = _ref12.throwOnTimeout;

    var stop = null;
    var watcher = new __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_promise___default.a(function (resolve) {
      stop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(r, function (v) {
        if (condition(v) !== isNot) {
          stop == null ? void 0 : stop();
          resolve(v);
        }
      }, {
        flush: flush,
        deep: deep,
        immediate: true
      });
    });
    var promises = [watcher];
    if (timeout != null) {
      promises.push(promiseTimeout(timeout, throwOnTimeout).then(function () {
        return toValue(r);
      }).finally(function () {
        return stop == null ? void 0 : stop();
      }));
    }
    return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_promise___default.a.race(promises);
  }
  function toBe(value, options) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["n" /* isRef */])(value)) return toMatch(function (v) {
      return v === value;
    }, options);

    var _ref13 = options != null ? options : {},
        _ref13$flush = _ref13.flush,
        flush = _ref13$flush === undefined ? "sync" : _ref13$flush,
        _ref13$deep = _ref13.deep,
        deep = _ref13$deep === undefined ? false : _ref13$deep,
        timeout = _ref13.timeout,
        throwOnTimeout = _ref13.throwOnTimeout;

    var stop = null;
    var watcher = new __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_promise___default.a(function (resolve) {
      stop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])([r, value], function (_ref14) {
        var _ref15 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_slicedToArray___default()(_ref14, 2),
            v1 = _ref15[0],
            v2 = _ref15[1];

        if (isNot !== (v1 === v2)) {
          stop == null ? void 0 : stop();
          resolve(v1);
        }
      }, {
        flush: flush,
        deep: deep,
        immediate: true
      });
    });
    var promises = [watcher];
    if (timeout != null) {
      promises.push(promiseTimeout(timeout, throwOnTimeout).then(function () {
        return toValue(r);
      }).finally(function () {
        stop == null ? void 0 : stop();
        return toValue(r);
      }));
    }
    return __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_promise___default.a.race(promises);
  }
  function toBeTruthy(options) {
    return toMatch(function (v) {
      return Boolean(v);
    }, options);
  }
  function toBeNull(options) {
    return toBe(null, options);
  }
  function toBeUndefined(options) {
    return toBe(void 0, options);
  }
  function toBeNaN(options) {
    return toMatch(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default.a, options);
  }
  function toContains(value, options) {
    return toMatch(function (v) {
      var array = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_array_from___default()(v);
      return array.includes(value) || array.includes(toValue(value));
    }, options);
  }
  function changed(options) {
    return changedTimes(1, options);
  }
  function changedTimes() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var options = arguments[1];

    var count = -1;
    return toMatch(function () {
      count += 1;
      return count >= n;
    }, options);
  }
  if (Array.isArray(toValue(r))) {
    var instance = {
      toMatch: toMatch,
      toContains: toContains,
      changed: changed,
      changedTimes: changedTimes,
      get not() {
        return createUntil(r, !isNot);
      }
    };
    return instance;
  } else {
    var _instance = {
      toMatch: toMatch,
      toBe: toBe,
      toBeTruthy: toBeTruthy,
      toBeNull: toBeNull,
      toBeNaN: toBeNaN,
      toBeUndefined: toBeUndefined,
      changed: changed,
      changedTimes: changedTimes,
      get not() {
        return createUntil(r, !isNot);
      }
    };
    return _instance;
  }
}
function until(r) {
  return createUntil(r);
}

function defaultComparator(value, othVal) {
  return value === othVal;
}
function useArrayDifference() {
  var _a;
  var list = arguments.length <= 0 ? undefined : arguments[0];
  var values = arguments.length <= 1 ? undefined : arguments[1];
  var compareFn = (_a = arguments.length <= 2 ? undefined : arguments[2]) != null ? _a : defaultComparator;
  if (typeof compareFn === "string") {
    var key = compareFn;
    compareFn = function compareFn(value, othVal) {
      return value[key] === othVal[key];
    };
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
    return toValue(list).filter(function (x) {
      return toValue(values).findIndex(function (y) {
        return compareFn(x, y);
      }) === -1;
    });
  });
}

function useArrayEvery(list, fn) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
    return toValue(list).every(function (element, index, array) {
      return fn(toValue(element), index, array);
    });
  });
}

function useArrayFilter(list, fn) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
    return toValue(list).map(function (i) {
      return toValue(i);
    }).filter(fn);
  });
}

function useArrayFind(list, fn) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
    return toValue(toValue(list).find(function (element, index, array) {
      return fn(toValue(element), index, array);
    }));
  });
}

function useArrayFindIndex(list, fn) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
    return toValue(list).findIndex(function (element, index, array) {
      return fn(toValue(element), index, array);
    });
  });
}

function findLast(arr, cb) {
  var index = arr.length;
  while (index-- > 0) {
    if (cb(arr[index], index, arr)) return arr[index];
  }
  return void 0;
}
function useArrayFindLast(list, fn) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
    return toValue(!Array.prototype.findLast ? findLast(toValue(list), function (element, index, array) {
      return fn(toValue(element), index, array);
    }) : toValue(list).findLast(function (element, index, array) {
      return fn(toValue(element), index, array);
    }));
  });
}

function isArrayIncludesOptions(obj) {
  return isObject(obj) && containsProp(obj, "formIndex", "comparator");
}
function useArrayIncludes() {
  var _a;
  var list = arguments.length <= 0 ? undefined : arguments[0];
  var value = arguments.length <= 1 ? undefined : arguments[1];
  var comparator = arguments.length <= 2 ? undefined : arguments[2];
  var formIndex = 0;
  if (isArrayIncludesOptions(comparator)) {
    formIndex = (_a = comparator.fromIndex) != null ? _a : 0;
    comparator = comparator.comparator;
  }
  if (typeof comparator === "string") {
    var key = comparator;
    comparator = function comparator(element, value2) {
      return element[key] === toValue(value2);
    };
  }
  comparator = comparator != null ? comparator : function (element, value2) {
    return element === toValue(value2);
  };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
    return toValue(list).slice(formIndex).some(function (element, index, array) {
      return comparator(toValue(element), toValue(value), index, toValue(array));
    });
  });
}

function useArrayJoin(list, separator) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
    return toValue(list).map(function (i) {
      return toValue(i);
    }).join(toValue(separator));
  });
}

function useArrayMap(list, fn) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
    return toValue(list).map(function (i) {
      return toValue(i);
    }).map(fn);
  });
}

function useArrayReduce(list, reducer) {
  for (var _len10 = arguments.length, args = Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
    args[_key10 - 2] = arguments[_key10];
  }

  var reduceCallback = function reduceCallback(sum, value, index) {
    return reducer(toValue(sum), toValue(value), index);
  };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
    var resolved = toValue(list);
    return args.length ? resolved.reduce(reduceCallback, toValue(args[0])) : resolved.reduce(reduceCallback);
  });
}

function useArraySome(list, fn) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
    return toValue(list).some(function (element, index, array) {
      return fn(toValue(element), index, array);
    });
  });
}

function uniq(array) {
  return __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_set___default.a(array));
}
function uniqueElementsBy(array, fn) {
  return array.reduce(function (acc, v) {
    if (!acc.some(function (x) {
      return fn(v, x, array);
    })) acc.push(v);
    return acc;
  }, []);
}
function useArrayUnique(list, compareFn) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
    var resolvedList = toValue(list).map(function (element) {
      return toValue(element);
    });
    return compareFn ? uniqueElementsBy(resolvedList, compareFn) : uniq(resolvedList);
  });
}

function useCounter() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var count = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["d" /* ref */])(initialValue);
  var _options$max = options.max,
      max = _options$max === undefined ? Infinity : _options$max,
      _options$min = options.min,
      min = _options$min === undefined ? -Infinity : _options$min;

  var inc = function inc() {
    var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return count.value = Math.min(max, count.value + delta);
  };
  var dec = function dec() {
    var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return count.value = Math.max(min, count.value - delta);
  };
  var get = function get() {
    return count.value;
  };
  var set = function set(val) {
    return count.value = Math.max(min, Math.min(max, val));
  };
  var reset = function reset() {
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialValue;

    initialValue = val;
    return set(val);
  };
  return { count: count, inc: inc, dec: dec, get: get, set: set, reset: reset };
}

var REGEX_PARSE = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/;
var REGEX_FORMAT = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a{1,2}|A{1,2}|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
function defaultMeridiem(hours, minutes, isLowercase, hasPeriod) {
  var m = hours < 12 ? "AM" : "PM";
  if (hasPeriod) m = m.split("").reduce(function (acc, curr) {
    return acc += curr + ".";
  }, "");
  return isLowercase ? m.toLowerCase() : m;
}
function formatDate(date, formatStr) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _a;
  var years = date.getFullYear();
  var month = date.getMonth();
  var days = date.getDate();
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  var milliseconds = date.getMilliseconds();
  var day = date.getDay();
  var meridiem = (_a = options.customMeridiem) != null ? _a : defaultMeridiem;
  var matches = {
    YY: function YY() {
      return String(years).slice(-2);
    },
    YYYY: function YYYY() {
      return years;
    },
    M: function M() {
      return month + 1;
    },
    MM: function MM() {
      return ("" + (month + 1)).padStart(2, "0");
    },
    MMM: function MMM() {
      return date.toLocaleDateString(options.locales, { month: "short" });
    },
    MMMM: function MMMM() {
      return date.toLocaleDateString(options.locales, { month: "long" });
    },
    D: function D() {
      return String(days);
    },
    DD: function DD() {
      return ("" + days).padStart(2, "0");
    },
    H: function H() {
      return String(hours);
    },
    HH: function HH() {
      return ("" + hours).padStart(2, "0");
    },
    h: function h() {
      return ("" + (hours % 12 || 12)).padStart(1, "0");
    },
    hh: function hh() {
      return ("" + (hours % 12 || 12)).padStart(2, "0");
    },
    m: function m() {
      return String(minutes);
    },
    mm: function mm() {
      return ("" + minutes).padStart(2, "0");
    },
    s: function s() {
      return String(seconds);
    },
    ss: function ss() {
      return ("" + seconds).padStart(2, "0");
    },
    SSS: function SSS() {
      return ("" + milliseconds).padStart(3, "0");
    },
    d: function d() {
      return day;
    },
    dd: function dd() {
      return date.toLocaleDateString(options.locales, { weekday: "narrow" });
    },
    ddd: function ddd() {
      return date.toLocaleDateString(options.locales, { weekday: "short" });
    },
    dddd: function dddd() {
      return date.toLocaleDateString(options.locales, { weekday: "long" });
    },
    A: function A() {
      return meridiem(hours, minutes);
    },
    AA: function AA() {
      return meridiem(hours, minutes, false, true);
    },
    a: function a() {
      return meridiem(hours, minutes, true);
    },
    aa: function aa() {
      return meridiem(hours, minutes, true, true);
    }
  };
  return formatStr.replace(REGEX_FORMAT, function (match, $1) {
    var _a2;
    return $1 || ((_a2 = matches[match]) == null ? void 0 : _a2.call(matches)) || match;
  });
}
function normalizeDate(date) {
  if (date === null) return new Date(NaN);
  if (date === void 0) return new Date();
  if (date instanceof Date) return new Date(date);
  if (typeof date === "string" && !/Z$/i.test(date)) {
    var d = date.match(REGEX_PARSE);
    if (d) {
      var m = d[2] - 1 || 0;
      var ms = (d[7] || "0").substring(0, 3);
      return new Date(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms);
    }
  }
  return new Date(date);
}
function useDateFormat(date) {
  var formatStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "HH:mm:ss";
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
    return formatDate(normalizeDate(toValue(date)), toValue(formatStr), options);
  });
}

function useIntervalFn(cb) {
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1e3;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$immediate3 = options.immediate,
      immediate = _options$immediate3 === undefined ? true : _options$immediate3,
      _options$immediateCal = options.immediateCallback,
      immediateCallback = _options$immediateCal === undefined ? false : _options$immediateCal;

  var timer = null;
  var isActive = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["d" /* ref */])(false);
  function clean() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }
  function pause() {
    isActive.value = false;
    clean();
  }
  function resume() {
    var intervalValue = toValue(interval);
    if (intervalValue <= 0) return;
    isActive.value = true;
    if (immediateCallback) cb();
    clean();
    timer = setInterval(cb, intervalValue);
  }
  if (immediate && isClient) resume();
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["n" /* isRef */])(interval) || typeof interval === "function") {
    var stopWatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(interval, function () {
      if (isActive.value && isClient) resume();
    });
    tryOnScopeDispose(stopWatch);
  }
  tryOnScopeDispose(pause);
  return {
    isActive: isActive,
    pause: pause,
    resume: resume
  };
}

var __defProp$8 = __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property___default.a;
var __getOwnPropSymbols$a = __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = function __defNormalProp$8(obj, key, value) {
  return key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$8 = function __spreadValues$8(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$a.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
  }if (__getOwnPropSymbols$a) {
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$a(b)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var prop = _step5.value;

        if (__propIsEnum$a.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }
  }return a;
};
function useInterval() {
  var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1e3;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$controls = options.controls,
      exposeControls = _options$controls === undefined ? false : _options$controls,
      _options$immediate4 = options.immediate,
      immediate = _options$immediate4 === undefined ? true : _options$immediate4,
      callback = options.callback;

  var counter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["d" /* ref */])(0);
  var update = function update() {
    return counter.value += 1;
  };
  var reset = function reset() {
    counter.value = 0;
  };
  var controls = useIntervalFn(callback ? function () {
    update();
    callback(counter.value);
  } : update, interval, { immediate: immediate });
  if (exposeControls) {
    return __spreadValues$8({
      counter: counter,
      reset: reset
    }, controls);
  } else {
    return counter;
  }
}

function useLastChanged(source) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _a;
  var ms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["d" /* ref */])((_a = options.initialValue) != null ? _a : null);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(source, function () {
    return ms.value = timestamp();
  }, options);
  return ms;
}

function useTimeoutFn(cb, interval) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$immediate5 = options.immediate,
      immediate = _options$immediate5 === undefined ? true : _options$immediate5;

  var isPending = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["d" /* ref */])(false);
  var timer = null;
  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }
  function stop() {
    isPending.value = false;
    clear();
  }
  function start() {
    for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      args[_key11] = arguments[_key11];
    }

    clear();
    isPending.value = true;
    timer = setTimeout(function () {
      isPending.value = false;
      timer = null;
      cb.apply(undefined, args);
    }, toValue(interval));
  }
  if (immediate) {
    isPending.value = true;
    if (isClient) start();
  }
  tryOnScopeDispose(stop);
  return {
    isPending: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["c" /* readonly */])(isPending),
    start: start,
    stop: stop
  };
}

var __defProp$7 = __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property___default.a;
var __getOwnPropSymbols$9 = __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = function __defNormalProp$7(obj, key, value) {
  return key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$7 = function __spreadValues$7(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$9.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
  }if (__getOwnPropSymbols$9) {
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$9(b)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var prop = _step6.value;

        if (__propIsEnum$9.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }
  }return a;
};
function useTimeout() {
  var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1e3;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$controls2 = options.controls,
      exposeControls = _options$controls2 === undefined ? false : _options$controls2,
      callback = options.callback;

  var controls = useTimeoutFn(callback != null ? callback : noop, interval, options);
  var ready = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
    return !controls.isPending.value;
  });
  if (exposeControls) {
    return __spreadValues$7({
      ready: ready
    }, controls);
  } else {
    return ready;
  }
}

function useToNumber(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$method = options.method,
      method = _options$method === undefined ? "parseFloat" : _options$method,
      radix = options.radix,
      nanToZero = options.nanToZero;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
    var resolved = toValue(value);
    if (typeof resolved === "string") resolved = Number[method](resolved, radix);
    if (nanToZero && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(resolved)) resolved = 0;
    return resolved;
  });
}

function useToString(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["p" /* computed */])(function () {
    return "" + toValue(value);
  });
}

function useToggle() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$truthyValue = options.truthyValue,
      truthyValue = _options$truthyValue === undefined ? true : _options$truthyValue,
      _options$falsyValue = options.falsyValue,
      falsyValue = _options$falsyValue === undefined ? false : _options$falsyValue;

  var valueIsRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["n" /* isRef */])(initialValue);
  var _value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["d" /* ref */])(initialValue);
  function toggle(value) {
    if (arguments.length) {
      _value.value = value;
      return _value.value;
    } else {
      var truthy = toValue(truthyValue);
      _value.value = _value.value === truthy ? toValue(falsyValue) : truthy;
      return _value.value;
    }
  }
  if (valueIsRef) return toggle;else return [_value, toggle];
}

function watchArray(source, cb, options) {
  var oldList = (options == null ? void 0 : options.immediate) ? [] : [].concat(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray___default()(source instanceof Function ? source() : Array.isArray(source) ? source : toValue(source)));
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(source, function (newList, _, onCleanup) {
    var oldListRemains = new Array(oldList.length);
    var added = [];
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(newList), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var obj = _step7.value;

        var found = false;
        for (var i = 0; i < oldList.length; i++) {
          if (!oldListRemains[i] && obj === oldList[i]) {
            oldListRemains[i] = true;
            found = true;
            break;
          }
        }
        if (!found) added.push(obj);
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }

    var removed = oldList.filter(function (_2, i) {
      return !oldListRemains[i];
    });
    cb(newList, oldList, added, removed, onCleanup);
    oldList = [].concat(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray___default()(newList));
  }, options);
}

var __getOwnPropSymbols$8 = __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __objRest$5 = function __objRest$5(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp$8.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }if (source != null && __getOwnPropSymbols$8) {
    var _iteratorNormalCompletion8 = true;
    var _didIteratorError8 = false;
    var _iteratorError8 = undefined;

    try {
      for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$8(source)), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
        var prop = _step8.value;

        if (exclude.indexOf(prop) < 0 && __propIsEnum$8.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _didIteratorError8 = true;
      _iteratorError8 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion8 && _iterator8.return) {
          _iterator8.return();
        }
      } finally {
        if (_didIteratorError8) {
          throw _iteratorError8;
        }
      }
    }
  }return target;
};
function watchWithFilter(source, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a = options,
      _a$eventFilter = _a.eventFilter,
      eventFilter = _a$eventFilter === undefined ? bypassFilter : _a$eventFilter,
      watchOptions = __objRest$5(_a, ["eventFilter"]);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(source, createFilterWrapper(eventFilter, cb), watchOptions);
}

var __getOwnPropSymbols$7 = __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __objRest$4 = function __objRest$4(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp$7.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }if (source != null && __getOwnPropSymbols$7) {
    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$7(source)), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        var prop = _step9.value;

        if (exclude.indexOf(prop) < 0 && __propIsEnum$7.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9.return) {
          _iterator9.return();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }
  }return target;
};
function watchAtMost(source, cb, options) {
  var _a = options,
      count = _a.count,
      watchOptions = __objRest$4(_a, ["count"]);
  var current = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["d" /* ref */])(0);
  var stop = watchWithFilter(source, function () {
    current.value += 1;
    if (current.value >= toValue(count)) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["x" /* nextTick */])(function () {
      return stop();
    });
    cb.apply(undefined, arguments);
  }, watchOptions);
  return { count: current, stop: stop };
}

var __defProp$6 = __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property___default.a;
var __defProps$6 = __WEBPACK_IMPORTED_MODULE_24_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$6 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$6 = __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = function __defNormalProp$6(obj, key, value) {
  return key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$6 = function __spreadValues$6(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
  }if (__getOwnPropSymbols$6) {
    var _iteratorNormalCompletion10 = true;
    var _didIteratorError10 = false;
    var _iteratorError10 = undefined;

    try {
      for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$6(b)), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
        var prop = _step10.value;

        if (__propIsEnum$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError10 = true;
      _iteratorError10 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion10 && _iterator10.return) {
          _iterator10.return();
        }
      } finally {
        if (_didIteratorError10) {
          throw _iteratorError10;
        }
      }
    }
  }return a;
};
var __spreadProps$6 = function __spreadProps$6(a, b) {
  return __defProps$6(a, __getOwnPropDescs$6(b));
};
var __objRest$3 = function __objRest$3(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp$6.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }if (source != null && __getOwnPropSymbols$6) {
    var _iteratorNormalCompletion11 = true;
    var _didIteratorError11 = false;
    var _iteratorError11 = undefined;

    try {
      for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$6(source)), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
        var prop = _step11.value;

        if (exclude.indexOf(prop) < 0 && __propIsEnum$6.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _didIteratorError11 = true;
      _iteratorError11 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion11 && _iterator11.return) {
          _iterator11.return();
        }
      } finally {
        if (_didIteratorError11) {
          throw _iteratorError11;
        }
      }
    }
  }return target;
};
function watchDebounced(source, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a = options,
      _a$debounce = _a.debounce,
      debounce = _a$debounce === undefined ? 0 : _a$debounce,
      _a$maxWait = _a.maxWait,
      maxWait = _a$maxWait === undefined ? void 0 : _a$maxWait,
      watchOptions = __objRest$3(_a, ["debounce", "maxWait"]);
  return watchWithFilter(source, cb, __spreadProps$6(__spreadValues$6({}, watchOptions), {
    eventFilter: debounceFilter(debounce, { maxWait: maxWait })
  }));
}

var __defProp$5 = __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property___default.a;
var __defProps$5 = __WEBPACK_IMPORTED_MODULE_24_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$5 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$5 = __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = function __defNormalProp$5(obj, key, value) {
  return key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$5 = function __spreadValues$5(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
  }if (__getOwnPropSymbols$5) {
    var _iteratorNormalCompletion12 = true;
    var _didIteratorError12 = false;
    var _iteratorError12 = undefined;

    try {
      for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$5(b)), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
        var prop = _step12.value;

        if (__propIsEnum$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError12 = true;
      _iteratorError12 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion12 && _iterator12.return) {
          _iterator12.return();
        }
      } finally {
        if (_didIteratorError12) {
          throw _iteratorError12;
        }
      }
    }
  }return a;
};
var __spreadProps$5 = function __spreadProps$5(a, b) {
  return __defProps$5(a, __getOwnPropDescs$5(b));
};
function watchDeep(source, cb, options) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(source, cb, __spreadProps$5(__spreadValues$5({}, options), {
    deep: true
  }));
}

var __defProp$4 = __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property___default.a;
var __defProps$4 = __WEBPACK_IMPORTED_MODULE_24_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$4 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$4 = __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = function __defNormalProp$4(obj, key, value) {
  return key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$4 = function __spreadValues$4(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
  }if (__getOwnPropSymbols$4) {
    var _iteratorNormalCompletion13 = true;
    var _didIteratorError13 = false;
    var _iteratorError13 = undefined;

    try {
      for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$4(b)), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
        var prop = _step13.value;

        if (__propIsEnum$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError13 = true;
      _iteratorError13 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion13 && _iterator13.return) {
          _iterator13.return();
        }
      } finally {
        if (_didIteratorError13) {
          throw _iteratorError13;
        }
      }
    }
  }return a;
};
var __spreadProps$4 = function __spreadProps$4(a, b) {
  return __defProps$4(a, __getOwnPropDescs$4(b));
};
var __objRest$2 = function __objRest$2(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp$4.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }if (source != null && __getOwnPropSymbols$4) {
    var _iteratorNormalCompletion14 = true;
    var _didIteratorError14 = false;
    var _iteratorError14 = undefined;

    try {
      for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$4(source)), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
        var prop = _step14.value;

        if (exclude.indexOf(prop) < 0 && __propIsEnum$4.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _didIteratorError14 = true;
      _iteratorError14 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion14 && _iterator14.return) {
          _iterator14.return();
        }
      } finally {
        if (_didIteratorError14) {
          throw _iteratorError14;
        }
      }
    }
  }return target;
};
function watchIgnorable(source, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a = options,
      _a$eventFilter2 = _a.eventFilter,
      eventFilter = _a$eventFilter2 === undefined ? bypassFilter : _a$eventFilter2,
      watchOptions = __objRest$2(_a, ["eventFilter"]);
  var filteredCb = createFilterWrapper(eventFilter, cb);
  var ignoreUpdates = void 0;
  var ignorePrevAsyncUpdates = void 0;
  var stop = void 0;
  if (watchOptions.flush === "sync") {
    var ignore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["d" /* ref */])(false);
    ignorePrevAsyncUpdates = function ignorePrevAsyncUpdates() {};
    ignoreUpdates = function ignoreUpdates(updater) {
      ignore.value = true;
      updater();
      ignore.value = false;
    };
    stop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(source, function () {
      if (!ignore.value) filteredCb.apply(undefined, arguments);
    }, watchOptions);
  } else {
    var disposables = [];
    var ignoreCounter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["d" /* ref */])(0);
    var syncCounter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["d" /* ref */])(0);
    ignorePrevAsyncUpdates = function ignorePrevAsyncUpdates() {
      ignoreCounter.value = syncCounter.value;
    };
    disposables.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(source, function () {
      syncCounter.value++;
    }, __spreadProps$4(__spreadValues$4({}, watchOptions), { flush: "sync" })));
    ignoreUpdates = function ignoreUpdates(updater) {
      var syncCounterPrev = syncCounter.value;
      updater();
      ignoreCounter.value += syncCounter.value - syncCounterPrev;
    };
    disposables.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(source, function () {
      var ignore = ignoreCounter.value > 0 && ignoreCounter.value === syncCounter.value;
      ignoreCounter.value = 0;
      syncCounter.value = 0;
      if (ignore) return;
      filteredCb.apply(undefined, arguments);
    }, watchOptions));
    stop = function stop() {
      disposables.forEach(function (fn) {
        return fn();
      });
    };
  }
  return { stop: stop, ignoreUpdates: ignoreUpdates, ignorePrevAsyncUpdates: ignorePrevAsyncUpdates };
}

var __defProp$3 = __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property___default.a;
var __defProps$3 = __WEBPACK_IMPORTED_MODULE_24_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$3 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$3 = __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = function __defNormalProp$3(obj, key, value) {
  return key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$3 = function __spreadValues$3(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
  }if (__getOwnPropSymbols$3) {
    var _iteratorNormalCompletion15 = true;
    var _didIteratorError15 = false;
    var _iteratorError15 = undefined;

    try {
      for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$3(b)), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
        var prop = _step15.value;

        if (__propIsEnum$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError15 = true;
      _iteratorError15 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion15 && _iterator15.return) {
          _iterator15.return();
        }
      } finally {
        if (_didIteratorError15) {
          throw _iteratorError15;
        }
      }
    }
  }return a;
};
var __spreadProps$3 = function __spreadProps$3(a, b) {
  return __defProps$3(a, __getOwnPropDescs$3(b));
};
function watchImmediate(source, cb, options) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(source, cb, __spreadProps$3(__spreadValues$3({}, options), {
    immediate: true
  }));
}

function watchOnce(source, cb, options) {
  var stop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(source, function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["x" /* nextTick */])(function () {
      return stop();
    });
    return cb.apply(undefined, arguments);
  }, options);
}

var __defProp$2 = __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property___default.a;
var __defProps$2 = __WEBPACK_IMPORTED_MODULE_24_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$2 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$2 = __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = function __defNormalProp$2(obj, key, value) {
  return key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$2 = function __spreadValues$2(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  }if (__getOwnPropSymbols$2) {
    var _iteratorNormalCompletion16 = true;
    var _didIteratorError16 = false;
    var _iteratorError16 = undefined;

    try {
      for (var _iterator16 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$2(b)), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
        var prop = _step16.value;

        if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError16 = true;
      _iteratorError16 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion16 && _iterator16.return) {
          _iterator16.return();
        }
      } finally {
        if (_didIteratorError16) {
          throw _iteratorError16;
        }
      }
    }
  }return a;
};
var __spreadProps$2 = function __spreadProps$2(a, b) {
  return __defProps$2(a, __getOwnPropDescs$2(b));
};
var __objRest$1 = function __objRest$1(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }if (source != null && __getOwnPropSymbols$2) {
    var _iteratorNormalCompletion17 = true;
    var _didIteratorError17 = false;
    var _iteratorError17 = undefined;

    try {
      for (var _iterator17 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$2(source)), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
        var prop = _step17.value;

        if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _didIteratorError17 = true;
      _iteratorError17 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion17 && _iterator17.return) {
          _iterator17.return();
        }
      } finally {
        if (_didIteratorError17) {
          throw _iteratorError17;
        }
      }
    }
  }return target;
};
function watchPausable(source, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a = options,
      filter = _a.eventFilter,
      watchOptions = __objRest$1(_a, ["eventFilter"]);
  var _pausableFilter = pausableFilter(filter),
      eventFilter = _pausableFilter.eventFilter,
      pause = _pausableFilter.pause,
      resume = _pausableFilter.resume,
      isActive = _pausableFilter.isActive;

  var stop = watchWithFilter(source, cb, __spreadProps$2(__spreadValues$2({}, watchOptions), {
    eventFilter: eventFilter
  }));
  return { stop: stop, pause: pause, resume: resume, isActive: isActive };
}

var __defProp$1 = __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property___default.a;
var __defProps$1 = __WEBPACK_IMPORTED_MODULE_24_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs$1 = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols$1 = __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp$1(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues$1(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  }if (__getOwnPropSymbols$1) {
    var _iteratorNormalCompletion18 = true;
    var _didIteratorError18 = false;
    var _iteratorError18 = undefined;

    try {
      for (var _iterator18 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$1(b)), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
        var prop = _step18.value;

        if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError18 = true;
      _iteratorError18 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion18 && _iterator18.return) {
          _iterator18.return();
        }
      } finally {
        if (_didIteratorError18) {
          throw _iteratorError18;
        }
      }
    }
  }return a;
};
var __spreadProps$1 = function __spreadProps$1(a, b) {
  return __defProps$1(a, __getOwnPropDescs$1(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }if (source != null && __getOwnPropSymbols$1) {
    var _iteratorNormalCompletion19 = true;
    var _didIteratorError19 = false;
    var _iteratorError19 = undefined;

    try {
      for (var _iterator19 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols$1(source)), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
        var prop = _step19.value;

        if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _didIteratorError19 = true;
      _iteratorError19 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion19 && _iterator19.return) {
          _iterator19.return();
        }
      } finally {
        if (_didIteratorError19) {
          throw _iteratorError19;
        }
      }
    }
  }return target;
};
function watchThrottled(source, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a = options,
      _a$throttle = _a.throttle,
      throttle = _a$throttle === undefined ? 0 : _a$throttle,
      _a$trailing = _a.trailing,
      trailing = _a$trailing === undefined ? true : _a$trailing,
      _a$leading = _a.leading,
      leading = _a$leading === undefined ? true : _a$leading,
      watchOptions = __objRest(_a, ["throttle", "trailing", "leading"]);
  return watchWithFilter(source, cb, __spreadProps$1(__spreadValues$1({}, watchOptions), {
    eventFilter: throttleFilter(throttle, trailing, leading)
  }));
}

var __defProp = __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_object_define_property___default.a;
var __defProps = __WEBPACK_IMPORTED_MODULE_24_babel_runtime_core_js_object_define_properties___default.a;
var __getOwnPropDescs = __WEBPACK_IMPORTED_MODULE_23_babel_runtime_core_js_object_get_own_property_descriptors___default.a;
var __getOwnPropSymbols = __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_own_property_symbols___default.a;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }if (__getOwnPropSymbols) {
    var _iteratorNormalCompletion20 = true;
    var _didIteratorError20 = false;
    var _iteratorError20 = undefined;

    try {
      for (var _iterator20 = __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_get_iterator___default()(__getOwnPropSymbols(b)), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
        var prop = _step20.value;

        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError20 = true;
      _iteratorError20 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion20 && _iterator20.return) {
          _iterator20.return();
        }
      } finally {
        if (_didIteratorError20) {
          throw _iteratorError20;
        }
      }
    }
  }return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
function watchTriggerable(source, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var cleanupFn = void 0;
  function onEffect() {
    if (!cleanupFn) return;
    var fn = cleanupFn;
    cleanupFn = void 0;
    fn();
  }
  function onCleanup(callback) {
    cleanupFn = callback;
  }
  var _cb = function _cb(value, oldValue) {
    onEffect();
    return cb(value, oldValue, onCleanup);
  };
  var res = watchIgnorable(source, _cb, options);
  var ignoreUpdates = res.ignoreUpdates;

  var trigger = function trigger() {
    var res2 = void 0;
    ignoreUpdates(function () {
      res2 = _cb(getWatchSources(source), getOldValue(source));
    });
    return res2;
  };
  return __spreadProps(__spreadValues({}, res), {
    trigger: trigger
  });
}
function getWatchSources(sources) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["B" /* isReactive */])(sources)) return sources;
  if (Array.isArray(sources)) return sources.map(function (item) {
    return toValue(item);
  });
  return toValue(sources);
}
function getOldValue(source) {
  return Array.isArray(source) ? source.map(function () {
    return void 0;
  }) : void 0;
}

function whenever(source, cb, options) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_vue_demi__["e" /* watch */])(source, function (v, ov, onInvalidate) {
    if (v) cb(v, ov, onInvalidate);
  }, options);
}



/***/ })

},[181]);


// WEBPACK FOOTER //
// static/js/app.84f4716cc1034b06f98c.js